export const VALIDGUESSES = [
  'Adolf',
  'Agdan',
  'Agdum',
  'Agdur',
  'Agnar',
  'Agnas',
  'Akrar',
  'Akrum',
  'Aksal',
  'Aksel',
  'Albin',
  'Aldis',
  'Aleks',
  'Alisa',
  'Alisu',
  'Allan',
  'Alman',
  'Almum',
  'Almur',
  'Alrún',
  'Amosa',
  'Amosi',
  'Andra',
  'Andri',
  'Anita',
  'Anitu',
  'Anjan',
  'Anjum',
  'Anjur',
  'Annan',
  'Annar',
  'Annin',
  'Annum',
  'Annur',
  'Anton',
  'Arans',
  'Aresa',
  'Argir',
  'Argja',
  'Arian',
  'Arina',
  'Arinu',
  'Arium',
  'Ariur',
  'Arnan',
  'Arnar',
  'Arnin',
  'Arnum',
  'Arnur',
  'Arnór',
  'Arona',
  'Aroni',
  'Arons',
  'Artan',
  'Artur',
  'Astan',
  'Astum',
  'Astur',
  'Atara',
  'Ataru',
  'Atlan',
  'Atlar',
  'Atlin',
  'Atlum',
  'Atuna',
  'Atuni',
  'Auran',
  'Aurum',
  'Aurur',
  'Barba',
  'Barbu',
  'Beata',
  'Beatu',
  'Bedda',
  'Beddu',
  'Berit',
  'Bersa',
  'Bersi',
  'Berta',
  'Bertu',
  'Bessa',
  'Bessi',
  'Betta',
  'Bettu',
  'Bettý',
  'Bilbo',
  'Binan',
  'Binum',
  'Binur',
  'Birgi',
  'Birni',
  'Boasa',
  'Boasi',
  'Braga',
  'Bragi',
  'Brian',
  'Britt',
  'Bungo',
  'Bursa',
  'Bursi',
  'Bárða',
  'Bárði',
  'Bávur',
  'Bívur',
  'Bóasa',
  'Bóasi',
  'Búans',
  'Dagný',
  'Danar',
  'Dania',
  'Danin',
  'Daniu',
  'Danna',
  'Danni',
  'Danns',
  'Danum',
  'Diana',
  'Dianu',
  'Dinan',
  'Dinna',
  'Dinnu',
  'Dinum',
  'Dinur',
  'Diona',
  'Dioni',
  'Dions',
  'Djóna',
  'Djóni',
  'Doran',
  'Doris',
  'Dorum',
  'Dorur',
  'Durin',
  'Durið',
  'Dávan',
  'Dávar',
  'Dávid',
  'Dávin',
  'Dávið',
  'Dávum',
  'Dávur',
  'Dímun',
  'Dóran',
  'Dórar',
  'Dórin',
  'Dórum',
  'Dórur',
  'Ebban',
  'Ebbar',
  'Ebbin',
  'Ebbum',
  'Ebbur',
  'Eddan',
  'Eddum',
  'Eddur',
  'Ednan',
  'Ednum',
  'Ednur',
  'Edvin',
  'Egans',
  'Egila',
  'Egili',
  'Egils',
  'Egina',
  'Eilin',
  'Eilív',
  'Einan',
  'Einur',
  'Eiran',
  'Eirar',
  'Eirik',
  'Eirin',
  'Eivør',
  'Elian',
  'Eliar',
  'Elias',
  'Eliin',
  'Elina',
  'Elini',
  'Elinu',
  'Elisa',
  'Elisi',
  'Elisu',
  'Elium',
  'Eliur',
  'Ellan',
  'Ellum',
  'Ellur',
  'Elmar',
  'Elnan',
  'Elnum',
  'Elnur',
  'Elsan',
  'Elsba',
  'Elsbu',
  'Elspa',
  'Elspu',
  'Elsum',
  'Elsur',
  'Embla',
  'Emblu',
  'Emila',
  'Emili',
  'Emils',
  'Emilý',
  'Emman',
  'Emmum',
  'Emmur',
  'Ennan',
  'Ennum',
  'Ennur',
  'Enoka',
  'Enoki',
  'Enoks',
  'Erika',
  'Eriku',
  'Ernan',
  'Ernst',
  'Ernum',
  'Ernur',
  'Eskil',
  'Esmar',
  'Estan',
  'Ester',
  'Estum',
  'Estur',
  'Evald',
  'Evuna',
  'Evuni',
  'Eyðan',
  'Eyðar',
  'Eyðin',
  'Eyðum',
  'Eyðun',
  'Fanný',
  'Femja',
  'Femju',
  'Filip',
  'Finna',
  'Finni',
  'Finns',
  'Flosa',
  'Flosi',
  'Fossá',
  'Frank',
  'Frans',
  'Frida',
  'Fridu',
  'Frits',
  'Froya',
  'Froyu',
  'Fríða',
  'Fríði',
  'Fríðu',
  'Fróða',
  'Fróði',
  'Fróðu',
  'Fípan',
  'Fípum',
  'Fípur',
  'Fíuna',
  'Fíuni',
  'Følvu',
  'Garðá',
  'Geira',
  'Geiri',
  'Geirs',
  'Geiru',
  'Georg',
  'Gerda',
  'Gerdu',
  'Glóan',
  'Glóin',
  'Glóum',
  'Glóur',
  'Glúma',
  'Glúmi',
  'Glúms',
  'Golla',
  'Golli',
  'Gorma',
  'Gormi',
  'Gorms',
  'Greip',
  'Greta',
  'Gretu',
  'Grias',
  'Gríms',
  'Gróan',
  'Gróur',
  'Gudný',
  'Gulak',
  'Gunda',
  'Gundi',
  'Gunna',
  'Gunni',
  'Gunnu',
  'Gusta',
  'Gusti',
  'Gutta',
  'Gutti',
  'Gylva',
  'Gylvi',
  'Gyðan',
  'Gyðum',
  'Gyður',
  'Haldu',
  'Halls',
  'Hallu',
  'Hannu',
  'Hansa',
  'Hansi',
  'Hansu',
  'Hanus',
  'Heidi',
  'Heina',
  'Heini',
  'Heiðu',
  'Helga',
  'Helgi',
  'Helgu',
  'Helmu',
  'Henný',
  'Heran',
  'Herar',
  'Herin',
  'Herta',
  'Hertu',
  'Herum',
  'Herur',
  'Heðin',
  'Hilda',
  'Hildi',
  'Hilma',
  'Hilmu',
  'Honnu',
  'Hákun',
  'Hárik',
  'Hávar',
  'Hóran',
  'Hórin',
  'Hórum',
  'Hórða',
  'Hórði',
  'Hørði',
  'Iduna',
  'Iduni',
  'India',
  'Ingan',
  'Ingar',
  'Ingin',
  'Ingum',
  'Ingur',
  'Ingvá',
  'Innan',
  'Innum',
  'Innur',
  'Inuna',
  'Inuni',
  'Irena',
  'Irenu',
  'Irman',
  'Irmum',
  'Irmur',
  'Ivana',
  'Ivani',
  'Ivans',
  'Iðunn',
  'Jafet',
  'Janan',
  'Janar',
  'Janin',
  'Janna',
  'Janni',
  'Janns',
  'Jannu',
  'Jansý',
  'Janum',
  'Janur',
  'Janus',
  'Japan',
  'Jason',
  'Jenis',
  'Jenný',
  'Jensa',
  'Jensi',
  'Jensu',
  'Jesum',
  'Jesus',
  'Jetta',
  'Jettu',
  'Johna',
  'Johni',
  'Johns',
  'Jonan',
  'Jonna',
  'Jonni',
  'Jonns',
  'Jonnu',
  'Jonur',
  'Josva',
  'Judit',
  'Julia',
  'Juliu',
  'Justa',
  'Justi',
  'Justu',
  'Jutta',
  'Juttu',
  'Jákup',
  'Jóala',
  'Jóali',
  'Jóals',
  'Jóana',
  'Jóani',
  'Jóans',
  'Jóasa',
  'Jóasi',
  'Jódis',
  'Jóela',
  'Jóeli',
  'Jóels',
  'Jóhan',
  'Jónan',
  'Jónas',
  'Jónur',
  'Jónvá',
  'Jósef',
  'Jósup',
  'Jóvør',
  'Júlia',
  'Júliu',
  'Jústa',
  'Jústi',
  'Jústs',
  'Jústu',
  'Jútta',
  'Júttu',
  'Kaian',
  'Kaiur',
  'Kaleb',
  'Kamma',
  'Kammu',
  'Karan',
  'Karin',
  'Karla',
  'Karli',
  'Karls',
  'Karlu',
  'Karum',
  'Karur',
  'Katja',
  'Katju',
  'Katla',
  'Katlu',
  'Kesia',
  'Kesiu',
  'Klara',
  'Klaru',
  'Kláus',
  'Krist',
  'Kunoy',
  'Kurta',
  'Kurti',
  'Kurts',
  'Káran',
  'Kárin',
  'Kárum',
  'Kárur',
  'Kílan',
  'Kílin',
  'Kílum',
  'Laars',
  'Laila',
  'Lailu',
  'Larsa',
  'Larsi',
  'Laura',
  'Lauru',
  'Leiki',
  'Lenan',
  'Lenur',
  'Leoar',
  'Leoin',
  'Leona',
  'Leoni',
  'Leons',
  'Leonu',
  'Leoum',
  'Leuna',
  'Leuni',
  'Levia',
  'Levis',
  'Liama',
  'Liami',
  'Liams',
  'Liasa',
  'Liasi',
  'Lillý',
  'Linan',
  'Lindu',
  'Linum',
  'Linur',
  'Livan',
  'Livum',
  'Livur',
  'Lotta',
  'Lottu',
  'Lukas',
  'Lulan',
  'Lulum',
  'Lulur',
  'Lunan',
  'Lunum',
  'Lunur',
  'Lusia',
  'Lusiu',
  'Lávus',
  'Línar',
  'Línin',
  'Lívar',
  'Lívin',
  'Lóuna',
  'Lóuni',
  'Løðar',
  'Lýdia',
  'Lýdiu',
  'Lýina',
  'Lýini',
  'Lýðar',
  'Lýður',
  'Magda',
  'Magdu',
  'Magga',
  'Maggu',
  'Magnu',
  'Maian',
  'Maika',
  'Maiku',
  'Maium',
  'Maiur',
  'Maksa',
  'Malan',
  'Maria',
  'Marin',
  'Marit',
  'Mariu',
  'Marið',
  'Marja',
  'Marju',
  'Marna',
  'Marni',
  'Marnu',
  'Marta',
  'Martu',
  'Masan',
  'Masum',
  'Masur',
  'Matsa',
  'Matsi',
  'Merrý',
  'Mikal',
  'Milan',
  'Milja',
  'Milju',
  'Miran',
  'Mirja',
  'Mirju',
  'Mirum',
  'Mirur',
  'Miuna',
  'Miuni',
  'Monur',
  'Myrna',
  'Myrnu',
  'Mækir',
  'Mækis',
  'Mórus',
  'Móses',
  'Møggu',
  'Naina',
  'Nainu',
  'Nanna',
  'Nannu',
  'Nanný',
  'Nansý',
  'Naomi',
  'Narva',
  'Narvi',
  'Natan',
  'Niels',
  'Nilsa',
  'Nilsi',
  'Ninan',
  'Ninna',
  'Ninnu',
  'Ninum',
  'Ninur',
  'Nitan',
  'Nitur',
  'Njála',
  'Njáli',
  'Njáls',
  'Noomi',
  'Noran',
  'Noreg',
  'Norma',
  'Normu',
  'Norra',
  'Norum',
  'Norur',
  'Nábal',
  'Nóama',
  'Nóami',
  'Nóams',
  'Nóans',
  'Nóela',
  'Nóeli',
  'Nóels',
  'Oddný',
  'Oddvá',
  'Oduna',
  'Oduni',
  'Olgan',
  'Olgar',
  'Olgum',
  'Olgur',
  'Onnum',
  'Onnur',
  'Onund',
  'Ormar',
  'Oskar',
  'Ottar',
  'Ottoa',
  'Ottos',
  'Ovans',
  'Oydis',
  'Oygló',
  'Oyolv',
  'Oyvør',
  'Palma',
  'Palmu',
  'París',
  'Paula',
  'Pauli',
  'Paulu',
  'Pavla',
  'Pavlu',
  'Perar',
  'Perin',
  'Perum',
  'Petra',
  'Petru',
  'Petur',
  'Polan',
  'Polar',
  'Polin',
  'Polum',
  'Poula',
  'Pouli',
  'Pouls',
  'Poulu',
  'Pálar',
  'Pálin',
  'Pálla',
  'Pálli',
  'Pálls',
  'Pálma',
  'Pálmu',
  'Pálum',
  'Pætur',
  'Pólan',
  'Pólar',
  'Pólin',
  'Pólum',
  'Pólur',
  'Ragnu',
  'Rakul',
  'Ranja',
  'Ranju',
  'Regin',
  'Revna',
  'Revnu',
  'Rikka',
  'Rikku',
  'Ritva',
  'Ritvu',
  'Riuna',
  'Riuni',
  'Rodan',
  'Rodum',
  'Rodur',
  'Ronja',
  'Ronju',
  'Ronna',
  'Ronni',
  'Rubek',
  'Ruben',
  'Rutar',
  'Rutin',
  'Ránar',
  'Ránin',
  'Ríkin',
  'Róald',
  'Róans',
  'Róara',
  'Róari',
  'Róars',
  'Róina',
  'Róini',
  'Rólva',
  'Rólvi',
  'Rólvs',
  'Róuna',
  'Róuni',
  'Róðan',
  'Róðum',
  'Róður',
  'Rúnan',
  'Rúnur',
  'Salný',
  'Sannu',
  'Saula',
  'Sauli',
  'Sauls',
  'Selma',
  'Selmu',
  'Semar',
  'Semin',
  'Semum',
  'Setum',
  'Signý',
  'Silas',
  'Sirið',
  'Sivin',
  'Sivja',
  'Sjúrð',
  'Skaga',
  'Skagi',
  'Smáka',
  'Smáki',
  'Smáks',
  'Sofus',
  'Sofía',
  'Sofíu',
  'Sonja',
  'Sonju',
  'Sonna',
  'Sonni',
  'Sonnu',
  'Sumba',
  'Sunan',
  'Sunar',
  'Sunin',
  'Sunum',
  'Sváva',
  'Svávu',
  'Sámal',
  'Sámur',
  'Sáran',
  'Sárur',
  'Sædis',
  'Sæunn',
  'Sævar',
  'Símun',
  'Sívar',
  'Sólvá',
  'Sølva',
  'Sølvi',
  'Sølvu',
  'Sølvá',
  'Sørin',
  'Sørla',
  'Sørli',
  'Súnan',
  'Súnar',
  'Súnin',
  'Súnur',
  'Tanja',
  'Tanju',
  'Tekla',
  'Teklu',
  'Terja',
  'Terji',
  'Teuna',
  'Teuni',
  'Tilda',
  'Tildu',
  'Tinan',
  'Tinum',
  'Tinur',
  'Tonna',
  'Tonni',
  'Torný',
  'Tovan',
  'Tovum',
  'Tovur',
  'Trina',
  'Trinu',
  'Trónd',
  'Tyrna',
  'Tyrni',
  'Tókan',
  'Tókar',
  'Tókin',
  'Tókum',
  'Tóran',
  'Tórin',
  'Tórir',
  'Tóris',
  'Tórum',
  'Tórur',
  'Tórða',
  'Tórði',
  'Tótan',
  'Tótar',
  'Tótin',
  'Tótum',
  'Tótur',
  'Tóvan',
  'Tóvur',
  'Týran',
  'Týrar',
  'Týrin',
  'Týrum',
  'Týrur',
  'Uggum',
  'Ullan',
  'Ullur',
  'Unans',
  'Unnan',
  'Unnar',
  'Unnin',
  'Unnum',
  'Unnur',
  'Ununa',
  'Ununi',
  'Urðan',
  'Urður',
  'Vagna',
  'Vagnu',
  'Viggo',
  'Vinný',
  'Vinsa',
  'Vinsi',
  'Vitus',
  'Vivia',
  'Viviu',
  'Viðoy',
  'Viólu',
  'Vágar',
  'Vágoy',
  'Vágum',
  'Várin',
  'Vænan',
  'Vænum',
  'Vænur',
  'Vívil',
  'Vøggi',
  'Vøggs',
  'Yngva',
  'Yngvi',
  'Yngvu',
  'Yrsan',
  'Yrsum',
  'Yrsur',
  'abban',
  'abbar',
  'abbin',
  'abbum',
  'aftan',
  'aftna',
  'aftni',
  'aftra',
  'aftri',
  'aftur',
  'agans',
  'agast',
  'agati',
  'agats',
  'agaða',
  'agaði',
  'agaðs',
  'agaðu',
  'agent',
  'aggar',
  'aggað',
  'aggið',
  'agist',
  'agnið',
  'agnum',
  'agoni',
  'ahorn',
  'akarn',
  'akast',
  'akfar',
  'akfør',
  'akini',
  'akist',
  'akker',
  'aklar',
  'aklum',
  'akryl',
  'akrýl',
  'aksil',
  'aksið',
  'aksla',
  'aksli',
  'aktar',
  'aktað',
  'aktin',
  'aktir',
  'aktiv',
  'aktið',
  'aktum',
  'aktáa',
  'aktær',
  'aktól',
  'aktóm',
  'aktør',
  'akuls',
  'akurs',
  'akveg',
  'akørn',
  'alara',
  'alari',
  'alarm',
  'alast',
  'album',
  'aldan',
  'aldar',
  'aldað',
  'aldin',
  'aldir',
  'aldið',
  'aldra',
  'aldri',
  'aldum',
  'aldur',
  'aldut',
  'alfús',
  'algan',
  'algum',
  'algur',
  'algóð',
  'aling',
  'alins',
  'alist',
  'alkøn',
  'allar',
  'allia',
  'allir',
  'alliu',
  'allur',
  'allík',
  'allýs',
  'almar',
  'almin',
  'alnan',
  'alnar',
  'alnet',
  'alnir',
  'alnum',
  'alnót',
  'alnýs',
  'aloyð',
  'alrar',
  'alrík',
  'alrím',
  'alska',
  'alski',
  'alsks',
  'alsom',
  'altal',
  'altan',
  'altar',
  'altin',
  'altir',
  'altrá',
  'altso',
  'altum',
  'altur',
  'altíð',
  'altøk',
  'altøl',
  'alvan',
  'alvar',
  'alvað',
  'alvin',
  'alvið',
  'alvum',
  'alvur',
  'alvís',
  'alúna',
  'alúni',
  'alúns',
  'amara',
  'amari',
  'amast',
  'amboð',
  'ambra',
  'amist',
  'amman',
  'ammum',
  'ammur',
  'ampan',
  'ampar',
  'ampað',
  'amper',
  'ampin',
  'ampið',
  'ampum',
  'ampur',
  'amtið',
  'amtum',
  'amuta',
  'amuti',
  'amuts',
  'amutu',
  'amøba',
  'amøbu',
  'anada',
  'anadu',
  'anala',
  'anali',
  'anals',
  'analt',
  'analu',
  'anara',
  'anari',
  'andan',
  'andar',
  'andað',
  'andin',
  'andir',
  'andið',
  'andum',
  'andøv',
  'angan',
  'angar',
  'angað',
  'angin',
  'angið',
  'angra',
  'angri',
  'angum',
  'angur',
  'aning',
  'anini',
  'ankar',
  'ankað',
  'ankið',
  'ankra',
  'ankri',
  'ankør',
  'annað',
  'annám',
  'anoda',
  'anodu',
  'ansar',
  'ansað',
  'ansin',
  'ansið',
  'ansjá',
  'ansna',
  'ansni',
  'ansnu',
  'ansur',
  'antal',
  'antar',
  'antil',
  'antin',
  'apast',
  'apaði',
  'apaðu',
  'apist',
  'appar',
  'appin',
  'appir',
  'appum',
  'apríl',
  'apuna',
  'apuni',
  'aputa',
  'aputi',
  'aputs',
  'aputu',
  'araba',
  'arabi',
  'argan',
  'argar',
  'argað',
  'argið',
  'argra',
  'argur',
  'arini',
  'arisk',
  'arkar',
  'arkin',
  'arkir',
  'arkið',
  'arkum',
  'arman',
  'armar',
  'armað',
  'armin',
  'armir',
  'armið',
  'armra',
  'armum',
  'armur',
  'armóð',
  'arrig',
  'arrið',
  'arrum',
  'arrut',
  'arsar',
  'arsin',
  'arsum',
  'arsur',
  'artar',
  'artað',
  'artin',
  'artið',
  'arvan',
  'arvar',
  'arvað',
  'arvin',
  'arvið',
  'arvum',
  'arvur',
  'arába',
  'arábi',
  'asans',
  'asast',
  'asaða',
  'asaði',
  'asaðs',
  'asaðu',
  'asiat',
  'asins',
  'asist',
  'askar',
  'askin',
  'askir',
  'askum',
  'askur',
  'asnan',
  'asnar',
  'asnin',
  'asnum',
  'aspar',
  'aspir',
  'aspum',
  'assar',
  'assað',
  'assið',
  'astma',
  'astmu',
  'athav',
  'athøv',
  'atlim',
  'atlit',
  'atlið',
  'atlop',
  'atlát',
  'atomi',
  'atoms',
  'atoni',
  'atrar',
  'atrað',
  'atrið',
  'atrák',
  'atvik',
  'aulan',
  'aulum',
  'aulur',
  'avans',
  'avboð',
  'avbær',
  'avdag',
  'avdal',
  'avdøm',
  'avegn',
  'aveld',
  'avelt',
  'avgap',
  'avgav',
  'avger',
  'avgev',
  'avgud',
  'avhyl',
  'avhús',
  'avill',
  'avils',
  'avilt',
  'avkom',
  'avlas',
  'avles',
  'avlop',
  'avlát',
  'avlæt',
  'avlýs',
  'avmóð',
  'avmøð',
  'avnor',
  'avnot',
  'avnór',
  'avoyð',
  'avrak',
  'avrik',
  'avrit',
  'avrot',
  'avroð',
  'avráð',
  'avrók',
  'avrøk',
  'avrúm',
  'avsag',
  'avsig',
  'avtak',
  'avtíð',
  'avtók',
  'avveg',
  'avvik',
  'aváar',
  'aváin',
  'aváir',
  'aváti',
  'aváts',
  'aváum',
  'avísa',
  'aðala',
  'aðali',
  'aðals',
  'aðrar',
  'aðrir',
  'babba',
  'babbi',
  'babla',
  'babli',
  'babls',
  'babsa',
  'babsi',
  'bagal',
  'bagan',
  'bagar',
  'bagga',
  'baggi',
  'bagin',
  'bagla',
  'bagli',
  'bagum',
  'bakar',
  'bakað',
  'bakin',
  'bakið',
  'bakka',
  'bakki',
  'baksa',
  'baksi',
  'baktá',
  'bakum',
  'bakur',
  'bakál',
  'bakæs',
  'balan',
  'balda',
  'baldi',
  'balds',
  'baldu',
  'balin',
  'balið',
  'balja',
  'balju',
  'balla',
  'balli',
  'ballu',
  'balna',
  'balni',
  'balnu',
  'balst',
  'balta',
  'balti',
  'bamsa',
  'bamsi',
  'bamsu',
  'banal',
  'banan',
  'banar',
  'banað',
  'banda',
  'bandi',
  'bands',
  'banga',
  'bangi',
  'bangs',
  'banin',
  'banið',
  'banka',
  'banki',
  'banks',
  'banna',
  'banni',
  'bansa',
  'bansi',
  'banum',
  'baran',
  'barar',
  'barað',
  'barda',
  'bardi',
  'bards',
  'bardu',
  'barir',
  'barið',
  'barka',
  'barki',
  'barks',
  'barma',
  'barmi',
  'barms',
  'barna',
  'barni',
  'barns',
  'barst',
  'barum',
  'barur',
  'barva',
  'barvi',
  'barða',
  'barði',
  'barðs',
  'barón',
  'basal',
  'basan',
  'basar',
  'basin',
  'baska',
  'baski',
  'basks',
  'bassa',
  'bassi',
  'basta',
  'basti',
  'basts',
  'basum',
  'basár',
  'batan',
  'batar',
  'batin',
  'batna',
  'batni',
  'batta',
  'batti',
  'batum',
  'baðar',
  'baðað',
  'baðið',
  'baðst',
  'baðum',
  'beddi',
  'beidd',
  'beids',
  'beina',
  'beind',
  'beini',
  'beins',
  'beint',
  'beinu',
  'beisa',
  'beisi',
  'beisk',
  'beist',
  'beisu',
  'beita',
  'beiti',
  'beits',
  'beitt',
  'beitu',
  'beiða',
  'beiði',
  'bekil',
  'bekka',
  'bekki',
  'bekla',
  'bekli',
  'bekls',
  'bekta',
  'belga',
  'belgi',
  'belgt',
  'belis',
  'belið',
  'belja',
  'belji',
  'beljs',
  'bella',
  'belli',
  'belta',
  'belti',
  'benda',
  'bendi',
  'bends',
  'bendu',
  'benin',
  'benir',
  'benis',
  'benið',
  'benja',
  'benum',
  'beran',
  'berar',
  'berba',
  'berbi',
  'berga',
  'bergi',
  'bergs',
  'berin',
  'berir',
  'berið',
  'berja',
  'berji',
  'berka',
  'berki',
  'berma',
  'bermu',
  'berst',
  'berum',
  'berur',
  'berva',
  'bervi',
  'berár',
  'besta',
  'besti',
  'bests',
  'bestu',
  'besøk',
  'betra',
  'betri',
  'betru',
  'betur',
  'betýð',
  'bevís',
  'beyka',
  'beyki',
  'beyks',
  'beðar',
  'beðin',
  'beðir',
  'beðið',
  'beðum',
  'beður',
  'bibba',
  'bibbi',
  'bibbu',
  'bidda',
  'biddi',
  'bidna',
  'bidni',
  'bidnu',
  'bifak',
  'bikar',
  'bikað',
  'bikið',
  'bikka',
  'bikku',
  'biksa',
  'biksi',
  'bikut',
  'bikør',
  'bilar',
  'bilin',
  'bilir',
  'bilið',
  'billa',
  'billi',
  'billu',
  'bilum',
  'bilur',
  'bimba',
  'bimbi',
  'binda',
  'bindi',
  'binds',
  'biner',
  'binga',
  'bingi',
  'bingo',
  'bings',
  'bioið',
  'bipar',
  'bipað',
  'bipið',
  'bippa',
  'bippi',
  'birga',
  'birgd',
  'birgs',
  'birgt',
  'birgu',
  'birki',
  'birna',
  'birnu',
  'birta',
  'birti',
  'birts',
  'birtu',
  'bison',
  'bispa',
  'bispi',
  'bisps',
  'bitan',
  'bitar',
  'bitil',
  'bitin',
  'bitið',
  'bitla',
  'bitli',
  'bitna',
  'bitni',
  'bitnu',
  'bitra',
  'bitri',
  'bitru',
  'bitum',
  'bitur',
  'bitut',
  'bivan',
  'bivar',
  'bivað',
  'bivið',
  'biðil',
  'biðin',
  'biðir',
  'biðis',
  'biðið',
  'biðja',
  'biðji',
  'biðla',
  'biðli',
  'biðst',
  'biðum',
  'biður',
  'bjarg',
  'bjart',
  'bjóra',
  'bjóri',
  'bjórs',
  'bjóst',
  'bjóða',
  'bjóði',
  'bjølg',
  'bjøll',
  'bjørg',
  'bjørk',
  'bjørn',
  'bjørt',
  'blaka',
  'blaki',
  'blakk',
  'blaks',
  'bland',
  'blant',
  'blarv',
  'blaða',
  'blaði',
  'blaðs',
  'bleik',
  'bleiv',
  'blekk',
  'bleks',
  'blets',
  'blett',
  'bleyt',
  'blika',
  'bliki',
  'blikk',
  'bliks',
  'bliku',
  'blind',
  'blink',
  'blint',
  'blits',
  'blivu',
  'blogg',
  'blogs',
  'blokk',
  'bloks',
  'blonk',
  'blota',
  'bloti',
  'blots',
  'bloyt',
  'blund',
  'blunk',
  'blusa',
  'bluss',
  'blusu',
  'blygd',
  'bláan',
  'bláar',
  'bláin',
  'bláir',
  'bláma',
  'blámi',
  'bláms',
  'blána',
  'bláni',
  'blása',
  'blási',
  'blást',
  'blátt',
  'bláum',
  'bláur',
  'bláís',
  'blæan',
  'blæma',
  'blæmu',
  'blæst',
  'blæum',
  'blæur',
  'blítt',
  'blíva',
  'blívi',
  'blíða',
  'blíði',
  'blíðs',
  'blíðu',
  'blóma',
  'blómi',
  'blómu',
  'blóta',
  'blóti',
  'blóts',
  'blóða',
  'blóði',
  'blóðs',
  'blødd',
  'bløds',
  'bløka',
  'bløku',
  'bløtt',
  'bløða',
  'bløði',
  'blúgs',
  'blúgt',
  'blúgv',
  'blúna',
  'blúni',
  'blúnu',
  'blýið',
  'blýum',
  'boara',
  'boari',
  'bobba',
  'bobbi',
  'bodna',
  'bodni',
  'bodnu',
  'bogan',
  'bogar',
  'bogað',
  'bogga',
  'boggu',
  'bogin',
  'bogið',
  'bogna',
  'bogni',
  'bognu',
  'bogra',
  'bogri',
  'bogum',
  'bohem',
  'boksa',
  'boksi',
  'boksl',
  'bolan',
  'bolar',
  'bolað',
  'bolin',
  'bolið',
  'bolla',
  'bolli',
  'bolta',
  'bolti',
  'bolts',
  'bolum',
  'bomma',
  'bommi',
  'bonar',
  'bonað',
  'bonið',
  'bonki',
  'bonni',
  'bonsk',
  'boppa',
  'boppi',
  'boppu',
  'boran',
  'borar',
  'borað',
  'borda',
  'bordi',
  'bords',
  'borga',
  'borgi',
  'borgs',
  'borin',
  'borir',
  'borið',
  'borna',
  'borni',
  'bornu',
  'borum',
  'borur',
  'borða',
  'borði',
  'borðs',
  'borðu',
  'bosar',
  'bosað',
  'bosið',
  'bosna',
  'bosni',
  'bosut',
  'botna',
  'botni',
  'botns',
  'bouna',
  'bouni',
  'bowla',
  'bowli',
  'boyan',
  'boygd',
  'boygg',
  'boygt',
  'boyla',
  'boyli',
  'boysa',
  'boysi',
  'boyum',
  'boyur',
  'boðan',
  'boðar',
  'boðað',
  'boðin',
  'boðið',
  'boðum',
  'bragd',
  'bragg',
  'brags',
  'bragð',
  'braka',
  'braki',
  'braks',
  'brala',
  'brali',
  'brals',
  'brand',
  'brann',
  'brast',
  'brats',
  'bratt',
  'bregd',
  'bregs',
  'bregð',
  'breið',
  'breka',
  'breki',
  'breks',
  'brell',
  'brels',
  'brend',
  'brenn',
  'brens',
  'brent',
  'brest',
  'breta',
  'breti',
  'brets',
  'brett',
  'breyt',
  'breyð',
  'brigd',
  'brigg',
  'brima',
  'brimi',
  'brims',
  'bring',
  'brint',
  'brisa',
  'brisi',
  'brist',
  'brita',
  'britu',
  'brjót',
  'brodd',
  'brods',
  'brokk',
  'broks',
  'bromi',
  'broms',
  'brosa',
  'brosi',
  'brota',
  'broti',
  'brots',
  'broyt',
  'brudd',
  'bruds',
  'bruka',
  'bruki',
  'bruks',
  'brumm',
  'brums',
  'bruna',
  'brund',
  'bruni',
  'brunn',
  'bruns',
  'brutt',
  'brutu',
  'brygs',
  'brynn',
  'brynt',
  'bryst',
  'bryði',
  'bráan',
  'bráar',
  'bráað',
  'bráin',
  'bráir',
  'bráið',
  'bráka',
  'bráki',
  'bráks',
  'brást',
  'brátt',
  'bráum',
  'bráur',
  'bráða',
  'bráði',
  'bráðs',
  'bráðu',
  'brædd',
  'bræds',
  'brætt',
  'bræva',
  'brævi',
  'brævs',
  'bræða',
  'bræði',
  'bríka',
  'bróka',
  'brósk',
  'bróst',
  'bróta',
  'bróti',
  'brøgd',
  'brøgð',
  'brøka',
  'brøla',
  'brøli',
  'brøls',
  'brøtt',
  'brøyt',
  'brúar',
  'brúgv',
  'brúin',
  'brúka',
  'brúki',
  'brúks',
  'brúkt',
  'brúna',
  'brúni',
  'brúns',
  'brúnt',
  'brúnu',
  'brúsa',
  'brúsi',
  'brúsu',
  'brýna',
  'brýnd',
  'brýni',
  'brýnt',
  'brýsk',
  'bubba',
  'bubbu',
  'bugar',
  'bugað',
  'bugin',
  'bugið',
  'bugum',
  'bugur',
  'bukan',
  'bukar',
  'bukað',
  'bukið',
  'bukka',
  'bukki',
  'bukku',
  'bukla',
  'bukli',
  'buklu',
  'buksa',
  'bukta',
  'bukti',
  'bukum',
  'bukur',
  'bular',
  'bulað',
  'buldó',
  'bulin',
  'bulka',
  'bulki',
  'bulks',
  'bulla',
  'bulli',
  'bulum',
  'bulur',
  'bumba',
  'bumbi',
  'bumbu',
  'bumma',
  'bummi',
  'bumsa',
  'bumsi',
  'bunan',
  'bunda',
  'bundi',
  'bundu',
  'bunga',
  'bungu',
  'bunit',
  'bunja',
  'bunji',
  'bunka',
  'bunki',
  'bunta',
  'bunti',
  'bunum',
  'bunur',
  'buppa',
  'buppi',
  'buppu',
  'burdi',
  'burdu',
  'burga',
  'burgu',
  'burra',
  'burri',
  'burða',
  'burði',
  'busan',
  'busar',
  'busað',
  'busin',
  'busið',
  'buski',
  'busks',
  'bussa',
  'bussi',
  'bussu',
  'busta',
  'busti',
  'busum',
  'busut',
  'butan',
  'butar',
  'butað',
  'butið',
  'butta',
  'butti',
  'buttu',
  'buuna',
  'buuni',
  'bygda',
  'bygdi',
  'bygds',
  'bygdu',
  'byggi',
  'bygst',
  'bylar',
  'bylin',
  'bylja',
  'bylum',
  'bylur',
  'byrgd',
  'byrgi',
  'byrgt',
  'byrin',
  'byrir',
  'byrja',
  'byrji',
  'byrsa',
  'byrsu',
  'byrur',
  'byrða',
  'byrði',
  'byrðu',
  'bytta',
  'byttu',
  'bágan',
  'bágar',
  'bágað',
  'bágin',
  'bágið',
  'bágna',
  'bágni',
  'bágnu',
  'bágum',
  'bágur',
  'bákna',
  'bákni',
  'bákns',
  'bálan',
  'bálar',
  'bálað',
  'bálin',
  'bálið',
  'bálna',
  'bálni',
  'bálnu',
  'bálum',
  'bálur',
  'bálut',
  'báran',
  'bárið',
  'bárum',
  'bárur',
  'bárut',
  'básar',
  'básað',
  'básin',
  'básum',
  'básur',
  'bátar',
  'bátin',
  'bátum',
  'bátur',
  'báðar',
  'báðir',
  'báðum',
  'bæris',
  'bærið',
  'bævri',
  'bævur',
  'bíggi',
  'bílan',
  'bílig',
  'bílum',
  'bílur',
  'bílæt',
  'bíløt',
  'bínda',
  'bíndi',
  'bínds',
  'bíndu',
  'bínir',
  'bínið',
  'bítar',
  'bítin',
  'bítið',
  'bítsk',
  'bítst',
  'bítum',
  'bítur',
  'bíðan',
  'bógva',
  'bógvi',
  'bógár',
  'bókan',
  'bókar',
  'bókað',
  'bókin',
  'bókið',
  'bókum',
  'bólar',
  'bólað',
  'bólið',
  'bólka',
  'bólki',
  'bólks',
  'bólta',
  'bólti',
  'bólts',
  'bólum',
  'bónda',
  'bóndi',
  'bósan',
  'bósar',
  'bósað',
  'bósin',
  'bósið',
  'bósna',
  'bósni',
  'bósnu',
  'bósum',
  'bótar',
  'bótað',
  'bótin',
  'bótið',
  'bótum',
  'bótut',
  'bøbba',
  'bøbbi',
  'bøbit',
  'bøgan',
  'bøgir',
  'bøgum',
  'bøgur',
  'bøgás',
  'bøgæs',
  'bøkil',
  'bøkka',
  'bøkki',
  'bøkla',
  'bøkli',
  'bøksl',
  'bøkul',
  'bøkum',
  'bøkur',
  'bøkut',
  'bølar',
  'bølað',
  'bøldi',
  'bøldu',
  'bølir',
  'bølis',
  'bølið',
  'bølla',
  'bølli',
  'bølst',
  'bølum',
  'bølva',
  'bølvi',
  'bønan',
  'bønar',
  'bønað',
  'bønin',
  'bønir',
  'bønið',
  'bønum',
  'bønur',
  'børan',
  'børka',
  'børki',
  'børku',
  'børum',
  'børur',
  'bøssa',
  'bøssi',
  'bøtir',
  'bøtið',
  'bøtst',
  'bøtta',
  'bøtti',
  'bøtts',
  'bøttu',
  'bøtur',
  'bøveg',
  'bøðil',
  'bøðla',
  'bøðli',
  'búffa',
  'búffi',
  'búfla',
  'búfli',
  'búfæi',
  'búfør',
  'búgva',
  'búgvi',
  'búini',
  'búkar',
  'búkin',
  'búkum',
  'búkur',
  'búkut',
  'búlga',
  'búlgu',
  'búlið',
  'búlut',
  'búnan',
  'búnar',
  'búnað',
  'búnin',
  'búnir',
  'búnum',
  'búrið',
  'búrum',
  'búrók',
  'búrúm',
  'búset',
  'bússa',
  'bússu',
  'búsíl',
  'bútíð',
  'búurs',
  'búveg',
  'búðar',
  'búðin',
  'búðir',
  'búðum',
  'búøki',
  'býggi',
  'býggj',
  'býlir',
  'býlis',
  'býlið',
  'býlum',
  'býnum',
  'býráð',
  'býtir',
  'býtis',
  'býtið',
  'býtst',
  'býtta',
  'býtti',
  'býtts',
  'býttu',
  'býtum',
  'býðst',
  'býður',
  'cover',
  'dadda',
  'daddu',
  'dadla',
  'dadlu',
  'daffa',
  'daffi',
  'dagar',
  'dagað',
  'dagga',
  'daggi',
  'dagin',
  'dagið',
  'dagna',
  'dagni',
  'dagur',
  'dalar',
  'dalað',
  'dalda',
  'daldi',
  'dalin',
  'dalir',
  'dalið',
  'dalla',
  'dalli',
  'dalum',
  'dalur',
  'daman',
  'damla',
  'damli',
  'damls',
  'damma',
  'dammi',
  'dammu',
  'dampa',
  'dampi',
  'damps',
  'damum',
  'damur',
  'danan',
  'danda',
  'dandi',
  'dandu',
  'danga',
  'dangi',
  'dangu',
  'danir',
  'dansa',
  'dansi',
  'dapan',
  'dapar',
  'dapað',
  'dapið',
  'dapra',
  'dapri',
  'dapur',
  'darla',
  'darli',
  'darls',
  'darra',
  'darri',
  'darta',
  'darti',
  'darts',
  'darva',
  'darvi',
  'dassa',
  'dassi',
  'dasti',
  'dasts',
  'datai',
  'datas',
  'datað',
  'datea',
  'dativ',
  'datst',
  'datum',
  'datur',
  'davar',
  'david',
  'degna',
  'degni',
  'deiga',
  'deigi',
  'deigs',
  'deigt',
  'deigu',
  'deila',
  'deild',
  'deili',
  'deilt',
  'deilu',
  'deist',
  'dekan',
  'dekil',
  'dekka',
  'dekki',
  'dekla',
  'dekli',
  'dekna',
  'dekni',
  'dekns',
  'delda',
  'della',
  'delli',
  'demba',
  'dembd',
  'dembi',
  'dembt',
  'demma',
  'demmu',
  'dempa',
  'dempi',
  'denar',
  'denti',
  'dents',
  'depil',
  'depla',
  'depli',
  'depot',
  'derla',
  'derlu',
  'desar',
  'desin',
  'desir',
  'desum',
  'detst',
  'detta',
  'detti',
  'devil',
  'devla',
  'devli',
  'devul',
  'deyda',
  'deydu',
  'deyma',
  'deymi',
  'deyms',
  'deysa',
  'deysi',
  'deytt',
  'deyva',
  'deyvi',
  'deyvs',
  'deyvt',
  'deyvu',
  'deyða',
  'deyði',
  'deyðs',
  'deyðu',
  'didda',
  'diddu',
  'difla',
  'difli',
  'digga',
  'diggi',
  'diggu',
  'digla',
  'diglu',
  'digra',
  'digri',
  'digru',
  'digur',
  'dikar',
  'dikað',
  'dikið',
  'dikka',
  'dikki',
  'dikta',
  'dikti',
  'dilda',
  'dildi',
  'dildu',
  'dilka',
  'dilki',
  'dilks',
  'dilla',
  'dilli',
  'dimda',
  'dimdi',
  'dimds',
  'dimdu',
  'dimma',
  'dimmi',
  'dimmu',
  'dimra',
  'dimsa',
  'dimsi',
  'dimst',
  'dinta',
  'dinti',
  'dints',
  'dioda',
  'diodu',
  'dirka',
  'dirki',
  'dirks',
  'dirla',
  'dirli',
  'dirls',
  'dirra',
  'dirri',
  'dirta',
  'dirti',
  'dirtl',
  'dirvi',
  'disja',
  'disji',
  'diska',
  'diski',
  'disks',
  'disma',
  'dismi',
  'disms',
  'dispi',
  'disps',
  'ditna',
  'ditni',
  'ditnu',
  'divan',
  'divum',
  'divur',
  'djass',
  'djóra',
  'djóri',
  'djórs',
  'djørv',
  'djúpa',
  'djúpd',
  'djúpi',
  'djúps',
  'djúpt',
  'djúpu',
  'djúsi',
  'dnaið',
  'dnaum',
  'dobba',
  'dobbi',
  'dobla',
  'dobli',
  'dodda',
  'doddi',
  'dogga',
  'doggi',
  'dogma',
  'dogmu',
  'dokka',
  'dokki',
  'dolka',
  'dolki',
  'dolks',
  'dongd',
  'dongt',
  'donor',
  'donsk',
  'donta',
  'donti',
  'dorar',
  'dorga',
  'dorin',
  'dorma',
  'dormi',
  'dosna',
  'dosni',
  'dosnu',
  'dossa',
  'dossi',
  'dotna',
  'dotni',
  'dotnu',
  'dovin',
  'dovið',
  'dovna',
  'dovni',
  'dovnu',
  'doydd',
  'doyds',
  'doyir',
  'doyið',
  'doypa',
  'doypi',
  'doypt',
  'doyrt',
  'doyst',
  'doytt',
  'doyva',
  'doyvd',
  'doyvi',
  'doyvt',
  'doyða',
  'doyði',
  'doyðu',
  'doðan',
  'doðar',
  'doðað',
  'doðin',
  'drabb',
  'drabs',
  'draga',
  'dragi',
  'drags',
  'drakk',
  'drakt',
  'drama',
  'dramm',
  'drams',
  'dramu',
  'drang',
  'drapp',
  'draps',
  'drasl',
  'dratl',
  'dravi',
  'dravs',
  'dregg',
  'dregs',
  'dreit',
  'dreiv',
  'dreka',
  'dreki',
  'drekk',
  'drekt',
  'drena',
  'dreni',
  'drens',
  'drepa',
  'drepi',
  'dreya',
  'dreyg',
  'dreyi',
  'dreym',
  'dreyp',
  'drift',
  'driti',
  'drits',
  'dritu',
  'drivi',
  'drivs',
  'drivu',
  'drjúp',
  'drong',
  'dropa',
  'dropi',
  'drops',
  'drosl',
  'drots',
  'drott',
  'droym',
  'droyp',
  'drumb',
  'drunn',
  'druns',
  'drupu',
  'drykk',
  'drynj',
  'drypp',
  'dryps',
  'dráka',
  'dráki',
  'dráks',
  'drála',
  'dráli',
  'dráls',
  'drápa',
  'drápi',
  'dráps',
  'drápu',
  'drátt',
  'dríta',
  'dríti',
  'dríva',
  'drívi',
  'drógu',
  'drópu',
  'dróst',
  'drøgg',
  'drøgs',
  'drølt',
  'drøni',
  'drøns',
  'drúgs',
  'drúgt',
  'drúgv',
  'drúpa',
  'drúpi',
  'drúva',
  'drúvu',
  'drýla',
  'drýli',
  'drýls',
  'drýpa',
  'drýpi',
  'drýpt',
  'dubba',
  'dubbi',
  'dudda',
  'duddi',
  'duffa',
  'duffi',
  'dugað',
  'dugdi',
  'dugdu',
  'dugga',
  'duggi',
  'dugin',
  'dugir',
  'dugið',
  'dugna',
  'dugni',
  'dugst',
  'dugur',
  'dukan',
  'dukar',
  'dukat',
  'dukað',
  'dukið',
  'dukka',
  'dukku',
  'dukum',
  'dukát',
  'dulan',
  'dular',
  'dulda',
  'duldi',
  'dulds',
  'duldu',
  'dulin',
  'dulir',
  'dulið',
  'dulla',
  'dulli',
  'dulna',
  'dulni',
  'dulnu',
  'dulst',
  'dulum',
  'dulur',
  'duman',
  'dumba',
  'dumbi',
  'dumbs',
  'dumbt',
  'dumbu',
  'dumma',
  'dummi',
  'dummu',
  'dumpa',
  'dumpi',
  'dumra',
  'dumsa',
  'dumsi',
  'dunan',
  'dunar',
  'dunað',
  'dunga',
  'dungi',
  'dunin',
  'dunið',
  'dunka',
  'dunki',
  'dunks',
  'dunna',
  'dunnu',
  'dupla',
  'dupli',
  'dupls',
  'dupul',
  'durar',
  'durum',
  'durur',
  'durva',
  'durvi',
  'dusar',
  'dusað',
  'dusin',
  'dusið',
  'duska',
  'duski',
  'dusks',
  'dusma',
  'dusmi',
  'dusms',
  'dussa',
  'dussi',
  'dusta',
  'dusti',
  'dusts',
  'dusør',
  'duttu',
  'dvala',
  'dvald',
  'dvali',
  'dvalt',
  'dveyl',
  'dvøld',
  'dvølt',
  'dvørg',
  'dygda',
  'dygga',
  'dyggi',
  'dyggu',
  'dygra',
  'dygða',
  'dylin',
  'dylið',
  'dylja',
  'dylji',
  'dylla',
  'dyllu',
  'dylna',
  'dylni',
  'dylnu',
  'dylst',
  'dylum',
  'dylur',
  'dymba',
  'dymbi',
  'dymbs',
  'dynda',
  'dyndi',
  'dyngd',
  'dyngi',
  'dyngt',
  'dynin',
  'dynur',
  'dyppa',
  'dyppi',
  'dyrgi',
  'dyrgt',
  'dyrka',
  'dyrki',
  'dysan',
  'dysin',
  'dysja',
  'dysta',
  'dysti',
  'dysts',
  'dysum',
  'dysur',
  'dáans',
  'dádýr',
  'dálan',
  'dálar',
  'dálað',
  'dálin',
  'dálið',
  'dálka',
  'dálki',
  'dálks',
  'dálum',
  'dámar',
  'dámað',
  'dámda',
  'dámdi',
  'dámds',
  'dámdu',
  'dámið',
  'dámst',
  'dámti',
  'dámtu',
  'dánan',
  'dánar',
  'dánað',
  'dánin',
  'dánir',
  'dánið',
  'dánum',
  'dánur',
  'dáran',
  'dárar',
  'dárað',
  'dárin',
  'dárið',
  'dárum',
  'dásan',
  'dásar',
  'dásin',
  'dásum',
  'dátan',
  'dátum',
  'dátur',
  'dáðar',
  'dáðin',
  'dáðir',
  'dáðum',
  'dældi',
  'dældu',
  'dælir',
  'dælið',
  'dælla',
  'dælli',
  'dællu',
  'dælra',
  'dæmda',
  'dæmdi',
  'dæmds',
  'dæmdu',
  'dæmis',
  'dæmið',
  'díkir',
  'díkis',
  'díkið',
  'díkja',
  'díkst',
  'díkta',
  'díkti',
  'díkts',
  'díktu',
  'dílan',
  'dílar',
  'dílin',
  'dílum',
  'dílur',
  'dílut',
  'dísar',
  'dísin',
  'dísum',
  'dólga',
  'dólgi',
  'dólgs',
  'dómar',
  'dómin',
  'dómum',
  'dómur',
  'dópar',
  'dópin',
  'dópum',
  'dópur',
  'dósar',
  'dósað',
  'dósin',
  'dósir',
  'dósið',
  'dósna',
  'dósni',
  'dósnu',
  'dósum',
  'dósut',
  'døbba',
  'døbbi',
  'døgga',
  'døggi',
  'døgna',
  'døgni',
  'døgns',
  'døgum',
  'døkka',
  'døkki',
  'døkku',
  'dølin',
  'dølið',
  'dølla',
  'dølli',
  'dølma',
  'dølmi',
  'dølna',
  'dølni',
  'dølnu',
  'dølsk',
  'dølum',
  'dømda',
  'dømdi',
  'dømds',
  'dømdu',
  'dømir',
  'dømis',
  'dømið',
  'dømma',
  'dømmi',
  'dømst',
  'dømum',
  'dønum',
  'døpla',
  'døpli',
  'døplu',
  'døpru',
  'døpul',
  'døpur',
  'døsan',
  'døsar',
  'døsil',
  'døsin',
  'døsið',
  'døsla',
  'døsli',
  'døsna',
  'døsni',
  'døsnu',
  'døsum',
  'døtla',
  'døtli',
  'døtra',
  'døtta',
  'døtti',
  'døtur',
  'døvin',
  'dúgva',
  'dúgvu',
  'dúkar',
  'dúkað',
  'dúkin',
  'dúkið',
  'dúkum',
  'dúkur',
  'dúnar',
  'dúnað',
  'dúnið',
  'dúnut',
  'dúrar',
  'dúrað',
  'dúrin',
  'dúrið',
  'dúrka',
  'dúrki',
  'dúrks',
  'dúrum',
  'dúrur',
  'dúsan',
  'dúsar',
  'dúsað',
  'dúsin',
  'dúsir',
  'dúsið',
  'dúsum',
  'dúsur',
  'dúvan',
  'dúvar',
  'dúvað',
  'dúvið',
  'dúvum',
  'dúvur',
  'dýggi',
  'dýggj',
  'dýkir',
  'dýkið',
  'dýkja',
  'dýkta',
  'dýkti',
  'dýkts',
  'dýktu',
  'dýnan',
  'dýnum',
  'dýnur',
  'dýpda',
  'dýpir',
  'dýpis',
  'dýpið',
  'dýpst',
  'dýpta',
  'dýpti',
  'dýpts',
  'dýptu',
  'dýpum',
  'dýran',
  'dýrar',
  'dýrað',
  'dýrda',
  'dýrir',
  'dýrið',
  'dýrka',
  'dýrki',
  'dýrum',
  'dýrur',
  'dýsan',
  'dýsum',
  'dýsur',
  'dývda',
  'dývdi',
  'dývds',
  'dývdu',
  'dývir',
  'dývið',
  'dývát',
  'edika',
  'ediki',
  'ediks',
  'edlan',
  'edlar',
  'edlað',
  'edlið',
  'edlum',
  'edlur',
  'edrúa',
  'edrúi',
  'edrús',
  'edrúu',
  'eftir',
  'eftna',
  'eftni',
  'egala',
  'egali',
  'egals',
  'egalt',
  'egalu',
  'egara',
  'egari',
  'eggin',
  'eggið',
  'eggja',
  'eggum',
  'egini',
  'egins',
  'egnan',
  'egnar',
  'egnað',
  'egnda',
  'egndi',
  'egnds',
  'egndu',
  'egnir',
  'egnið',
  'egnst',
  'egnum',
  'eigan',
  'eiggj',
  'eigið',
  'eigna',
  'eigni',
  'eignu',
  'eigst',
  'eigum',
  'eigur',
  'eikar',
  'eikin',
  'eikir',
  'eikja',
  'eikju',
  'eikum',
  'eimin',
  'eimur',
  'einar',
  'einda',
  'eingi',
  'einig',
  'einir',
  'einis',
  'einið',
  'einki',
  'einst',
  'einta',
  'einti',
  'eints',
  'eintu',
  'einum',
  'eirda',
  'eirdi',
  'eirds',
  'eirdu',
  'eirir',
  'eiris',
  'eirið',
  'eirna',
  'eirni',
  'eirnu',
  'eirst',
  'eirum',
  'eista',
  'eistu',
  'eitil',
  'eitir',
  'eitis',
  'eitið',
  'eitla',
  'eitli',
  'eitra',
  'eitri',
  'eitst',
  'eitta',
  'eittu',
  'eitum',
  'eitur',
  'eiðar',
  'eiðin',
  'eiðir',
  'eiðis',
  'eiðið',
  'eiðum',
  'eiður',
  'ekkan',
  'ekkin',
  'ekkja',
  'ekkju',
  'ekkoa',
  'ekkoi',
  'ekkos',
  'ekkóa',
  'ekkói',
  'ekkós',
  'eklar',
  'eklað',
  'eklið',
  'ekran',
  'ekrum',
  'ekrur',
  'eksam',
  'eksem',
  'eksið',
  'eksum',
  'ektar',
  'ektað',
  'ektið',
  'elbil',
  'eldan',
  'eldar',
  'eldað',
  'eldin',
  'eldir',
  'eldið',
  'eldra',
  'eldri',
  'eldru',
  'eldst',
  'eldum',
  'eldur',
  'elgar',
  'elgdi',
  'elgdu',
  'elgin',
  'elgir',
  'elgið',
  'elgja',
  'elgum',
  'elgur',
  'elita',
  'elitu',
  'eljan',
  'eljum',
  'eljur',
  'ellin',
  'elman',
  'elmum',
  'elmur',
  'elrir',
  'elris',
  'elrið',
  'elrum',
  'elska',
  'elski',
  'elsta',
  'elsti',
  'elsts',
  'elstu',
  'eltan',
  'eltar',
  'eltin',
  'eltir',
  'eltið',
  'eltna',
  'eltni',
  'eltnu',
  'eltst',
  'eltum',
  'eltur',
  'elvar',
  'elvda',
  'elvdi',
  'elvds',
  'elvdu',
  'elvin',
  'elvir',
  'elvis',
  'elvið',
  'elvst',
  'elvum',
  'elvur',
  'embar',
  'embør',
  'emira',
  'emiri',
  'emirs',
  'endan',
  'endar',
  'endað',
  'endin',
  'endir',
  'endið',
  'endst',
  'endum',
  'endur',
  'ennir',
  'ennis',
  'ennið',
  'ennnú',
  'enntá',
  'enntó',
  'enska',
  'enski',
  'ensks',
  'enskt',
  'ensku',
  'entir',
  'entið',
  'entur',
  'epikk',
  'epiks',
  'eplir',
  'eplis',
  'eplið',
  'eplum',
  'eplut',
  'epoka',
  'epoku',
  'erara',
  'erari',
  'eraru',
  'erast',
  'erfín',
  'ergan',
  'ergum',
  'ergur',
  'erlan',
  'erlig',
  'erlum',
  'erlur',
  'erman',
  'ermar',
  'ermin',
  'ermum',
  'ermur',
  'ernar',
  'ernir',
  'ernis',
  'ernið',
  'erpar',
  'erpað',
  'erpin',
  'erpið',
  'erpna',
  'erpni',
  'erpnu',
  'errar',
  'errað',
  'errin',
  'errið',
  'errum',
  'ersmá',
  'ertin',
  'ertið',
  'ertna',
  'ertni',
  'ertnu',
  'ertur',
  'ervir',
  'ervis',
  'ervið',
  'ervum',
  'esils',
  'esjan',
  'esjar',
  'esjað',
  'esjið',
  'eskja',
  'eskju',
  'eslið',
  'eslum',
  'espar',
  'espin',
  'espir',
  'espum',
  'essið',
  'essum',
  'estar',
  'estin',
  'etast',
  'etika',
  'etiki',
  'etikk',
  'etiks',
  'eting',
  'etins',
  'etisk',
  'etist',
  'etjar',
  'etjað',
  'etjið',
  'etnan',
  'etnar',
  'etnir',
  'etnum',
  'etrið',
  'etuda',
  'etudu',
  'eturs',
  'event',
  'eviga',
  'evigi',
  'evigs',
  'evigt',
  'evigu',
  'evjan',
  'evjar',
  'evjað',
  'evjið',
  'evjut',
  'evlar',
  'evlað',
  'evlið',
  'evnar',
  'evnað',
  'evnda',
  'evndi',
  'evnds',
  'evndu',
  'evnir',
  'evnis',
  'evnið',
  'evnst',
  'evnum',
  'evran',
  'evrum',
  'evrur',
  'evsta',
  'evsti',
  'evsts',
  'evstu',
  'eydna',
  'eydni',
  'eydnu',
  'eygað',
  'eygna',
  'eygnd',
  'eygni',
  'eygnt',
  'eygum',
  'eygur',
  'eygut',
  'eykan',
  'eykar',
  'eykað',
  'eykin',
  'eykið',
  'eykum',
  'eykut',
  'eyman',
  'eymar',
  'eymir',
  'eymka',
  'eymki',
  'eymks',
  'eymum',
  'eymur',
  'eyrar',
  'eyrað',
  'eyrin',
  'eyrur',
  'eyrut',
  'eyðir',
  'eyðið',
  'eyður',
  'fafta',
  'fafti',
  'fagna',
  'fagni',
  'fagra',
  'fagri',
  'fagur',
  'fakir',
  'fakið',
  'fakra',
  'fakri',
  'faksa',
  'faksi',
  'fakta',
  'fakti',
  'fakum',
  'fakur',
  'falda',
  'faldi',
  'falds',
  'falka',
  'falki',
  'falks',
  'falla',
  'falli',
  'falna',
  'falni',
  'falnu',
  'falsa',
  'falsi',
  'falsk',
  'falst',
  'fanan',
  'fanar',
  'fanga',
  'fangi',
  'fangs',
  'fanin',
  'fanna',
  'fansa',
  'fansi',
  'fanst',
  'fanta',
  'fanti',
  'fants',
  'fanum',
  'farga',
  'fargi',
  'fargs',
  'farin',
  'farið',
  'farma',
  'farmi',
  'farms',
  'farna',
  'farni',
  'farnu',
  'farra',
  'farri',
  'farru',
  'farsi',
  'farst',
  'farta',
  'farti',
  'farts',
  'farva',
  'farvu',
  'fasan',
  'fasta',
  'fasti',
  'fasts',
  'fasum',
  'fasur',
  'fasán',
  'fatal',
  'fatan',
  'fatar',
  'fatað',
  'fatið',
  'fatla',
  'fatli',
  'fatls',
  'fatna',
  'fatni',
  'fatra',
  'fatri',
  'fatta',
  'fatti',
  'fattu',
  'fatur',
  'fatøl',
  'favna',
  'favni',
  'favns',
  'faðir',
  'fedra',
  'fegin',
  'fegið',
  'fegna',
  'fegni',
  'fegnu',
  'feiar',
  'feiað',
  'feiga',
  'feigd',
  'feigi',
  'feigs',
  'feigt',
  'feigu',
  'feigð',
  'feiið',
  'feila',
  'feili',
  'feils',
  'feima',
  'feimi',
  'feims',
  'feimt',
  'feimu',
  'feira',
  'feiri',
  'feita',
  'feiti',
  'feits',
  'feitt',
  'feitu',
  'fekal',
  'fekst',
  'fekta',
  'fekti',
  'felag',
  'felan',
  'felar',
  'felda',
  'feldi',
  'felds',
  'feldu',
  'felga',
  'felgu',
  'felin',
  'fella',
  'felli',
  'fellu',
  'felst',
  'felta',
  'felti',
  'felts',
  'felum',
  'feløg',
  'fenan',
  'fenar',
  'fenað',
  'fenin',
  'fenir',
  'fenis',
  'fenið',
  'fenja',
  'fenol',
  'fenum',
  'fepri',
  'fepur',
  'ferga',
  'fergu',
  'feria',
  'feril',
  'feriu',
  'ferja',
  'ferji',
  'ferju',
  'ferli',
  'ferma',
  'fermd',
  'fermi',
  'ferms',
  'fermt',
  'fermu',
  'ferst',
  'ferða',
  'fesil',
  'fesja',
  'fesji',
  'fesju',
  'feska',
  'feski',
  'fesks',
  'feskt',
  'fesku',
  'fesla',
  'fesli',
  'festa',
  'festi',
  'fests',
  'festu',
  'fetan',
  'fetar',
  'fetað',
  'fetil',
  'fetin',
  'fetið',
  'fetla',
  'fetli',
  'fetst',
  'fetta',
  'fetti',
  'fettu',
  'fetum',
  'fevna',
  'fevnd',
  'fevni',
  'fevnt',
  'feyda',
  'feydi',
  'feðga',
  'fidus',
  'figur',
  'fikan',
  'fikka',
  'fikku',
  'fiksa',
  'fiksi',
  'fikst',
  'fiksu',
  'fikta',
  'fikti',
  'fikum',
  'fikur',
  'filar',
  'filað',
  'filið',
  'filla',
  'filli',
  'fillu',
  'filma',
  'filmi',
  'films',
  'filpa',
  'filpi',
  'filps',
  'fiman',
  'fimar',
  'fimir',
  'fimis',
  'fimið',
  'fimla',
  'fimlu',
  'fimma',
  'fimmu',
  'fimta',
  'fimti',
  'fimtu',
  'fimum',
  'fimur',
  'final',
  'fingu',
  'finka',
  'finki',
  'finku',
  'finnu',
  'finsk',
  'finst',
  'finta',
  'finti',
  'fintu',
  'fipan',
  'fipar',
  'fipað',
  'fipið',
  'fipla',
  'fipli',
  'firma',
  'firmu',
  'firna',
  'firni',
  'firra',
  'firri',
  'firru',
  'firta',
  'firti',
  'firði',
  'fisan',
  'fiska',
  'fiski',
  'fisks',
  'fisum',
  'fisur',
  'fitar',
  'fitað',
  'fitin',
  'fitið',
  'fitja',
  'fitji',
  'fitju',
  'fitla',
  'fitli',
  'fitlu',
  'fitna',
  'fitni',
  'fitta',
  'fitti',
  'fittu',
  'fiðri',
  'fióla',
  'fiúla',
  'fjakk',
  'fjaks',
  'fjala',
  'fjall',
  'fjals',
  'fjant',
  'fjara',
  'fjari',
  'fjars',
  'fjart',
  'fjaru',
  'fjasa',
  'fjasi',
  'fjesa',
  'fjesi',
  'fjáka',
  'fjáki',
  'fjáks',
  'fjálg',
  'fjóla',
  'fjóli',
  'fjóls',
  'fjólu',
  'fjóna',
  'fjóni',
  'fjóns',
  'fjósa',
  'fjósi',
  'fjøgg',
  'fjøgs',
  'fjøld',
  'fjøll',
  'fjøra',
  'fjøru',
  'fjørð',
  'fjøsa',
  'fjøsi',
  'fjøss',
  'fjúsa',
  'fjúsi',
  'flaga',
  'flagd',
  'flagg',
  'flagi',
  'flags',
  'flagu',
  'flaka',
  'flaki',
  'flakr',
  'flaks',
  'flakt',
  'flana',
  'flani',
  'flans',
  'flant',
  'flanu',
  'flata',
  'flati',
  'flats',
  'flatt',
  'fleki',
  'flekk',
  'fleks',
  'flenn',
  'flens',
  'flent',
  'flesa',
  'flesk',
  'flest',
  'fleta',
  'flets',
  'flett',
  'fleyg',
  'fleyr',
  'fleyt',
  'flika',
  'fliki',
  'flikr',
  'fliku',
  'flipp',
  'flips',
  'fliða',
  'fliðu',
  'fljót',
  'fljóð',
  'fljúg',
  'flogi',
  'flogs',
  'floka',
  'floki',
  'flokk',
  'floks',
  'flora',
  'floru',
  'flota',
  'floti',
  'flots',
  'flott',
  'flova',
  'flovi',
  'flovs',
  'flovt',
  'flovu',
  'floya',
  'floyi',
  'floym',
  'floys',
  'floyt',
  'fluga',
  'flugu',
  'flukt',
  'flusa',
  'flusi',
  'flust',
  'fluts',
  'flutt',
  'flutu',
  'flysa',
  'flysi',
  'flyst',
  'flyta',
  'flyti',
  'fláan',
  'fláar',
  'fláað',
  'fláin',
  'fláir',
  'fláið',
  'fláka',
  'fláki',
  'flákr',
  'flána',
  'fláni',
  'flátt',
  'fláum',
  'fláur',
  'flæir',
  'flæið',
  'flæsa',
  'flæsu',
  'flætt',
  'flími',
  'flíms',
  'flísa',
  'flísi',
  'flógv',
  'flóka',
  'flóki',
  'flóks',
  'flóna',
  'flóni',
  'flóra',
  'flóri',
  'flórs',
  'flósa',
  'flósi',
  'flóta',
  'flóti',
  'flóts',
  'flótt',
  'flótu',
  'flóða',
  'flóði',
  'flóðs',
  'fløar',
  'fløað',
  'flødd',
  'fløds',
  'fløga',
  'fløgd',
  'fløgg',
  'fløgi',
  'fløgu',
  'fløið',
  'fløki',
  'fløkt',
  'fløta',
  'fløti',
  'fløts',
  'fløtt',
  'fløtu',
  'fløur',
  'fløva',
  'fløvi',
  'fløvu',
  'fløða',
  'fløði',
  'flúga',
  'flúgi',
  'flúgv',
  'flúra',
  'flúri',
  'flúrs',
  'flúsa',
  'flúsi',
  'flýdd',
  'flýds',
  'flýst',
  'flýtt',
  'fnisa',
  'fnisi',
  'fnýsa',
  'fnýsi',
  'fnýst',
  'fokin',
  'fokið',
  'fokka',
  'fokki',
  'fokku',
  'fokna',
  'fokni',
  'foknu',
  'foksa',
  'foksi',
  'fokum',
  'fokus',
  'folan',
  'folar',
  'folað',
  'folda',
  'foldi',
  'folds',
  'folin',
  'folið',
  'fonar',
  'fonað',
  'fonda',
  'fondi',
  'fonds',
  'fonem',
  'fongd',
  'fongi',
  'fongs',
  'fongt',
  'fonið',
  'fonum',
  'foran',
  'forar',
  'forað',
  'forbí',
  'forin',
  'forið',
  'forma',
  'formi',
  'forms',
  'forna',
  'forni',
  'forns',
  'fornt',
  'fornu',
  'forsa',
  'forsi',
  'forta',
  'forti',
  'forts',
  'fortu',
  'forum',
  'forur',
  'forða',
  'forði',
  'fossa',
  'fossi',
  'fotoa',
  'fotoi',
  'fotos',
  'foyan',
  'foyar',
  'foyir',
  'foyki',
  'foykt',
  'foyra',
  'foyri',
  'foyru',
  'foysa',
  'foysi',
  'foyst',
  'foytt',
  'foyum',
  'foyur',
  'fragd',
  'frama',
  'framd',
  'frami',
  'frams',
  'framt',
  'framá',
  'framí',
  'frasa',
  'frasi',
  'frasu',
  'frata',
  'frati',
  'fregn',
  'freka',
  'freki',
  'frekk',
  'freks',
  'frekt',
  'freku',
  'frell',
  'frels',
  'frens',
  'fresa',
  'fresi',
  'fress',
  'frest',
  'freta',
  'freti',
  'fretl',
  'frets',
  'fritt',
  'friða',
  'friði',
  'fromu',
  'front',
  'frosa',
  'frosi',
  'frosk',
  'frost',
  'froys',
  'froyð',
  'froða',
  'froði',
  'froðu',
  'frukt',
  'frunt',
  'frygd',
  'frykt',
  'fryns',
  'fryst',
  'fræar',
  'fræað',
  'fræga',
  'frægd',
  'frægi',
  'frægs',
  'frægt',
  'frægu',
  'fræið',
  'fræls',
  'fræna',
  'fræts',
  'frætt',
  'fræum',
  'frían',
  'fríar',
  'fríað',
  'fríir',
  'fríið',
  'frísa',
  'frísi',
  'frísk',
  'frísu',
  'frítt',
  'fríum',
  'fríur',
  'fríðs',
  'fróan',
  'fróar',
  'fróir',
  'fróma',
  'frómi',
  'fróms',
  'frómt',
  'frómu',
  'frótt',
  'fróum',
  'fróur',
  'fróðs',
  'frøar',
  'frøin',
  'frøir',
  'frøið',
  'frøst',
  'frøtt',
  'frøum',
  'frøða',
  'frøði',
  'frúan',
  'frúar',
  'frúgv',
  'frúin',
  'frúir',
  'frúum',
  'frúur',
  'frýni',
  'frýns',
  'frýnt',
  'frýsa',
  'frýsi',
  'frýst',
  'fubba',
  'fubbi',
  'fugan',
  'fugar',
  'fugað',
  'fugið',
  'fugla',
  'fugli',
  'fugls',
  'fugum',
  'fugur',
  'fukka',
  'fukki',
  'fulla',
  'fulli',
  'fullu',
  'fulpa',
  'fulpi',
  'fulps',
  'fulra',
  'fumma',
  'fummi',
  'fummu',
  'funan',
  'funda',
  'fundi',
  'funin',
  'funka',
  'funki',
  'funks',
  'funku',
  'funna',
  'funni',
  'funnu',
  'funsa',
  'funsi',
  'funta',
  'funti',
  'funts',
  'fuppa',
  'fuppi',
  'furan',
  'furar',
  'furað',
  'furið',
  'furum',
  'furur',
  'furða',
  'furðu',
  'fuska',
  'fuski',
  'fussa',
  'fussi',
  'futta',
  'futti',
  'fuvan',
  'fuvar',
  'fuvað',
  'fygla',
  'fygli',
  'fyglt',
  'fylgd',
  'fylgi',
  'fylgt',
  'fylið',
  'fylja',
  'fylki',
  'fylkt',
  'fylla',
  'fylli',
  'fyllu',
  'fylra',
  'fylri',
  'fylru',
  'fylst',
  'fylta',
  'fylti',
  'fylts',
  'fyltu',
  'fylum',
  'fyrna',
  'fyrnd',
  'fyrni',
  'fyrnt',
  'fyrra',
  'fyrri',
  'fyrru',
  'fyrst',
  'fytin',
  'fáari',
  'fáast',
  'fáins',
  'fáist',
  'fálig',
  'fálka',
  'fálki',
  'fálks',
  'fálma',
  'fálmi',
  'fálát',
  'fámar',
  'fámað',
  'fámið',
  'fámum',
  'fánan',
  'fánar',
  'fánað',
  'fánin',
  'fánir',
  'fánið',
  'fánum',
  'fánut',
  'fánýt',
  'fáran',
  'fárar',
  'fárin',
  'fárið',
  'fárum',
  'fátti',
  'fátæk',
  'fækka',
  'fækki',
  'fælut',
  'fænum',
  'færra',
  'færri',
  'færru',
  'fæsta',
  'fæsti',
  'fæsts',
  'fæstu',
  'fíggi',
  'fílan',
  'fílar',
  'fílað',
  'fílin',
  'fílir',
  'fílið',
  'fílla',
  'fílli',
  'fílum',
  'fílur',
  'fínan',
  'fínar',
  'fínir',
  'fínka',
  'fínki',
  'fínum',
  'fínur',
  'fírda',
  'fírdi',
  'fírds',
  'fírdu',
  'fírir',
  'fírið',
  'fírst',
  'físan',
  'físar',
  'físin',
  'físir',
  'físið',
  'físna',
  'físni',
  'físnu',
  'físpa',
  'físpi',
  'físta',
  'físti',
  'físts',
  'fístu',
  'físum',
  'físur',
  'fívil',
  'fívla',
  'fívli',
  'fóata',
  'fóati',
  'fólka',
  'fólki',
  'fólks',
  'fólsk',
  'fómar',
  'fómað',
  'fómin',
  'fómið',
  'fómur',
  'fóran',
  'fórst',
  'fótar',
  'fótað',
  'fótin',
  'fótið',
  'fótum',
  'fótur',
  'fóðra',
  'fóðri',
  'fóður',
  'fødda',
  'føddi',
  'føddu',
  'føgru',
  'føgur',
  'føkru',
  'føkur',
  'følda',
  'føldi',
  'følds',
  'føldu',
  'følin',
  'følir',
  'følið',
  'følna',
  'følni',
  'følnu',
  'følsk',
  'følst',
  'følva',
  'følvi',
  'følvs',
  'føran',
  'førar',
  'førda',
  'førdi',
  'førds',
  'førdu',
  'førir',
  'føris',
  'førið',
  'førka',
  'førki',
  'førna',
  'førni',
  'først',
  'førum',
  'førur',
  'føsil',
  'føsla',
  'føsli',
  'føsta',
  'føstu',
  'føtil',
  'føtla',
  'føtli',
  'føtra',
  'føtta',
  'føtti',
  'føttu',
  'føtum',
  'føtur',
  'føðga',
  'føðgi',
  'føðin',
  'føðir',
  'føðið',
  'føðst',
  'føður',
  'fúgva',
  'fúgvi',
  'fúkið',
  'fúlan',
  'fúlar',
  'fúlir',
  'fúlna',
  'fúlni',
  'fúlum',
  'fúlur',
  'fúnan',
  'fúnar',
  'fúnað',
  'fúnir',
  'fúnið',
  'fúnum',
  'fúsan',
  'fúsar',
  'fúsin',
  'fúsir',
  'fúsra',
  'fússa',
  'fússi',
  'fúsum',
  'fúsur',
  'fútan',
  'fútar',
  'fútin',
  'fútum',
  'fýkur',
  'fýlan',
  'fýlin',
  'fýlið',
  'fýlna',
  'fýlni',
  'fýlnu',
  'fýlst',
  'fýlum',
  'fýlur',
  'fýrar',
  'fýrda',
  'fýrdi',
  'fýrds',
  'fýrdu',
  'fýrik',
  'fýrin',
  'fýrið',
  'fýrna',
  'fýrni',
  'fýrnu',
  'fýrsa',
  'fýrsu',
  'fýrum',
  'fýrur',
  'fýsin',
  'fýsir',
  'fýsið',
  'fýsna',
  'fýsni',
  'fýsnu',
  'fýsta',
  'fýsti',
  'fýsts',
  'fýstu',
  'gabba',
  'gabbi',
  'gadda',
  'gaddi',
  'gafla',
  'gafli',
  'gagga',
  'gaggi',
  'gaggu',
  'gagna',
  'gagni',
  'gagns',
  'galda',
  'galdi',
  'galin',
  'galið',
  'galla',
  'gallu',
  'galna',
  'galni',
  'galnu',
  'galst',
  'galta',
  'galti',
  'galts',
  'galum',
  'galva',
  'galvi',
  'galvs',
  'gamal',
  'gaman',
  'gamla',
  'gamli',
  'gamma',
  'gammi',
  'gamni',
  'gampa',
  'gampi',
  'gamps',
  'ganda',
  'gandi',
  'gands',
  'ganga',
  'gangi',
  'gangs',
  'ganir',
  'ganum',
  'gapar',
  'gapað',
  'gapið',
  'gapum',
  'gaput',
  'garma',
  'garmi',
  'garms',
  'garna',
  'garni',
  'garns',
  'garpa',
  'garpi',
  'garps',
  'garta',
  'garti',
  'garts',
  'garva',
  'garvi',
  'garða',
  'garði',
  'garðs',
  'gassa',
  'gassi',
  'gatan',
  'gatar',
  'gatað',
  'gatið',
  'gatna',
  'gatst',
  'gatum',
  'gatur',
  'gatut',
  'gavni',
  'gavsa',
  'gavsi',
  'gavst',
  'gedda',
  'geddu',
  'gefoy',
  'geggi',
  'geggj',
  'gegla',
  'gegli',
  'gegls',
  'gegna',
  'gegnd',
  'gegni',
  'gegnt',
  'gehør',
  'geila',
  'geipa',
  'geipi',
  'geips',
  'geipu',
  'geisa',
  'geisp',
  'geisu',
  'geita',
  'gekka',
  'gekki',
  'gekst',
  'gelda',
  'geldi',
  'gelds',
  'geldu',
  'gelið',
  'gella',
  'gelli',
  'gellu',
  'gelti',
  'geltu',
  'gelum',
  'gelur',
  'gemsa',
  'gemsu',
  'genar',
  'genað',
  'genið',
  'genom',
  'genta',
  'gentu',
  'gerar',
  'gerað',
  'gerdi',
  'gerds',
  'geril',
  'gerin',
  'gerið',
  'gerla',
  'gerli',
  'gerst',
  'gerva',
  'gervi',
  'gerða',
  'gerði',
  'gerðs',
  'gerðu',
  'gesna',
  'gesni',
  'gesnu',
  'gessa',
  'gessi',
  'gesta',
  'gesti',
  'gests',
  'gever',
  'gevið',
  'gevst',
  'gevur',
  'geyka',
  'geyki',
  'geykn',
  'geyks',
  'geyla',
  'geyli',
  'geyls',
  'geyma',
  'geymi',
  'geyms',
  'geypa',
  'geypu',
  'geyra',
  'geyri',
  'geyrs',
  'geyst',
  'geyta',
  'geyti',
  'gidda',
  'giddi',
  'gifta',
  'gifti',
  'gifts',
  'giftu',
  'gigga',
  'giggu',
  'gigla',
  'gigli',
  'gigna',
  'gilda',
  'gildi',
  'gilds',
  'gildu',
  'gilið',
  'gilja',
  'gilka',
  'gilki',
  'gilla',
  'gilli',
  'gillu',
  'gilsa',
  'gilsi',
  'gilum',
  'giman',
  'gimar',
  'gimað',
  'gimin',
  'gimið',
  'gimsa',
  'gimsi',
  'ginar',
  'ginað',
  'gingu',
  'ginið',
  'ginna',
  'ginni',
  'ginta',
  'ginti',
  'gints',
  'gintu',
  'ginum',
  'gipar',
  'gipin',
  'gippa',
  'gippi',
  'gipsa',
  'gipsi',
  'gipum',
  'gipur',
  'girar',
  'girað',
  'girda',
  'girdi',
  'girds',
  'girdu',
  'girið',
  'girnd',
  'girum',
  'girða',
  'girði',
  'gisar',
  'gisað',
  'gisin',
  'gisið',
  'gisla',
  'gisli',
  'gisna',
  'gisni',
  'gisnu',
  'gissa',
  'gissi',
  'gista',
  'gisti',
  'gistu',
  'gitan',
  'gitar',
  'gitin',
  'gitið',
  'gitna',
  'gitni',
  'gitnu',
  'gitur',
  'givin',
  'givið',
  'givna',
  'givni',
  'givnu',
  'gjala',
  'gjald',
  'gjali',
  'gjall',
  'gjals',
  'gjalt',
  'gjara',
  'gjari',
  'gjars',
  'gjaur',
  'gjums',
  'gjáar',
  'gjáin',
  'gjáir',
  'gjálv',
  'gjáum',
  'gjógv',
  'gjóin',
  'gjósa',
  'gjósi',
  'gjóta',
  'gjóti',
  'gjótu',
  'gjøld',
  'gjøll',
  'gjøls',
  'gjølt',
  'gjøra',
  'gjørd',
  'gjørs',
  'gjørt',
  'gjørð',
  'gjøtl',
  'glamm',
  'glamp',
  'glams',
  'glana',
  'gland',
  'glani',
  'glans',
  'glant',
  'glapp',
  'glara',
  'glari',
  'glars',
  'glasa',
  'glasi',
  'glata',
  'glati',
  'glatt',
  'glaða',
  'glaði',
  'glaðs',
  'glaðu',
  'glefs',
  'gleim',
  'gleiv',
  'gleið',
  'glenn',
  'glent',
  'glepp',
  'gleps',
  'glera',
  'gleri',
  'glers',
  'glett',
  'gleða',
  'gleði',
  'glint',
  'glips',
  'glisa',
  'glisi',
  'gliti',
  'glits',
  'gliðu',
  'glopa',
  'glopi',
  'glopp',
  'glopr',
  'glops',
  'glosa',
  'glosi',
  'glosu',
  'glots',
  'glott',
  'gloym',
  'gloyp',
  'glugg',
  'glugs',
  'glumt',
  'glunt',
  'glups',
  'glygg',
  'glygs',
  'glæma',
  'glæmu',
  'glæra',
  'glæri',
  'glærs',
  'glært',
  'glæru',
  'glæst',
  'glíma',
  'glími',
  'glímt',
  'glímu',
  'glípa',
  'glípi',
  'glíps',
  'glísa',
  'glísu',
  'glíða',
  'glíði',
  'glógv',
  'glóma',
  'glómi',
  'glómu',
  'glóra',
  'glóri',
  'glórs',
  'glósa',
  'glósi',
  'glósu',
  'glóða',
  'glødd',
  'gløds',
  'gløgg',
  'gløgs',
  'gløgt',
  'gløir',
  'gløið',
  'gløst',
  'gløtt',
  'gløða',
  'gløði',
  'glúpa',
  'glúpi',
  'glúps',
  'glýpa',
  'glýpi',
  'glýps',
  'glýsa',
  'glýsu',
  'gnadd',
  'gnads',
  'gnaga',
  'gnagi',
  'gnags',
  'gnegs',
  'gneis',
  'gnell',
  'gnelt',
  'gnisa',
  'gnisi',
  'gnoma',
  'gnomi',
  'gnoms',
  'gníst',
  'gnúpa',
  'gnúpi',
  'gnúps',
  'gnýin',
  'gnýið',
  'gnýur',
  'goffa',
  'goffi',
  'gogga',
  'goggi',
  'goggu',
  'goksa',
  'goksi',
  'golfi',
  'golfs',
  'gomlu',
  'gomul',
  'gonga',
  'gongd',
  'gongt',
  'gongu',
  'gonna',
  'gonni',
  'goran',
  'gorar',
  'gorað',
  'gorið',
  'gorpa',
  'gorpi',
  'gorps',
  'gorra',
  'gorri',
  'gorut',
  'gosin',
  'gosið',
  'gosna',
  'gosni',
  'gosnu',
  'gosop',
  'gosum',
  'gotan',
  'gotar',
  'gotað',
  'gotin',
  'gotið',
  'gotra',
  'gotri',
  'gotum',
  'gotur',
  'goyan',
  'goyma',
  'goymd',
  'goymi',
  'goyms',
  'goymt',
  'goyrt',
  'goysa',
  'goysi',
  'goyst',
  'goyum',
  'goyur',
  'goyði',
  'goyðu',
  'goðan',
  'goðar',
  'goðin',
  'goðum',
  'grafa',
  'grafi',
  'grafs',
  'gragg',
  'grags',
  'grama',
  'grami',
  'graml',
  'gramm',
  'grams',
  'gramt',
  'grana',
  'grand',
  'grann',
  'grans',
  'grant',
  'graps',
  'grasa',
  'grasi',
  'gratt',
  'grava',
  'gravi',
  'graða',
  'graði',
  'graðs',
  'graðu',
  'grein',
  'greið',
  'grell',
  'grels',
  'grena',
  'grend',
  'greni',
  'grenj',
  'grens',
  'grent',
  'grenu',
  'grepi',
  'grepp',
  'greps',
  'gresj',
  'grett',
  'greva',
  'grevi',
  'grevs',
  'greyt',
  'greði',
  'grift',
  'grima',
  'grimi',
  'grimm',
  'grims',
  'grimt',
  'grimu',
  'grina',
  'grind',
  'grini',
  'grinu',
  'gripa',
  'gripi',
  'grips',
  'gripu',
  'grisa',
  'grisi',
  'grisk',
  'griði',
  'gromm',
  'gromu',
  'grona',
  'groni',
  'gronn',
  'grova',
  'grovi',
  'grovs',
  'grovt',
  'grovu',
  'groyp',
  'groys',
  'grubb',
  'grubs',
  'grugg',
  'grugs',
  'grulv',
  'grumd',
  'grumm',
  'grums',
  'grumt',
  'gruna',
  'grund',
  'gruni',
  'grunn',
  'gruns',
  'grunt',
  'grupa',
  'grusm',
  'grutt',
  'grynn',
  'grynt',
  'gryði',
  'gráan',
  'gráar',
  'gráað',
  'gráir',
  'gráið',
  'grána',
  'gráni',
  'gráta',
  'gráti',
  'gráts',
  'grátt',
  'gráum',
  'gráur',
  'gráva',
  'grávu',
  'gráða',
  'gráði',
  'græla',
  'græli',
  'gríma',
  'grími',
  'grímt',
  'grímu',
  'grína',
  'gríni',
  'grípa',
  'grípi',
  'grísa',
  'grísi',
  'grísk',
  'grísl',
  'grógv',
  'gróin',
  'gróið',
  'gróma',
  'grómi',
  'grómu',
  'gróna',
  'gróni',
  'gróns',
  'grónu',
  'grópa',
  'grópi',
  'gróps',
  'grópu',
  'gróti',
  'gróts',
  'grótu',
  'gróum',
  'gróvu',
  'gróði',
  'gróðu',
  'grødd',
  'grøds',
  'grøna',
  'grøni',
  'grøns',
  'grønt',
  'grønu',
  'grørt',
  'grøtt',
  'grøva',
  'grøvi',
  'grøvu',
  'grøða',
  'grøði',
  'grúka',
  'grúki',
  'grúks',
  'grúpa',
  'grúsa',
  'grúsi',
  'grúva',
  'grúvu',
  'grýla',
  'grýlu',
  'grýna',
  'grýni',
  'grýns',
  'grýta',
  'grýti',
  'grýts',
  'grýtt',
  'grýtu',
  'gubba',
  'gubbi',
  'gudar',
  'gudað',
  'gudin',
  'gudið',
  'gudum',
  'gudur',
  'gulan',
  'gular',
  'gulað',
  'guldu',
  'gulir',
  'gulið',
  'gulla',
  'gulli',
  'gullu',
  'gulna',
  'gulni',
  'gulum',
  'gulur',
  'gulut',
  'gumma',
  'gummi',
  'gummu',
  'gumpa',
  'gumpi',
  'gumps',
  'gurka',
  'gurku',
  'gurla',
  'gurli',
  'gusan',
  'guvan',
  'guvar',
  'guvað',
  'guvin',
  'guvir',
  'guvið',
  'guvum',
  'guvur',
  'gvagg',
  'gygdi',
  'gyggi',
  'gykla',
  'gykli',
  'gykls',
  'gylla',
  'gylli',
  'gylta',
  'gylti',
  'gylts',
  'gyltu',
  'gynga',
  'gyngu',
  'gyrda',
  'gyrdi',
  'gyrds',
  'gyrdu',
  'gyrða',
  'gyrði',
  'gyðja',
  'gyðju',
  'gáans',
  'gáaði',
  'gáaðu',
  'gáddi',
  'gáddu',
  'gágga',
  'gággu',
  'gáins',
  'gákan',
  'gákar',
  'gákað',
  'gákin',
  'gákið',
  'gákum',
  'gákur',
  'gákut',
  'gálga',
  'gálgi',
  'gálva',
  'gálvi',
  'gálvs',
  'gánan',
  'gánar',
  'gánað',
  'gánir',
  'gánið',
  'gánum',
  'gánus',
  'gásar',
  'gásin',
  'gásum',
  'gátan',
  'gátta',
  'gátum',
  'gátur',
  'gávan',
  'gávað',
  'gávum',
  'gávur',
  'gávut',
  'gænir',
  'gænum',
  'gærar',
  'gærað',
  'gærdi',
  'gærdu',
  'gærin',
  'gærir',
  'gærið',
  'gærna',
  'gærni',
  'gærnu',
  'gærut',
  'gæsan',
  'gæsar',
  'gæsað',
  'gæsin',
  'gæsið',
  'gæsna',
  'gæsni',
  'gæsnu',
  'gæsum',
  'gæsur',
  'gæsut',
  'gætur',
  'gævan',
  'gævar',
  'gævig',
  'gævir',
  'gævum',
  'gævur',
  'gíggi',
  'gíggj',
  'gírig',
  'gírin',
  'gírið',
  'gírna',
  'gírni',
  'gírnu',
  'gírug',
  'gísla',
  'gísli',
  'gívin',
  'gívið',
  'gívna',
  'gívni',
  'gívnu',
  'gívra',
  'gívri',
  'gívur',
  'gókar',
  'gókað',
  'gókið',
  'gólan',
  'gólar',
  'gólað',
  'gólið',
  'gólst',
  'gólum',
  'gólvi',
  'gólvs',
  'gómar',
  'gómin',
  'gómum',
  'gómur',
  'góran',
  'górar',
  'górin',
  'górum',
  'górur',
  'górut',
  'gótar',
  'gótað',
  'gótið',
  'góðan',
  'góðar',
  'góðga',
  'góðgi',
  'góðin',
  'góðir',
  'góðum',
  'góður',
  'gødda',
  'gøddi',
  'gøddu',
  'gøini',
  'gølan',
  'gølti',
  'gølum',
  'gølur',
  'gønum',
  'gørta',
  'gørti',
  'gørts',
  'gøsól',
  'gøtan',
  'gøtum',
  'gøtur',
  'gøvig',
  'gøvug',
  'gøðir',
  'gøðið',
  'gøðst',
  'gúppa',
  'gúppi',
  'gýsir',
  'gýsið',
  'gýsti',
  'gýstu',
  'gýsur',
  'gýtan',
  'gýtir',
  'gýtið',
  'gýtst',
  'gýtta',
  'gýtti',
  'gýtts',
  'gýttu',
  'gýtum',
  'gýtur',
  'gývil',
  'gývli',
  'gýðgi',
  'hafta',
  'hafti',
  'hafts',
  'hagan',
  'hagar',
  'hagað',
  'hagga',
  'haggi',
  'hagin',
  'hagir',
  'hagið',
  'hagla',
  'hagli',
  'hagls',
  'hagra',
  'hagri',
  'hagum',
  'hagur',
  'haiar',
  'haiað',
  'haiið',
  'hakan',
  'hakar',
  'hakað',
  'hakin',
  'hakið',
  'hakka',
  'hakki',
  'hakum',
  'halal',
  'halan',
  'halar',
  'halda',
  'haldi',
  'halds',
  'halga',
  'halgi',
  'halgu',
  'halin',
  'halla',
  'halli',
  'halló',
  'halra',
  'halsa',
  'halsi',
  'halta',
  'halti',
  'halts',
  'halum',
  'hamar',
  'hamað',
  'hamin',
  'hamir',
  'hamið',
  'hamla',
  'hamli',
  'hamma',
  'hammi',
  'hampa',
  'hampi',
  'hamps',
  'hamra',
  'hamri',
  'hamsa',
  'hamsi',
  'hamum',
  'hamur',
  'hanan',
  'hanar',
  'handa',
  'handi',
  'hanga',
  'hangi',
  'hanin',
  'hanka',
  'hanna',
  'hanni',
  'hanum',
  'happa',
  'happi',
  'haran',
  'harav',
  'harka',
  'harki',
  'harks',
  'harma',
  'harmi',
  'harms',
  'harmt',
  'harpa',
  'harpu',
  'harra',
  'harri',
  'harta',
  'harti',
  'harum',
  'harur',
  'harva',
  'harvi',
  'harvu',
  'harða',
  'harði',
  'harðs',
  'hasar',
  'hasin',
  'hasir',
  'haska',
  'haski',
  'hassj',
  'hasta',
  'hasti',
  'hasts',
  'hasum',
  'hatar',
  'hatað',
  'hatið',
  'hatri',
  'hatsk',
  'hatta',
  'hatti',
  'hatur',
  'havan',
  'havar',
  'havda',
  'havdi',
  'havds',
  'havdu',
  'havin',
  'havið',
  'havna',
  'havni',
  'havra',
  'havri',
  'havst',
  'havum',
  'havur',
  'havál',
  'havís',
  'haðan',
  'hedda',
  'heddi',
  'hefta',
  'hefti',
  'hefts',
  'heftu',
  'hegla',
  'hegli',
  'hegls',
  'hegna',
  'hegni',
  'hegnt',
  'hegra',
  'hegri',
  'heiar',
  'heiað',
  'heiið',
  'heila',
  'heild',
  'heili',
  'heils',
  'heilt',
  'heilu',
  'heima',
  'heimi',
  'heims',
  'heimá',
  'heita',
  'heiti',
  'heits',
  'heitt',
  'heitu',
  'heiða',
  'heiði',
  'heiðs',
  'hekil',
  'hekka',
  'hekku',
  'hekla',
  'hekli',
  'hekls',
  'heksa',
  'heksi',
  'hekst',
  'hekta',
  'hekti',
  'heldi',
  'helds',
  'helin',
  'helja',
  'helji',
  'helju',
  'hella',
  'helli',
  'hellu',
  'helma',
  'helmi',
  'helró',
  'helsa',
  'helsi',
  'helst',
  'helta',
  'helti',
  'heltn',
  'helts',
  'heltu',
  'helvt',
  'hemar',
  'hemir',
  'hemis',
  'hemið',
  'hemla',
  'hemlu',
  'hemra',
  'hemri',
  'hemum',
  'henda',
  'hendi',
  'hends',
  'hendt',
  'hendu',
  'henni',
  'henta',
  'henti',
  'hents',
  'hentu',
  'hepna',
  'hepni',
  'hepnu',
  'herda',
  'herdi',
  'herds',
  'herdu',
  'herir',
  'herið',
  'herja',
  'herji',
  'herju',
  'herki',
  'herkt',
  'herma',
  'hermd',
  'hermi',
  'hermt',
  'hersa',
  'hersi',
  'herða',
  'herði',
  'herðu',
  'hesar',
  'hesin',
  'hesir',
  'hesja',
  'hesju',
  'hesli',
  'hespa',
  'hespi',
  'hespu',
  'hesta',
  'hesti',
  'hests',
  'hesum',
  'hetja',
  'hetju',
  'hetsa',
  'hetsi',
  'hetta',
  'hettu',
  'hevda',
  'hevdi',
  'hevna',
  'hevnd',
  'hevni',
  'hevnt',
  'hevst',
  'hevur',
  'hevði',
  'heyar',
  'heyað',
  'heyga',
  'heygg',
  'heygi',
  'heygs',
  'heyið',
  'heyka',
  'heyki',
  'heyks',
  'heysa',
  'heysi',
  'heyst',
  'higar',
  'higst',
  'hikka',
  'hikki',
  'hildu',
  'hilka',
  'hilki',
  'hilla',
  'hilli',
  'hilni',
  'himin',
  'himla',
  'himli',
  'himna',
  'himni',
  'himnu',
  'himpa',
  'himpr',
  'himpu',
  'hinar',
  'hinda',
  'hingu',
  'hinir',
  'hinka',
  'hinki',
  'hinks',
  'hinna',
  'hinnu',
  'hinsa',
  'hinsi',
  'hinum',
  'hipna',
  'hipni',
  'hipnu',
  'hippa',
  'hippi',
  'hirda',
  'hirdi',
  'hirds',
  'hirdu',
  'hirja',
  'hirju',
  'hirsa',
  'hirsi',
  'hirti',
  'hirtu',
  'hirða',
  'hirði',
  'hista',
  'histi',
  'hists',
  'hitan',
  'hitar',
  'hitað',
  'hitil',
  'hitin',
  'hitið',
  'hitla',
  'hitli',
  'hitna',
  'hitni',
  'hitnu',
  'hitst',
  'hitta',
  'hitti',
  'hittu',
  'hivar',
  'hivað',
  'hivið',
  'hivna',
  'hivni',
  'hivum',
  'hiðan',
  'hjall',
  'hjals',
  'hjalt',
  'hjara',
  'hjari',
  'hjarr',
  'hjars',
  'hjelm',
  'hjuli',
  'hjuls',
  'hjálm',
  'hjálp',
  'hjána',
  'hjáni',
  'hjááa',
  'hjáær',
  'hjáóm',
  'hjóla',
  'hjóli',
  'hjóls',
  'hjóma',
  'hjómi',
  'hjóms',
  'hjóst',
  'hjølt',
  'hjørn',
  'hjørt',
  'hjørð',
  'hjúka',
  'hjúki',
  'hjúli',
  'hjúls',
  'hjúna',
  'hjúni',
  'hjúns',
  'hjúpa',
  'hjúpu',
  'hobba',
  'hobbi',
  'hokin',
  'hokið',
  'hokka',
  'hokki',
  'hokna',
  'hokni',
  'hoknu',
  'hokra',
  'hokri',
  'holan',
  'holar',
  'holað',
  'holda',
  'holdi',
  'holds',
  'holið',
  'holla',
  'holli',
  'hollu',
  'holra',
  'holum',
  'holur',
  'holut',
  'holva',
  'holvd',
  'holvi',
  'holvt',
  'homla',
  'homlu',
  'honar',
  'honin',
  'honir',
  'honka',
  'honki',
  'honum',
  'hopar',
  'hopað',
  'hopið',
  'hoppa',
  'hoppi',
  'hopra',
  'hopri',
  'hopum',
  'horan',
  'horið',
  'horna',
  'horni',
  'horns',
  'horræ',
  'horum',
  'horur',
  'horva',
  'horvi',
  'horvt',
  'hosan',
  'hosar',
  'hosað',
  'hosið',
  'hosja',
  'hosji',
  'hosna',
  'hosta',
  'hosti',
  'hosts',
  'hosum',
  'hosur',
  'hovin',
  'hovið',
  'hovna',
  'hovni',
  'hovnu',
  'hovum',
  'hoyið',
  'hoyki',
  'hoykt',
  'hoyna',
  'hoyni',
  'hoyra',
  'hoyrd',
  'hoyri',
  'hoyrn',
  'hoyrt',
  'hoyum',
  'hugan',
  'hugar',
  'hugað',
  'hugda',
  'hugdi',
  'hugds',
  'hugdu',
  'hugin',
  'hugir',
  'hugið',
  'hugla',
  'hugli',
  'hugna',
  'hugni',
  'hugró',
  'hugsa',
  'hugsi',
  'hugst',
  'hugum',
  'hugur',
  'hulan',
  'hular',
  'hulda',
  'huldi',
  'hulds',
  'huldu',
  'hulin',
  'hulir',
  'hulið',
  'hulna',
  'hulni',
  'hulnu',
  'hulst',
  'hulum',
  'hulur',
  'humla',
  'humli',
  'humlu',
  'hunda',
  'hundi',
  'hunds',
  'huppa',
  'huppi',
  'huran',
  'huria',
  'huriu',
  'hurla',
  'hurli',
  'hurls',
  'hurra',
  'hurri',
  'hurru',
  'hurrá',
  'hurta',
  'hurti',
  'hurða',
  'husar',
  'hutsa',
  'hutsi',
  'hvakk',
  'hvala',
  'hvali',
  'hvals',
  'hvamm',
  'hvams',
  'hvaps',
  'hvapt',
  'hvarm',
  'hvarv',
  'hvass',
  'hvast',
  'hvein',
  'hvell',
  'hvelt',
  'hvepp',
  'hvept',
  'hvess',
  'hvest',
  'hvina',
  'hvini',
  'hvins',
  'hvinu',
  'hvonn',
  'hvála',
  'hváli',
  'hváls',
  'hválv',
  'hvæli',
  'hvæls',
  'hvíar',
  'hvíað',
  'hvíið',
  'hvíla',
  'hvíld',
  'hvíli',
  'hvílt',
  'hvílu',
  'hvína',
  'hvíni',
  'hvíta',
  'hvíti',
  'hvíts',
  'hvítt',
  'hvítu',
  'hvøkk',
  'hvøkt',
  'hvøll',
  'hvølp',
  'hvøls',
  'hvølt',
  'hvølv',
  'hvønn',
  'hvøpp',
  'hvøpt',
  'hvørs',
  'hvørt',
  'hvørv',
  'hvøss',
  'hygga',
  'hyggi',
  'hyggj',
  'hygna',
  'hygni',
  'hygnu',
  'hygst',
  'hykla',
  'hykli',
  'hykls',
  'hylar',
  'hylik',
  'hylin',
  'hylja',
  'hylji',
  'hylki',
  'hylkt',
  'hylla',
  'hylli',
  'hylst',
  'hylta',
  'hylti',
  'hylts',
  'hyltu',
  'hylum',
  'hylur',
  'hyppa',
  'hyppi',
  'hyppu',
  'hyrna',
  'hyrnd',
  'hyrni',
  'hyrns',
  'hyrnt',
  'hyrnu',
  'háari',
  'hábær',
  'háhús',
  'hákøn',
  'hálan',
  'hálar',
  'hálað',
  'hálda',
  'háldi',
  'hálig',
  'hálir',
  'hálið',
  'hálka',
  'hálki',
  'hálku',
  'hálmi',
  'hálms',
  'hálop',
  'hálov',
  'hálsa',
  'hálsi',
  'hálum',
  'hálur',
  'hálva',
  'hálvi',
  'hálvs',
  'hálvt',
  'hálvu',
  'háman',
  'hámar',
  'hámet',
  'hámir',
  'hámum',
  'hámur',
  'hámál',
  'hánum',
  'háran',
  'hárar',
  'hárað',
  'háriv',
  'hárið',
  'hárum',
  'hárur',
  'hárut',
  'háróm',
  'háróp',
  'hásal',
  'hásan',
  'hásar',
  'hásig',
  'hásin',
  'hásir',
  'hásið',
  'hásna',
  'hásni',
  'hásnu',
  'hásra',
  'hásum',
  'hásur',
  'hátta',
  'hátti',
  'hátíð',
  'hátún',
  'hávan',
  'hávað',
  'hávin',
  'hávum',
  'hávur',
  'háálv',
  'háðan',
  'háðar',
  'háðað',
  'háðin',
  'háðið',
  'háðlæ',
  'háðum',
  'hædda',
  'hægra',
  'hægri',
  'hægru',
  'hægst',
  'hækka',
  'hækki',
  'hælar',
  'hælað',
  'hælin',
  'hælir',
  'hælið',
  'hælka',
  'hælki',
  'hælum',
  'hælur',
  'hæran',
  'hærda',
  'hærdi',
  'hærds',
  'hærdu',
  'hærir',
  'hærið',
  'hærra',
  'hærri',
  'hærru',
  'hærum',
  'hærur',
  'hærut',
  'hæsað',
  'hæsta',
  'hæsti',
  'hæsts',
  'hæstu',
  'hætta',
  'hætti',
  'hættu',
  'hæðar',
  'hæðað',
  'hæðið',
  'hímar',
  'hímað',
  'hímda',
  'hímdi',
  'hímds',
  'hímdu',
  'hímir',
  'hímið',
  'hímum',
  'hímut',
  'hítan',
  'hítar',
  'hítað',
  'hítin',
  'hítir',
  'hítið',
  'hítum',
  'hítur',
  'híðið',
  'híðst',
  'híðum',
  'hóast',
  'hóbit',
  'hógva',
  'hógvi',
  'hólar',
  'hólað',
  'hólga',
  'hólgi',
  'hólin',
  'hólið',
  'hólka',
  'hólki',
  'hólks',
  'hólla',
  'hólli',
  'hólma',
  'hólmi',
  'hólms',
  'hólpa',
  'hólpi',
  'hólps',
  'hólum',
  'hólur',
  'hóman',
  'hómar',
  'hómað',
  'hómin',
  'hómið',
  'hómur',
  'hónum',
  'hópar',
  'hópað',
  'hópdr',
  'hópin',
  'hópið',
  'hópum',
  'hópur',
  'hórar',
  'hórað',
  'hórið',
  'hóska',
  'hóski',
  'hósks',
  'hótið',
  'hótta',
  'hótum',
  'hóvan',
  'hóvar',
  'hóvað',
  'hóvin',
  'hóvið',
  'hóvum',
  'hóvur',
  'hødda',
  'høddu',
  'høgan',
  'høgar',
  'høgda',
  'høgdi',
  'høgds',
  'høgdu',
  'høgga',
  'høggi',
  'høgir',
  'høgna',
  'høgni',
  'høgnu',
  'høgst',
  'høgum',
  'høgur',
  'høkan',
  'høkil',
  'høkja',
  'høkju',
  'høkla',
  'høkli',
  'høkum',
  'høkur',
  'hølda',
  'høldi',
  'hølds',
  'høldu',
  'hølir',
  'hølis',
  'hølið',
  'hølla',
  'hølli',
  'høllu',
  'hølst',
  'høltu',
  'hølum',
  'hølva',
  'hølvi',
  'hømla',
  'hømlu',
  'hønan',
  'hønsa',
  'hønsi',
  'hønum',
  'hønur',
  'høpin',
  'høpir',
  'høpis',
  'høpið',
  'høpna',
  'høpni',
  'høpnu',
  'høpum',
  'hørga',
  'hørgi',
  'hørgs',
  'hørin',
  'hørmu',
  'hørpa',
  'hørpu',
  'hørur',
  'hørva',
  'hørvi',
  'hørvs',
  'hørðu',
  'høsna',
  'høsni',
  'høsns',
  'høtti',
  'høttu',
  'høvda',
  'høvdi',
  'høvdu',
  'høvil',
  'høvir',
  'høvið',
  'høvla',
  'høvli',
  'høvum',
  'høvur',
  'húgla',
  'húgli',
  'húgva',
  'húgvu',
  'húkar',
  'húkin',
  'húkið',
  'húkum',
  'húkur',
  'húnan',
  'húnar',
  'húnin',
  'húnum',
  'húsan',
  'húsar',
  'húsað',
  'húsin',
  'húsið',
  'húski',
  'hússj',
  'húsum',
  'hútta',
  'húttu',
  'húðar',
  'húðin',
  'húðir',
  'húðum',
  'húðál',
  'hýena',
  'hýenu',
  'hýggi',
  'hýggj',
  'hýkur',
  'hýran',
  'hýrað',
  'hýrda',
  'hýrdi',
  'hýrds',
  'hýrdu',
  'hýrum',
  'hýrur',
  'hýsan',
  'hýsir',
  'hýsið',
  'hýski',
  'hýsta',
  'hýsti',
  'hýsts',
  'hýstu',
  'hýsum',
  'hýsur',
  'iPadd',
  'iPads',
  'iPodd',
  'iPods',
  'ideal',
  'idear',
  'idein',
  'ideir',
  'ideum',
  'idiot',
  'igils',
  'iglan',
  'iglar',
  'iglin',
  'iglum',
  'iglut',
  'ikins',
  'ikist',
  'iknan',
  'iknar',
  'iknir',
  'iknum',
  'ikona',
  'ikoni',
  'ikons',
  'ilina',
  'ilini',
  'iljar',
  'iljum',
  'illan',
  'illar',
  'illað',
  'illir',
  'illið',
  'illum',
  'illur',
  'ilrar',
  'ilska',
  'ilski',
  'ilsks',
  'ilskt',
  'ilsku',
  'iltar',
  'iltað',
  'iltið',
  'imama',
  'imami',
  'imams',
  'indan',
  'indar',
  'indin',
  'indra',
  'indri',
  'indum',
  'indur',
  'innat',
  'innav',
  'innbý',
  'innin',
  'innir',
  'inniá',
  'innií',
  'innið',
  'insta',
  'insti',
  'insts',
  'instu',
  'intan',
  'intar',
  'intir',
  'intra',
  'intum',
  'intur',
  'iraka',
  'iraki',
  'irana',
  'irani',
  'ironi',
  'irrað',
  'isaða',
  'isaði',
  'isaðs',
  'isaðu',
  'isman',
  'ismum',
  'ismur',
  'itist',
  'itust',
  'ivast',
  'ivaáa',
  'ivaær',
  'ivaóm',
  'iving',
  'ivist',
  'ivrig',
  'iðran',
  'iðrar',
  'iðrað',
  'iðrin',
  'iðrið',
  'iðrun',
  'jabba',
  'jabbi',
  'jadan',
  'jadum',
  'jadur',
  'jagar',
  'jagað',
  'jagga',
  'jaggi',
  'jagið',
  'jagla',
  'jagli',
  'jagls',
  'jagta',
  'jagti',
  'jakka',
  'jakki',
  'jaksl',
  'jakta',
  'jakti',
  'jalig',
  'jalla',
  'jalli',
  'jalov',
  'jamen',
  'jamra',
  'jamri',
  'janga',
  'jangi',
  'jangl',
  'jaorð',
  'japsa',
  'japsi',
  'jarka',
  'jarki',
  'jarma',
  'jarmi',
  'jarms',
  'jarna',
  'jarni',
  'jarns',
  'jarpa',
  'jarpi',
  'jarps',
  'jarpt',
  'jarva',
  'jarvi',
  'jarvs',
  'jarða',
  'jarði',
  'jasar',
  'jasað',
  'jasið',
  'jassa',
  'jassi',
  'javna',
  'javni',
  'javns',
  'javnt',
  'jazzi',
  'jaðar',
  'jaðra',
  'jaðri',
  'jaður',
  'jemli',
  'jenka',
  'jenna',
  'jenni',
  'jeppa',
  'jeppi',
  'jerva',
  'jervi',
  'jervs',
  'jesan',
  'jesar',
  'jesað',
  'jesið',
  'jobba',
  'jobbi',
  'jodið',
  'jodla',
  'jodli',
  'jogað',
  'jogga',
  'joggi',
  'jolla',
  'jollu',
  'jompa',
  'jompi',
  'jonar',
  'jonað',
  'jonin',
  'jonir',
  'jonið',
  'jonum',
  'jukka',
  'jukki',
  'junta',
  'juntu',
  'jáaða',
  'jáaði',
  'jáaðs',
  'jáaðu',
  'jánka',
  'jánki',
  'játan',
  'játta',
  'játti',
  'jólar',
  'jólin',
  'jólum',
  'jólur',
  'jónar',
  'jónað',
  'jónin',
  'jónir',
  'jónið',
  'jónum',
  'jórar',
  'jórað',
  'jórið',
  'jótra',
  'jótri',
  'jótur',
  'jødan',
  'jødar',
  'jødin',
  'jødum',
  'jøkil',
  'jøkla',
  'jøkli',
  'jøkul',
  'jørpu',
  'jøvnu',
  'júgra',
  'júgri',
  'júgur',
  'júkan',
  'júkar',
  'júkað',
  'júkið',
  'júkut',
  'jútan',
  'jútar',
  'jútin',
  'jútsk',
  'jútum',
  'kabba',
  'kabbi',
  'kaffi',
  'kagan',
  'kagar',
  'kagað',
  'kagga',
  'kaggi',
  'kagin',
  'kagið',
  'kagum',
  'kaiar',
  'kaiin',
  'kaiir',
  'kaium',
  'kakan',
  'kakao',
  'kakla',
  'kakli',
  'kakum',
  'kakur',
  'kalar',
  'kalda',
  'kaldi',
  'kalds',
  'kaldu',
  'kalik',
  'kalin',
  'kalir',
  'kalis',
  'kalið',
  'kalla',
  'kalli',
  'kalna',
  'kalni',
  'kalnu',
  'kalum',
  'kalur',
  'kalva',
  'kalvi',
  'kamar',
  'kamba',
  'kambi',
  'kambs',
  'kamel',
  'kamin',
  'kampa',
  'kampi',
  'kamps',
  'kamsi',
  'kanan',
  'kanel',
  'kanna',
  'kanni',
  'kannu',
  'kansa',
  'kansi',
  'kanst',
  'kanta',
  'kanti',
  'kants',
  'kanum',
  'kanur',
  'kappa',
  'kappi',
  'karar',
  'karað',
  'karga',
  'kargi',
  'kargs',
  'kargt',
  'karið',
  'karka',
  'karki',
  'karks',
  'karma',
  'karmi',
  'karms',
  'karpa',
  'karpu',
  'karra',
  'karri',
  'karru',
  'karrá',
  'karsa',
  'karsi',
  'karti',
  'karva',
  'karvi',
  'karvs',
  'karða',
  'karði',
  'kasar',
  'kasað',
  'kasið',
  'kassa',
  'kassi',
  'kasta',
  'kasti',
  'kasts',
  'katli',
  'katta',
  'katti',
  'kavan',
  'kavar',
  'kavað',
  'kavin',
  'kavið',
  'kavrá',
  'kavum',
  'kavut',
  'kaðal',
  'kaðla',
  'kaðli',
  'kedda',
  'keddi',
  'keddu',
  'kegla',
  'kegli',
  'kegls',
  'keiar',
  'keiin',
  'keiir',
  'keika',
  'keiki',
  'keiks',
  'keila',
  'keili',
  'keils',
  'keina',
  'keini',
  'keipa',
  'keipi',
  'keips',
  'keipu',
  'keisa',
  'keisi',
  'keium',
  'kekan',
  'kekar',
  'kekin',
  'kekka',
  'kekki',
  'keksa',
  'keksi',
  'keksk',
  'keksu',
  'kekum',
  'kekur',
  'kelan',
  'kelar',
  'kelað',
  'kelda',
  'keldu',
  'kelin',
  'kelið',
  'kelka',
  'kelki',
  'kelks',
  'kelkt',
  'kelna',
  'kelni',
  'kelnu',
  'kelta',
  'kelti',
  'kelva',
  'kelvi',
  'kelvs',
  'kemba',
  'kembd',
  'kembi',
  'kembt',
  'kempa',
  'kempi',
  'kempu',
  'kemst',
  'kemur',
  'kenda',
  'kendi',
  'kends',
  'kendu',
  'kenna',
  'kenni',
  'kensl',
  'kenst',
  'keppa',
  'keppi',
  'keran',
  'kerar',
  'kerir',
  'kerið',
  'kerja',
  'kerra',
  'kerru',
  'kerta',
  'kerti',
  'kertu',
  'kerub',
  'kerum',
  'kerur',
  'kerva',
  'kervi',
  'kerúb',
  'ketan',
  'ketil',
  'ketla',
  'ketli',
  'ketta',
  'kettu',
  'ketum',
  'ketur',
  'kevan',
  'kevar',
  'kevin',
  'kevja',
  'kevji',
  'kevum',
  'keyla',
  'keylu',
  'keyma',
  'keymi',
  'keyms',
  'keypa',
  'keypi',
  'keyps',
  'keypt',
  'keysa',
  'keyst',
  'keðan',
  'keðar',
  'keðir',
  'keðið',
  'keðst',
  'keðum',
  'keður',
  'khana',
  'khani',
  'kikan',
  'kikar',
  'kikað',
  'kikin',
  'kikið',
  'kikki',
  'kikks',
  'kikla',
  'kikli',
  'kikna',
  'kikni',
  'kiksa',
  'kiksi',
  'kikum',
  'killa',
  'killi',
  'kiloa',
  'kiloi',
  'kilos',
  'kilpa',
  'kilpi',
  'kilps',
  'kilpu',
  'kiman',
  'kimar',
  'kimað',
  'kimið',
  'kindi',
  'kinds',
  'kinga',
  'kingi',
  'kinin',
  'kinka',
  'kinki',
  'kinks',
  'kinna',
  'kinni',
  'kippa',
  'kippi',
  'kippu',
  'kipsa',
  'kipsi',
  'kipst',
  'kipta',
  'kipti',
  'kipts',
  'kiptu',
  'kirna',
  'kirni',
  'kirnu',
  'kirva',
  'kirvd',
  'kirvi',
  'kirvt',
  'kisan',
  'kisar',
  'kisað',
  'kisil',
  'kisið',
  'kiska',
  'kiski',
  'kisku',
  'kisli',
  'kista',
  'kistu',
  'kisum',
  'kisur',
  'kitin',
  'kitla',
  'kitli',
  'kitls',
  'kitta',
  'kitti',
  'kjaft',
  'kjaki',
  'kjaks',
  'kjala',
  'kjalg',
  'kjali',
  'kjans',
  'kjari',
  'kjarr',
  'kjars',
  'kjánk',
  'kjóan',
  'kjóar',
  'kjóin',
  'kjóla',
  'kjóli',
  'kjósa',
  'kjósi',
  'kjósu',
  'kjóum',
  'kjøki',
  'kjøkr',
  'kjøks',
  'kjøli',
  'kjøra',
  'kjøri',
  'kjørm',
  'kjørs',
  'kjøti',
  'kjøts',
  'kjúka',
  'kjúki',
  'kjúku',
  'klaff',
  'klafs',
  'klaga',
  'klagi',
  'klagu',
  'klaka',
  'klaki',
  'klakk',
  'klaks',
  'klakt',
  'klamp',
  'klams',
  'klang',
  'klapp',
  'klaps',
  'klasa',
  'klasi',
  'klava',
  'klavi',
  'klavu',
  'klein',
  'kleiv',
  'kleki',
  'klekk',
  'klekt',
  'klemm',
  'klems',
  'klepp',
  'kleps',
  'klerk',
  'klets',
  'klett',
  'kleyv',
  'klika',
  'klikk',
  'kliks',
  'klikt',
  'kliku',
  'klink',
  'klipp',
  'klips',
  'klipt',
  'kliva',
  'klivi',
  'klivs',
  'klivu',
  'klong',
  'klori',
  'klors',
  'kloss',
  'klova',
  'klovi',
  'klovn',
  'klovs',
  'kloyk',
  'kloyn',
  'kloyv',
  'klubb',
  'klubs',
  'kluft',
  'kluið',
  'klump',
  'klums',
  'klunk',
  'kluum',
  'kluvu',
  'klykk',
  'klykt',
  'klára',
  'klári',
  'klárs',
  'klárt',
  'kláru',
  'kláða',
  'kláði',
  'kláðu',
  'klædd',
  'klæds',
  'klæna',
  'klæni',
  'klæns',
  'klænt',
  'klænu',
  'klætt',
  'klæða',
  'klæði',
  'klína',
  'klínd',
  'klíni',
  'klínt',
  'klípa',
  'klípi',
  'klípt',
  'klípu',
  'klíva',
  'klívi',
  'klóar',
  'klógv',
  'klóka',
  'klóki',
  'klóks',
  'klókt',
  'klóku',
  'klóra',
  'klóri',
  'klórs',
  'klóru',
  'klóta',
  'klótu',
  'klødd',
  'kløkk',
  'kløks',
  'kløkt',
  'klønu',
  'kløpp',
  'kløur',
  'klúgv',
  'klúka',
  'klúki',
  'klúks',
  'klúss',
  'klúta',
  'klúti',
  'klúts',
  'knaga',
  'knagi',
  'knaka',
  'knaki',
  'knaks',
  'knapp',
  'knaps',
  'knapt',
  'knara',
  'knark',
  'knarr',
  'knars',
  'knasa',
  'knasi',
  'knask',
  'knast',
  'knava',
  'knavi',
  'knekk',
  'kneks',
  'knekt',
  'knell',
  'knelt',
  'knepa',
  'knepi',
  'knepp',
  'kneps',
  'knept',
  'knerk',
  'kneyk',
  'kneys',
  'knikk',
  'kniks',
  'knipa',
  'knipi',
  'knipr',
  'knips',
  'knisa',
  'knisi',
  'knokk',
  'knoks',
  'knosa',
  'knosi',
  'knoss',
  'knota',
  'knotu',
  'knoða',
  'knoði',
  'knubb',
  'knubs',
  'knugg',
  'knugs',
  'knurr',
  'knurs',
  'knykk',
  'knykt',
  'knyll',
  'knylt',
  'knáan',
  'knáar',
  'knáir',
  'knátt',
  'knáum',
  'knáur',
  'knáva',
  'knávi',
  'knávs',
  'knávt',
  'knávu',
  'knæið',
  'knæla',
  'knæli',
  'knæum',
  'knípa',
  'knípi',
  'knípt',
  'knípu',
  'kníva',
  'knívi',
  'knívs',
  'knópa',
  'knópi',
  'knóps',
  'knóra',
  'knóri',
  'knøpp',
  'knøri',
  'knørr',
  'knørt',
  'knøtt',
  'knøum',
  'knúka',
  'knúki',
  'knúks',
  'knúsk',
  'knúta',
  'knúti',
  'knúts',
  'knútu',
  'knýta',
  'knýti',
  'knýts',
  'knýtt',
  'kobba',
  'kobbi',
  'kobla',
  'kobli',
  'kodan',
  'kodda',
  'koddi',
  'kodum',
  'kodur',
  'kofta',
  'koftu',
  'kokan',
  'kokar',
  'kokað',
  'kokið',
  'kokka',
  'kokki',
  'kokku',
  'kokra',
  'kokri',
  'koksa',
  'koksi',
  'koksu',
  'kokum',
  'kokur',
  'kolan',
  'kolar',
  'kolað',
  'kolba',
  'kolbu',
  'kolið',
  'kolla',
  'kolli',
  'kollu',
  'kolon',
  'kolum',
  'kolur',
  'kolut',
  'koman',
  'komdi',
  'komdu',
  'komet',
  'komin',
  'komir',
  'komið',
  'komma',
  'kommu',
  'komna',
  'komni',
  'komnu',
  'komst',
  'komum',
  'komur',
  'konan',
  'konga',
  'kongi',
  'kongs',
  'konka',
  'konku',
  'konta',
  'konto',
  'kontu',
  'konum',
  'konur',
  'kopar',
  'kopek',
  'kopia',
  'kopii',
  'kopis',
  'kopla',
  'kopli',
  'koppa',
  'koppi',
  'kopra',
  'kopri',
  'kopta',
  'kopti',
  'korar',
  'korað',
  'korið',
  'korka',
  'korki',
  'korku',
  'korna',
  'korni',
  'korns',
  'korta',
  'korti',
  'korts',
  'kortu',
  'korum',
  'korál',
  'korða',
  'korði',
  'korðu',
  'kosin',
  'kosið',
  'kosma',
  'kosna',
  'kosni',
  'kosnu',
  'kossa',
  'kossi',
  'kossu',
  'kosta',
  'kosti',
  'kotið',
  'kotra',
  'kotri',
  'kotum',
  'kovan',
  'kovar',
  'kover',
  'kovin',
  'kovum',
  'koykl',
  'koyla',
  'koylu',
  'koyna',
  'koynu',
  'koyra',
  'koyrd',
  'koyri',
  'koyrt',
  'koyta',
  'koytu',
  'kradd',
  'krads',
  'kraft',
  'kraga',
  'kragi',
  'kraka',
  'kraki',
  'krakk',
  'krakl',
  'kraks',
  'kramm',
  'krams',
  'krana',
  'krani',
  'krans',
  'krapa',
  'krapi',
  'kraps',
  'krapt',
  'krasa',
  'krasi',
  'krava',
  'kravd',
  'kravi',
  'kravs',
  'kravt',
  'kraði',
  'kraðs',
  'kreds',
  'kreft',
  'krema',
  'kremi',
  'krems',
  'kreol',
  'krepp',
  'krept',
  'kreym',
  'kreyp',
  'krian',
  'kriar',
  'kriað',
  'kriið',
  'krika',
  'kriki',
  'krill',
  'krils',
  'kring',
  'krinn',
  'krins',
  'krint',
  'krisa',
  'krisu',
  'krita',
  'kriti',
  'kritl',
  'krits',
  'kritu',
  'kriða',
  'kriði',
  'kroka',
  'kroki',
  'krokk',
  'kroks',
  'kroma',
  'kromi',
  'kroms',
  'kropa',
  'kropi',
  'kropp',
  'krops',
  'kross',
  'krota',
  'kroti',
  'krots',
  'krotu',
  'krova',
  'krovi',
  'krovs',
  'kroys',
  'krunk',
  'krupu',
  'krutl',
  'kruts',
  'krutt',
  'kruvd',
  'kruvt',
  'krydd',
  'kryds',
  'krylv',
  'kryvi',
  'kryvl',
  'kryvs',
  'kráar',
  'kráað',
  'kráir',
  'kráið',
  'kráka',
  'kráku',
  'kráma',
  'krámi',
  'kráms',
  'krána',
  'kráni',
  'krása',
  'krási',
  'kráum',
  'krígs',
  'kríll',
  'kríls',
  'krími',
  'kríms',
  'króar',
  'króað',
  'krógv',
  'króið',
  'króka',
  'króki',
  'króks',
  'króna',
  'krónu',
  'krøki',
  'krøkt',
  'krøpp',
  'krúll',
  'krúls',
  'krúna',
  'krúni',
  'krúnu',
  'krúpa',
  'krúpi',
  'krúsa',
  'krúsi',
  'krúss',
  'krúti',
  'krúts',
  'krýki',
  'krýkt',
  'krýna',
  'krýnd',
  'krýni',
  'krýnt',
  'kubba',
  'kubbi',
  'kugga',
  'kuggi',
  'kukka',
  'kukki',
  'kulan',
  'kular',
  'kulað',
  'kulda',
  'kuldi',
  'kulir',
  'kulið',
  'kulka',
  'kulki',
  'kulks',
  'kulla',
  'kullu',
  'kulpa',
  'kulpu',
  'kulsa',
  'kulsi',
  'kulta',
  'kulti',
  'kults',
  'kulum',
  'kulur',
  'kumla',
  'kumli',
  'kumls',
  'kumma',
  'kummu',
  'kunda',
  'kundi',
  'kundu',
  'kunja',
  'kunji',
  'kunna',
  'kunni',
  'kunnu',
  'kunra',
  'kunst',
  'kunta',
  'kuntu',
  'kupla',
  'kupli',
  'kupul',
  'kurda',
  'kurdi',
  'kurer',
  'kuril',
  'kurla',
  'kurli',
  'kurls',
  'kurlu',
  'kurra',
  'kurri',
  'kursa',
  'kursi',
  'kurva',
  'kurvi',
  'kurvs',
  'kurvu',
  'kusan',
  'kusma',
  'kussa',
  'kussi',
  'kussu',
  'kusta',
  'kusti',
  'kusts',
  'kusum',
  'kusur',
  'kutan',
  'kutar',
  'kutað',
  'kutið',
  'kutum',
  'kvadd',
  'kvads',
  'kvagg',
  'kvaka',
  'kvaki',
  'kvakk',
  'kvaks',
  'kvala',
  'kvald',
  'kvali',
  'kvalt',
  'kvams',
  'kvant',
  'kvark',
  'kvart',
  'kvatt',
  'kveik',
  'kvein',
  'kveit',
  'kveld',
  'kvets',
  'kvett',
  'kveyl',
  'kvika',
  'kviki',
  'kviks',
  'kvikt',
  'kviku',
  'kvink',
  'kvint',
  'kvirr',
  'kvirs',
  'kvirt',
  'kvisi',
  'kvisk',
  'kvist',
  'kvita',
  'kviti',
  'kviða',
  'kviði',
  'kviðs',
  'kvomu',
  'kvota',
  'kvotu',
  'kválm',
  'kvátt',
  'kváða',
  'kváði',
  'kváðs',
  'kváðu',
  'kvæma',
  'kvæmi',
  'kvæms',
  'kvæmt',
  'kvæmu',
  'kvætt',
  'kvæða',
  'kvæði',
  'kvíga',
  'kvígu',
  'kvísl',
  'kvíða',
  'kvíði',
  'kvíðu',
  'kvóðu',
  'kvødd',
  'kvøds',
  'kvøld',
  'kvøts',
  'kvøtt',
  'kvøða',
  'kvøði',
  'kvøðu',
  'kykan',
  'kykar',
  'kykað',
  'kykin',
  'kykir',
  'kykið',
  'kykna',
  'kykni',
  'kykns',
  'kyknu',
  'kykra',
  'kyksa',
  'kyksi',
  'kykum',
  'kykur',
  'kylla',
  'kylli',
  'kylti',
  'kyltu',
  'kylva',
  'kylvu',
  'kynda',
  'kyndi',
  'kynds',
  'kyndu',
  'kynið',
  'kynja',
  'kynum',
  'kyrja',
  'kyrji',
  'kyrki',
  'kyrkt',
  'kyrla',
  'kyrli',
  'kyrpt',
  'kyrra',
  'kyrri',
  'kyrru',
  'kysið',
  'kyssa',
  'kyssi',
  'kysta',
  'kysti',
  'kysts',
  'kystu',
  'kákan',
  'kákar',
  'kákað',
  'kákin',
  'kákið',
  'kákla',
  'kákli',
  'kákls',
  'kákum',
  'kákur',
  'kálar',
  'kálað',
  'kálið',
  'kálka',
  'kálki',
  'kálks',
  'kálum',
  'kálva',
  'kálvi',
  'kálvs',
  'káman',
  'kámar',
  'kámað',
  'kámir',
  'kámið',
  'kámum',
  'kámur',
  'kámut',
  'kánus',
  'kápan',
  'kápil',
  'kápla',
  'kápli',
  'kápum',
  'kápur',
  'kárar',
  'kárað',
  'kárið',
  'kásna',
  'kásni',
  'kásnu',
  'kássa',
  'kássu',
  'kátan',
  'kátar',
  'kátir',
  'kátra',
  'kátum',
  'kátur',
  'kávan',
  'kávar',
  'kávað',
  'kávið',
  'kávum',
  'kæran',
  'kærar',
  'kærað',
  'kærda',
  'kærdi',
  'kærds',
  'kærdu',
  'kærir',
  'kærið',
  'kærst',
  'kærum',
  'kærur',
  'kætin',
  'kætis',
  'kætið',
  'kíkar',
  'kíkað',
  'kíkin',
  'kíkið',
  'kíkum',
  'kíkur',
  'kílar',
  'kílað',
  'kílið',
  'kínan',
  'kínda',
  'kíndi',
  'kínds',
  'kíndu',
  'kínir',
  'kínið',
  'kínst',
  'kínum',
  'kísta',
  'kísti',
  'kísts',
  'kódna',
  'kódni',
  'kógva',
  'kógvi',
  'kóini',
  'kókan',
  'kókar',
  'kókað',
  'kókið',
  'kókum',
  'kólar',
  'kólað',
  'kólið',
  'kólna',
  'kólni',
  'kónum',
  'kópar',
  'kópin',
  'kópum',
  'kópur',
  'kórið',
  'kórum',
  'kósar',
  'kósin',
  'kósir',
  'kósum',
  'kóvið',
  'kóvna',
  'kóvni',
  'kóvum',
  'køgga',
  'køggu',
  'køkan',
  'køkar',
  'køkin',
  'køkir',
  'køkið',
  'køkja',
  'køkju',
  'køkst',
  'køkta',
  'køkti',
  'køkts',
  'køktu',
  'køkum',
  'køkur',
  'kølda',
  'køldi',
  'kølds',
  'køldu',
  'kølin',
  'kølir',
  'kølið',
  'kølna',
  'kølni',
  'kølnu',
  'kølst',
  'kølva',
  'kølvu',
  'kømur',
  'kønan',
  'kønar',
  'kønir',
  'kønka',
  'kønki',
  'kønum',
  'kønur',
  'køppa',
  'køppi',
  'køpsa',
  'køpsi',
  'køpsu',
  'kørga',
  'kørgi',
  'kørgs',
  'kørgu',
  'kørum',
  'køska',
  'køsku',
  'køsta',
  'køsti',
  'køsts',
  'køtti',
  'køvda',
  'køvdi',
  'køvds',
  'køvdu',
  'køvir',
  'køvið',
  'køvst',
  'kúgan',
  'kúgar',
  'kúgað',
  'kúgið',
  'kúgva',
  'kúgvi',
  'kúlan',
  'kúlar',
  'kúlað',
  'kúlið',
  'kúlla',
  'kúlli',
  'kúllu',
  'kúlum',
  'kúlur',
  'kúlut',
  'kúlva',
  'kúlvi',
  'kúlvs',
  'kúnna',
  'kúnni',
  'kúnum',
  'kúpan',
  'kúpin',
  'kúpið',
  'kúpna',
  'kúpni',
  'kúpnu',
  'kúpsa',
  'kúpsi',
  'kúpsu',
  'kúpum',
  'kúpur',
  'kúput',
  'kúrar',
  'kúrdi',
  'kúrdu',
  'kúrin',
  'kúrir',
  'kúrið',
  'kúrna',
  'kúrni',
  'kúrnu',
  'kúrra',
  'kúrri',
  'kúrru',
  'kúrum',
  'kúrur',
  'kúsan',
  'kústa',
  'kústi',
  'kúsum',
  'kúsur',
  'kúsut',
  'kútal',
  'kútøl',
  'kútøð',
  'kýlir',
  'kýlis',
  'kýlið',
  'kýlum',
  'kýpil',
  'kýpin',
  'kýpið',
  'kýpla',
  'kýpli',
  'kýpna',
  'kýpni',
  'kýpnu',
  'kýsan',
  'kýsar',
  'kýsin',
  'kýska',
  'kýski',
  'kýsks',
  'kýskt',
  'kýsku',
  'kýsum',
  'kýsur',
  'kýtir',
  'kýtið',
  'kýtst',
  'kýtti',
  'kýttu',
  'labba',
  'labbi',
  'ladar',
  'ladað',
  'ladið',
  'ladna',
  'ladni',
  'ladnu',
  'lagan',
  'lagar',
  'lagað',
  'lagda',
  'lagdi',
  'lagds',
  'lagga',
  'laggi',
  'lagin',
  'lagið',
  'lagna',
  'lagni',
  'lagnu',
  'lagra',
  'lagri',
  'lagst',
  'lagum',
  'lagur',
  'lakan',
  'lakar',
  'lakað',
  'lakin',
  'lakir',
  'lakið',
  'lakka',
  'lakki',
  'lakra',
  'laksa',
  'laksi',
  'lakst',
  'lakum',
  'lakur',
  'laman',
  'lamba',
  'lambi',
  'lambs',
  'lamda',
  'lamdi',
  'lamds',
  'lamdu',
  'lamin',
  'lamið',
  'lamma',
  'lammi',
  'lamna',
  'lamni',
  'lamnu',
  'lampa',
  'lampu',
  'lamsa',
  'lamsi',
  'lamum',
  'lamur',
  'landa',
  'landi',
  'lands',
  'langa',
  'langi',
  'langs',
  'langt',
  'langu',
  'lansa',
  'lansi',
  'lansu',
  'lappa',
  'lappi',
  'lapri',
  'lapur',
  'larma',
  'larmi',
  'larms',
  'larra',
  'larri',
  'larva',
  'larvu',
  'lasar',
  'lasað',
  'lasið',
  'laska',
  'laski',
  'lassa',
  'lassi',
  'lasta',
  'lasti',
  'latan',
  'latar',
  'latin',
  'latir',
  'latið',
  'latna',
  'latni',
  'latnu',
  'latra',
  'latst',
  'latur',
  'latín',
  'lavan',
  'lavum',
  'lavur',
  'laðin',
  'laðið',
  'ledig',
  'legal',
  'legan',
  'legda',
  'leggi',
  'legna',
  'legni',
  'legsa',
  'legsi',
  'legst',
  'legum',
  'legur',
  'legði',
  'leidd',
  'leids',
  'leiga',
  'leigi',
  'leigu',
  'leika',
  'leiks',
  'leikt',
  'leiku',
  'leina',
  'leini',
  'leins',
  'leira',
  'leiri',
  'leirs',
  'leist',
  'leita',
  'leiti',
  'leitt',
  'leiur',
  'leiva',
  'leivi',
  'leivs',
  'leivt',
  'leiða',
  'leiði',
  'leiðs',
  'leiðu',
  'lekam',
  'lekir',
  'lekið',
  'lekja',
  'lekju',
  'lekst',
  'lekta',
  'lekti',
  'lekts',
  'lektu',
  'lekum',
  'lekur',
  'lella',
  'lelli',
  'lellu',
  'lemba',
  'lembd',
  'lembi',
  'lembt',
  'lemja',
  'lemji',
  'lemma',
  'lemmi',
  'lempa',
  'lempu',
  'lemur',
  'lenda',
  'lendi',
  'lends',
  'lendu',
  'lenið',
  'lensa',
  'lensi',
  'lensu',
  'lenum',
  'lepar',
  'lepað',
  'lepið',
  'leppa',
  'leppi',
  'lepra',
  'lepri',
  'lepta',
  'lepti',
  'lepts',
  'leptu',
  'leput',
  'lerka',
  'lerki',
  'lerks',
  'lesið',
  'leska',
  'leski',
  'lesks',
  'lespa',
  'lespi',
  'lessa',
  'lessi',
  'lesta',
  'lesur',
  'letal',
  'letan',
  'letar',
  'letað',
  'letin',
  'letið',
  'letst',
  'letta',
  'letti',
  'letur',
  'levit',
  'levsa',
  'levsi',
  'levsu',
  'leyga',
  'leygi',
  'leyka',
  'leyki',
  'leyks',
  'leypa',
  'leypi',
  'leyps',
  'leysa',
  'leysi',
  'leysn',
  'leyss',
  'leyst',
  'leysu',
  'leyva',
  'leyvi',
  'leyvs',
  'leyvu',
  'leðra',
  'leðri',
  'leður',
  'lidna',
  'lidni',
  'lidnu',
  'lifra',
  'lifri',
  'lifrs',
  'ligan',
  'liggi',
  'ligin',
  'ligið',
  'ligna',
  'ligni',
  'lignu',
  'ligum',
  'ligur',
  'likam',
  'likin',
  'likið',
  'likka',
  'likki',
  'likku',
  'likna',
  'likni',
  'liknu',
  'likør',
  'lilja',
  'lilji',
  'lilju',
  'lilla',
  'lilli',
  'liman',
  'limar',
  'limað',
  'limin',
  'limir',
  'limið',
  'limum',
  'limur',
  'linar',
  'linað',
  'linda',
  'lindi',
  'linga',
  'lingi',
  'lings',
  'linin',
  'linir',
  'linið',
  'linja',
  'linju',
  'linka',
  'linki',
  'links',
  'linna',
  'linni',
  'linnu',
  'linsa',
  'linsu',
  'lippa',
  'lippi',
  'lippu',
  'liran',
  'lirar',
  'lirin',
  'lirka',
  'lirki',
  'lirku',
  'lirra',
  'lirri',
  'lirum',
  'lisan',
  'lisin',
  'lisið',
  'lisna',
  'lisni',
  'lisnu',
  'lissa',
  'lissi',
  'lissu',
  'lista',
  'listi',
  'lisum',
  'lisur',
  'litar',
  'litað',
  'litin',
  'litir',
  'litið',
  'litka',
  'litki',
  'litna',
  'litni',
  'litnu',
  'litra',
  'litri',
  'litta',
  'litti',
  'littu',
  'litum',
  'litur',
  'livað',
  'livda',
  'livdi',
  'livds',
  'livdu',
  'livir',
  'livið',
  'livna',
  'livni',
  'livra',
  'livst',
  'liðan',
  'liðar',
  'liðað',
  'liðin',
  'liðir',
  'liðið',
  'liðka',
  'liðki',
  'liðna',
  'liðni',
  'liðnu',
  'liðug',
  'liðum',
  'liður',
  'ljóma',
  'ljómi',
  'ljóms',
  'ljóna',
  'ljóni',
  'ljóns',
  'ljósa',
  'ljósi',
  'ljósn',
  'ljóst',
  'ljósu',
  'ljóta',
  'ljóti',
  'ljóts',
  'ljótt',
  'ljótu',
  'ljóða',
  'ljóði',
  'ljóðs',
  'ljúva',
  'ljúvi',
  'ljúvs',
  'ljúvt',
  'ljúvu',
  'lobba',
  'lobbi',
  'lodda',
  'loddi',
  'lodna',
  'lodni',
  'lodnu',
  'lofna',
  'lofni',
  'lofta',
  'lofti',
  'lofts',
  'logan',
  'logar',
  'logað',
  'logga',
  'loggi',
  'login',
  'logið',
  'logna',
  'logni',
  'logns',
  'logum',
  'lokal',
  'lokan',
  'lokar',
  'lokað',
  'lokin',
  'lokið',
  'lokka',
  'lokki',
  'lokna',
  'lokni',
  'loknu',
  'lokum',
  'lokur',
  'lonan',
  'lonar',
  'longa',
  'longd',
  'longu',
  'lonin',
  'lonir',
  'lonum',
  'lonur',
  'lopan',
  'lopin',
  'lopið',
  'lopna',
  'lopni',
  'lopnu',
  'loppa',
  'loppi',
  'loppu',
  'lopra',
  'lopri',
  'lopum',
  'loran',
  'lorar',
  'lorað',
  'lorda',
  'lordi',
  'lords',
  'lorið',
  'lorka',
  'lorki',
  'lorks',
  'lorra',
  'lorri',
  'lorta',
  'lorti',
  'lorts',
  'losar',
  'losað',
  'losið',
  'losja',
  'losju',
  'losna',
  'losni',
  'lossa',
  'lossi',
  'losta',
  'losti',
  'losáa',
  'losær',
  'losóm',
  'lotan',
  'lotar',
  'lotað',
  'lotin',
  'lotir',
  'lotið',
  'lotna',
  'lotni',
  'lotnu',
  'lotra',
  'lotum',
  'lotur',
  'lovar',
  'lovað',
  'lovið',
  'loyal',
  'loyna',
  'loynd',
  'loyni',
  'loynt',
  'loynu',
  'loypa',
  'loypi',
  'loypt',
  'loysa',
  'loysi',
  'loysn',
  'loyst',
  'loysu',
  'loyva',
  'loyvd',
  'loyvi',
  'loyvt',
  'loðar',
  'loðað',
  'loðin',
  'loðið',
  'loðra',
  'loðri',
  'loðsa',
  'loðsi',
  'loðum',
  'loðáa',
  'loðær',
  'loðóm',
  'lubba',
  'lubbi',
  'ludar',
  'ludað',
  'ludið',
  'ludoa',
  'ludoi',
  'ludos',
  'lufta',
  'lufti',
  'lugar',
  'lugga',
  'luggi',
  'lukka',
  'lukki',
  'lukku',
  'luksa',
  'lukta',
  'lukti',
  'lukts',
  'luktu',
  'lulla',
  'lulli',
  'lullu',
  'lumma',
  'lummi',
  'lumpa',
  'lumpi',
  'lumra',
  'lumri',
  'lunda',
  'lundi',
  'lunga',
  'lungu',
  'lunka',
  'lunki',
  'lunna',
  'lunni',
  'lupra',
  'lupri',
  'lurka',
  'lurki',
  'lurks',
  'lurta',
  'lurti',
  'lurts',
  'lusta',
  'lutan',
  'lutar',
  'lutað',
  'lutin',
  'lutir',
  'lutið',
  'lutta',
  'lutti',
  'lutum',
  'lutur',
  'luður',
  'lyfta',
  'lyfti',
  'lyfts',
  'lyftu',
  'lygin',
  'lygna',
  'lygni',
  'lygnt',
  'lygnu',
  'lykil',
  'lykka',
  'lykki',
  'lykla',
  'lykli',
  'lykta',
  'lykti',
  'lyktu',
  'lynda',
  'lyndi',
  'lyngi',
  'lyngs',
  'lynin',
  'lynir',
  'lynna',
  'lynni',
  'lynti',
  'lyntu',
  'lynum',
  'lynur',
  'lysta',
  'lysti',
  'lysts',
  'lágan',
  'lágar',
  'lágda',
  'lágin',
  'lágir',
  'lágum',
  'lágur',
  'láina',
  'láini',
  'lálla',
  'lállu',
  'lámar',
  'lámað',
  'lámin',
  'lámið',
  'lámum',
  'lámur',
  'lánir',
  'lánið',
  'lánka',
  'lánki',
  'lánna',
  'lánni',
  'lánst',
  'lánta',
  'lánti',
  'lánts',
  'lántu',
  'lánum',
  'láran',
  'lárar',
  'lárin',
  'lárir',
  'lárum',
  'lárur',
  'lásar',
  'lásin',
  'lásið',
  'lásum',
  'lásur',
  'látin',
  'látið',
  'látna',
  'látni',
  'látnu',
  'látra',
  'látri',
  'látst',
  'látum',
  'látur',
  'læaði',
  'lægar',
  'lægað',
  'lægda',
  'lægdi',
  'lægds',
  'lægdu',
  'lægir',
  'lægið',
  'lægra',
  'lægri',
  'lægru',
  'lægst',
  'læins',
  'lækja',
  'lækju',
  'lækka',
  'lækki',
  'lækna',
  'lækni',
  'lælig',
  'lænan',
  'lænar',
  'lænir',
  'lænum',
  'læran',
  'lærda',
  'lærdi',
  'lærds',
  'lærdu',
  'lærir',
  'lærið',
  'lærst',
  'lærum',
  'lærur',
  'lærár',
  'læsta',
  'læsti',
  'læsts',
  'læstu',
  'lætir',
  'lætna',
  'lætni',
  'lætst',
  'lætta',
  'lætti',
  'lættu',
  'lætum',
  'lídda',
  'líddi',
  'líddu',
  'lídni',
  'líggi',
  'líkan',
  'líkar',
  'líkað',
  'líkin',
  'líkir',
  'líkis',
  'líkið',
  'líkja',
  'líkna',
  'líkni',
  'líkra',
  'líkst',
  'líkum',
  'líkur',
  'límar',
  'límað',
  'límið',
  'línan',
  'línað',
  'línið',
  'línum',
  'línur',
  'líran',
  'lírar',
  'lírin',
  'lírum',
  'lítar',
  'lítil',
  'lítin',
  'lítið',
  'lítla',
  'lítli',
  'lítlu',
  'lítst',
  'lítur',
  'lívað',
  'lívdi',
  'lívdu',
  'lívga',
  'lívgi',
  'lívir',
  'lívið',
  'lívum',
  'líðar',
  'líðin',
  'líðir',
  'líðið',
  'líðum',
  'líður',
  'lógar',
  'lógin',
  'lógir',
  'lógum',
  'lógva',
  'lógvi',
  'lókar',
  'lókað',
  'lókin',
  'lókið',
  'lókra',
  'lókri',
  'lókum',
  'lókur',
  'lókut',
  'lómar',
  'lómin',
  'lómum',
  'lómur',
  'lónar',
  'lónin',
  'lónir',
  'lónið',
  'lónna',
  'lónni',
  'lónum',
  'lótir',
  'lótum',
  'lóðri',
  'lóður',
  'lødda',
  'løddi',
  'løddu',
  'løgan',
  'løgar',
  'løgað',
  'løgda',
  'løgdu',
  'løgga',
  'løggi',
  'løggu',
  'løgin',
  'løgir',
  'løgið',
  'løgna',
  'løgni',
  'løgnu',
  'løgst',
  'løgum',
  'løgur',
  'løkan',
  'løkar',
  'løkin',
  'løkir',
  'løkja',
  'løkju',
  'løkum',
  'løkur',
  'lønar',
  'lønin',
  'lønir',
  'lønka',
  'lønki',
  'lønum',
  'løppa',
  'løran',
  'lørka',
  'lørki',
  'lørum',
  'lørur',
  'lørut',
  'løsta',
  'løsti',
  'løsts',
  'løstu',
  'løtan',
  'løttu',
  'løtum',
  'løtur',
  'løvan',
  'løvda',
  'løvum',
  'løvur',
  'løðan',
  'løðir',
  'løðið',
  'løðst',
  'løðum',
  'løður',
  'lúgva',
  'lúgvi',
  'lúgvu',
  'lúkan',
  'lúkið',
  'lúkst',
  'lúkum',
  'lúkur',
  'lúnan',
  'lúnar',
  'lúnað',
  'lúnin',
  'lúnið',
  'lúnsk',
  'lúnum',
  'lúnur',
  'lúnut',
  'lúrdi',
  'lúrdu',
  'lúrin',
  'lúrir',
  'lúrið',
  'lúrna',
  'lúrni',
  'lúrnu',
  'lúrum',
  'lúrur',
  'lúrut',
  'lúsar',
  'lúsað',
  'lúsin',
  'lúsið',
  'lúsum',
  'lúsut',
  'lútar',
  'lútað',
  'lútin',
  'lútir',
  'lútið',
  'lútum',
  'lútur',
  'lúðra',
  'lúðri',
  'lúður',
  'lýdda',
  'lýddi',
  'lýddu',
  'lýdna',
  'lýdni',
  'lýdnu',
  'lýggi',
  'lýggj',
  'lýkka',
  'lýkki',
  'lýkku',
  'lýkst',
  'lýkur',
  'lýlig',
  'lýnan',
  'lýnar',
  'lýnað',
  'lýnin',
  'lýnið',
  'lýran',
  'lýrar',
  'lýrik',
  'lýrin',
  'lýrum',
  'lýrur',
  'lýsan',
  'lýsir',
  'lýsis',
  'lýsið',
  'lýsna',
  'lýsni',
  'lýsta',
  'lýsti',
  'lýsts',
  'lýstu',
  'lýsut',
  'lýtan',
  'lýtir',
  'lýtis',
  'lýtið',
  'lýtst',
  'lýtta',
  'lýtti',
  'lýtts',
  'lýttu',
  'lýtum',
  'lýtur',
  'lýðin',
  'lýðir',
  'lýðið',
  'lýðst',
  'mafia',
  'mafiu',
  'magan',
  'magar',
  'magin',
  'magma',
  'magna',
  'magni',
  'magns',
  'magum',
  'maisi',
  'major',
  'makan',
  'makar',
  'makað',
  'makin',
  'makir',
  'makið',
  'makra',
  'maksi',
  'makta',
  'makti',
  'makum',
  'makur',
  'malar',
  'malda',
  'maldi',
  'malds',
  'maldu',
  'malin',
  'malir',
  'malið',
  'malja',
  'malju',
  'malla',
  'mallu',
  'malna',
  'malni',
  'malnu',
  'malst',
  'malta',
  'malti',
  'malts',
  'malum',
  'malør',
  'mamma',
  'mammu',
  'manar',
  'manað',
  'manda',
  'mandi',
  'manga',
  'mangi',
  'mangs',
  'mangt',
  'mangu',
  'mania',
  'maniu',
  'manið',
  'manna',
  'manni',
  'mansk',
  'manst',
  'manum',
  'mappa',
  'mappu',
  'marar',
  'marda',
  'mardi',
  'mards',
  'mardu',
  'marga',
  'margi',
  'margs',
  'margt',
  'margu',
  'marka',
  'marki',
  'marks',
  'marra',
  'marri',
  'marru',
  'marsa',
  'marsi',
  'marsj',
  'martl',
  'marur',
  'marva',
  'marvi',
  'marða',
  'masar',
  'masað',
  'masið',
  'maska',
  'maski',
  'masks',
  'masku',
  'massa',
  'massi',
  'masut',
  'matar',
  'matað',
  'matig',
  'matin',
  'matið',
  'matla',
  'matli',
  'matna',
  'matni',
  'matnu',
  'matur',
  'matáa',
  'matær',
  'matís',
  'matóm',
  'maðka',
  'maðki',
  'maðks',
  'maður',
  'medda',
  'meddi',
  'media',
  'medii',
  'megað',
  'megin',
  'megis',
  'megið',
  'megna',
  'megni',
  'megns',
  'megnu',
  'meidd',
  'meids',
  'meila',
  'meilu',
  'meina',
  'meini',
  'meins',
  'meint',
  'meinu',
  'meira',
  'meiri',
  'meiru',
  'meisa',
  'meita',
  'meiti',
  'meitt',
  'meiða',
  'meiði',
  'mekan',
  'mekla',
  'mekli',
  'mekls',
  'mekul',
  'mekum',
  'mekur',
  'melda',
  'meldi',
  'melds',
  'mella',
  'melli',
  'mellu',
  'melst',
  'melta',
  'melti',
  'meltu',
  'melur',
  'menar',
  'menin',
  'menir',
  'menna',
  'menni',
  'mensk',
  'menst',
  'menta',
  'menti',
  'ments',
  'mentu',
  'menum',
  'merar',
  'merga',
  'mergi',
  'meril',
  'merin',
  'merja',
  'merji',
  'merki',
  'merkt',
  'merla',
  'merli',
  'merna',
  'merni',
  'mersa',
  'mersi',
  'merum',
  'mesan',
  'meska',
  'meski',
  'mesks',
  'meskt',
  'mesku',
  'messa',
  'messi',
  'messu',
  'mesta',
  'mesti',
  'mests',
  'mestu',
  'metal',
  'metan',
  'metis',
  'metið',
  'metra',
  'metri',
  'metta',
  'metti',
  'mettu',
  'metum',
  'metur',
  'metár',
  'meyka',
  'meyki',
  'meyla',
  'meyli',
  'meyls',
  'meyra',
  'meyru',
  'meðan',
  'meðni',
  'migið',
  'mikil',
  'mikið',
  'mikla',
  'mikli',
  'miklu',
  'milda',
  'mildi',
  'milds',
  'mildu',
  'miljø',
  'milta',
  'milti',
  'milts',
  'mimar',
  'mimað',
  'mimið',
  'minan',
  'minar',
  'minað',
  'minið',
  'minka',
  'minki',
  'minks',
  'minna',
  'minni',
  'minnu',
  'minst',
  'minta',
  'minti',
  'mints',
  'mintu',
  'minum',
  'minur',
  'minus',
  'missa',
  'missi',
  'mista',
  'misti',
  'mists',
  'mistu',
  'misár',
  'mitta',
  'mittu',
  'miðal',
  'miðan',
  'miðar',
  'miðað',
  'miðbý',
  'miðil',
  'miðir',
  'miðið',
  'miðja',
  'miðju',
  'miðla',
  'miðli',
  'miðum',
  'miður',
  'miðás',
  'mjarr',
  'mjars',
  'mjasi',
  'mjesk',
  'mjáan',
  'mjáar',
  'mjádd',
  'mjáin',
  'mjáir',
  'mjátt',
  'mjáum',
  'mjáur',
  'mjædd',
  'mjæst',
  'mjóan',
  'mjóar',
  'mjóin',
  'mjóka',
  'mjóki',
  'mjólk',
  'mjóma',
  'mjómi',
  'mjóna',
  'mjósk',
  'mjóum',
  'mjóva',
  'mjóvi',
  'mjødn',
  'mjøli',
  'mjøll',
  'mjøls',
  'mjølv',
  'mjøði',
  'mjúka',
  'mjúki',
  'mjúks',
  'mjúkt',
  'mjúku',
  'modna',
  'modni',
  'modnu',
  'mogga',
  'moggi',
  'mogin',
  'mogið',
  'mogna',
  'mogni',
  'mognu',
  'molan',
  'molar',
  'molað',
  'molda',
  'moldi',
  'molin',
  'molið',
  'molla',
  'molli',
  'molna',
  'molni',
  'molum',
  'molut',
  'momma',
  'mommu',
  'monan',
  'monar',
  'monað',
  'mongd',
  'mongu',
  'monin',
  'monið',
  'monsk',
  'monum',
  'moral',
  'morar',
  'morað',
  'morið',
  'morja',
  'morji',
  'morla',
  'morli',
  'morls',
  'morsa',
  'morsi',
  'morða',
  'morði',
  'morðs',
  'mosan',
  'mosar',
  'mosað',
  'mosin',
  'mosið',
  'moska',
  'mosku',
  'mosum',
  'motiv',
  'motor',
  'motta',
  'motti',
  'motto',
  'mottu',
  'moyar',
  'moyra',
  'moyri',
  'moyrs',
  'moyrt',
  'moyru',
  'moyum',
  'moðin',
  'moðið',
  'moðum',
  'mubba',
  'mubbi',
  'mudda',
  'muddi',
  'muffa',
  'muffu',
  'mugað',
  'mugga',
  'muggi',
  'mulda',
  'muldi',
  'mulds',
  'muldu',
  'mulna',
  'mulni',
  'mulpa',
  'mulpi',
  'multa',
  'multu',
  'mumia',
  'mumiu',
  'munan',
  'munar',
  'munað',
  'munda',
  'mundi',
  'munds',
  'mundu',
  'munga',
  'mungi',
  'mungs',
  'munin',
  'munir',
  'munið',
  'munja',
  'munji',
  'munka',
  'munki',
  'munks',
  'munna',
  'munni',
  'munnu',
  'munsa',
  'munsi',
  'munum',
  'munur',
  'muran',
  'murga',
  'murgi',
  'murgs',
  'murgu',
  'murkn',
  'murpa',
  'murpu',
  'murra',
  'murri',
  'murru',
  'murta',
  'murti',
  'murtl',
  'murtn',
  'murts',
  'mussa',
  'mussi',
  'mutan',
  'mutar',
  'mutað',
  'mutið',
  'mutla',
  'mutli',
  'mutls',
  'mutra',
  'mutri',
  'mutur',
  'muuna',
  'muuni',
  'muður',
  'mykið',
  'mykja',
  'mykju',
  'mylda',
  'myldi',
  'mylds',
  'myldu',
  'mylið',
  'mylja',
  'mylji',
  'mylla',
  'myllu',
  'mylna',
  'mylnu',
  'mylur',
  'mynda',
  'myndi',
  'mynna',
  'mynni',
  'mynst',
  'mynta',
  'mynti',
  'mynts',
  'myntu',
  'myrda',
  'myrdi',
  'myrds',
  'myrdu',
  'myrja',
  'myrju',
  'myrka',
  'myrki',
  'myrks',
  'myrkt',
  'myrku',
  'myrla',
  'myrli',
  'myrra',
  'myrri',
  'myrru',
  'myrta',
  'myrtu',
  'myrða',
  'myrði',
  'mysan',
  'mysut',
  'mytan',
  'mytum',
  'mytur',
  'máana',
  'máast',
  'máaða',
  'máaði',
  'máaðs',
  'máaðu',
  'máddi',
  'máddu',
  'mágar',
  'mágin',
  'mágum',
  'mágur',
  'máham',
  'máhav',
  'máhøv',
  'máist',
  'málan',
  'málar',
  'málað',
  'málda',
  'máldi',
  'málds',
  'máldu',
  'málir',
  'málið',
  'málmi',
  'málms',
  'málsk',
  'málst',
  'málum',
  'málóð',
  'mánan',
  'mánar',
  'mánað',
  'mánin',
  'mánið',
  'mánum',
  'mápar',
  'mápað',
  'mápið',
  'márar',
  'márin',
  'márum',
  'márur',
  'másan',
  'másar',
  'másin',
  'másum',
  'mátan',
  'mátar',
  'mátað',
  'mátin',
  'mátið',
  'mátla',
  'mátli',
  'mátta',
  'mátti',
  'máttu',
  'mátum',
  'mávar',
  'mávin',
  'mávum',
  'mávur',
  'mæini',
  'mækan',
  'mækar',
  'mækin',
  'mækja',
  'mækju',
  'mækum',
  'mælis',
  'mælið',
  'mælsk',
  'mælta',
  'mælti',
  'mælts',
  'mæltu',
  'mænum',
  'mætan',
  'mætar',
  'mætir',
  'mætis',
  'mætið',
  'mætra',
  'mætum',
  'mætur',
  'míggi',
  'míggj',
  'mígið',
  'mígur',
  'mílar',
  'mílin',
  'mílir',
  'mílum',
  'mínar',
  'mínir',
  'mínum',
  'mírst',
  'mógva',
  'mógvi',
  'mókar',
  'mókað',
  'mókin',
  'mókið',
  'mókum',
  'mókur',
  'mókut',
  'mólst',
  'mómót',
  'mónum',
  'mópot',
  'móran',
  'mórar',
  'mórin',
  'mórum',
  'mórut',
  'mótan',
  'mótar',
  'mótað',
  'mótig',
  'mótin',
  'mótið',
  'mótug',
  'mótum',
  'mótur',
  'móðan',
  'móðar',
  'móðað',
  'móðig',
  'móðir',
  'móðið',
  'móðum',
  'móður',
  'móðut',
  'møbil',
  'møbla',
  'møbli',
  'mødda',
  'møddi',
  'møddu',
  'mødig',
  'møgga',
  'møgut',
  'møkan',
  'møkum',
  'møkur',
  'mølar',
  'mølin',
  'mølir',
  'mølma',
  'mølmi',
  'mølms',
  'mølum',
  'mølur',
  'mølva',
  'mølvi',
  'mølvs',
  'mønan',
  'mønar',
  'mønað',
  'mønin',
  'mønir',
  'mønið',
  'mønum',
  'mønur',
  'møpla',
  'møpli',
  'møran',
  'mørar',
  'mørgu',
  'mørin',
  'mørir',
  'mørna',
  'mørni',
  'mørum',
  'mørur',
  'mørði',
  'møsna',
  'møsni',
  'møsns',
  'møtir',
  'møtis',
  'møtið',
  'møtla',
  'møtli',
  'møtst',
  'møtta',
  'møtti',
  'møtts',
  'møttu',
  'møtum',
  'møðga',
  'møðig',
  'møðin',
  'møðir',
  'møðið',
  'møðra',
  'møðst',
  'møður',
  'múgva',
  'múgvi',
  'múgvu',
  'múlan',
  'múlar',
  'múlað',
  'múlin',
  'múlið',
  'múlum',
  'múlut',
  'múnan',
  'múnar',
  'múnir',
  'múnja',
  'múnji',
  'múnju',
  'múnum',
  'múrar',
  'múrað',
  'múrin',
  'múrið',
  'múrum',
  'múrur',
  'músar',
  'músað',
  'músin',
  'músið',
  'músli',
  'músum',
  'músut',
  'mýggi',
  'mýggj',
  'mýini',
  'mýkir',
  'mýkið',
  'mýkja',
  'mýkst',
  'mýkta',
  'mýkti',
  'mýkts',
  'mýktu',
  'mýlda',
  'mýldi',
  'mýlds',
  'mýldu',
  'mýlir',
  'mýlið',
  'mýlsk',
  'mýlst',
  'mýlum',
  'mýnum',
  'mýran',
  'mýrar',
  'mýrin',
  'mýrum',
  'mýrur',
  'mýrut',
  'mýsut',
  'mýtan',
  'mýtum',
  'mýtur',
  'nabba',
  'nabbi',
  'nadda',
  'naddi',
  'nagar',
  'nagað',
  'nagga',
  'naggi',
  'nagið',
  'nagla',
  'nagli',
  'nakar',
  'nakað',
  'nakin',
  'nakið',
  'nakka',
  'nakki',
  'nakna',
  'nakni',
  'naknu',
  'nakra',
  'nalva',
  'nalvi',
  'namma',
  'nammi',
  'namst',
  'nanar',
  'nanað',
  'nanið',
  'nappa',
  'nappi',
  'narra',
  'narri',
  'nartl',
  'nasal',
  'nasan',
  'nasar',
  'nasað',
  'nasin',
  'nasið',
  'naska',
  'naski',
  'nasks',
  'naskt',
  'naspa',
  'naspi',
  'nassa',
  'nassi',
  'nasum',
  'natig',
  'natin',
  'natið',
  'natna',
  'natni',
  'natnu',
  'natri',
  'natur',
  'natúr',
  'navar',
  'navað',
  'navir',
  'navið',
  'navna',
  'navni',
  'navns',
  'navnu',
  'navra',
  'navri',
  'navum',
  'nebba',
  'nebbi',
  'nebbu',
  'nefsa',
  'nefsi',
  'neggi',
  'neggj',
  'negla',
  'negld',
  'negli',
  'neglt',
  'neipa',
  'neipu',
  'neisa',
  'neisu',
  'neita',
  'neiti',
  'neitu',
  'nekka',
  'nekki',
  'nekta',
  'nekti',
  'nelik',
  'nella',
  'nelli',
  'neman',
  'nemið',
  'nemma',
  'nemmi',
  'nemmu',
  'nemra',
  'nemst',
  'nemur',
  'nemus',
  'nenna',
  'nenni',
  'nenti',
  'nentu',
  'neoni',
  'neons',
  'neppa',
  'nepsa',
  'nepsi',
  'nerta',
  'nerti',
  'nerva',
  'nervi',
  'nervu',
  'nesið',
  'nesja',
  'nesta',
  'nesti',
  'nesum',
  'netar',
  'netað',
  'netið',
  'netja',
  'netji',
  'netju',
  'netta',
  'netti',
  'netto',
  'nettu',
  'netum',
  'nevan',
  'nevar',
  'nevað',
  'nevin',
  'nevið',
  'nevja',
  'nevna',
  'nevnd',
  'nevni',
  'nevnt',
  'nevsa',
  'nevsi',
  'nevum',
  'neyar',
  'neyað',
  'neyið',
  'neyra',
  'neyri',
  'neyst',
  'neyta',
  'neyti',
  'neyts',
  'neyva',
  'neyvi',
  'neyvs',
  'neyvt',
  'neyvu',
  'neyða',
  'neðra',
  'niara',
  'niari',
  'nigil',
  'nigin',
  'nigið',
  'nigla',
  'nigli',
  'nigna',
  'nigni',
  'nignu',
  'nikka',
  'nikki',
  'nikku',
  'nikli',
  'nilka',
  'nilki',
  'nilks',
  'nilla',
  'nilli',
  'nilta',
  'nilti',
  'nilva',
  'nilvi',
  'ninar',
  'ninað',
  'ninið',
  'nipil',
  'nipin',
  'nipið',
  'nipla',
  'nipli',
  'niplu',
  'nipna',
  'nipni',
  'nipnu',
  'nippa',
  'nippu',
  'nispa',
  'nispi',
  'nisps',
  'nispu',
  'nissa',
  'nissi',
  'nissu',
  'nitir',
  'nitis',
  'nitið',
  'nitra',
  'nitru',
  'nitum',
  'niðan',
  'niðra',
  'niðri',
  'niður',
  'njell',
  'njelt',
  'njóra',
  'njóri',
  'njósa',
  'njósi',
  'njósk',
  'njósn',
  'njóst',
  'njóta',
  'njóti',
  'njóða',
  'njóði',
  'nokka',
  'nokki',
  'nokta',
  'nokti',
  'nolar',
  'nolað',
  'nolið',
  'nomin',
  'nomið',
  'nomna',
  'nomni',
  'nomnu',
  'nomum',
  'nonna',
  'nonnu',
  'normi',
  'norms',
  'norna',
  'nornu',
  'norsk',
  'nosið',
  'nosla',
  'nosli',
  'nossa',
  'nossi',
  'nossu',
  'nosum',
  'notan',
  'notar',
  'notat',
  'notin',
  'notir',
  'notið',
  'notna',
  'notni',
  'notnu',
  'notum',
  'notur',
  'noydd',
  'noyds',
  'noytt',
  'noyða',
  'noyði',
  'noðar',
  'noðað',
  'noðið',
  'noðum',
  'noður',
  'nubba',
  'nubbi',
  'nudla',
  'nudli',
  'nudlu',
  'nugga',
  'nuggi',
  'nulla',
  'nulli',
  'nulva',
  'nulvi',
  'numra',
  'nunna',
  'nunnu',
  'nupla',
  'nupli',
  'nurra',
  'nurri',
  'nurtu',
  'nurva',
  'nurvi',
  'nussa',
  'nussi',
  'nutar',
  'nutað',
  'nutið',
  'nuvla',
  'nuvli',
  'nykar',
  'nykil',
  'nykin',
  'nykka',
  'nykki',
  'nykla',
  'nykli',
  'nykst',
  'nykta',
  'nykti',
  'nykts',
  'nyktu',
  'nykum',
  'nykur',
  'nytra',
  'nytri',
  'nytru',
  'nytta',
  'nytti',
  'nyttu',
  'nytum',
  'nytur',
  'nyðra',
  'nyðru',
  'náast',
  'náaða',
  'náaði',
  'náaðs',
  'náaðu',
  'nábúa',
  'nábúi',
  'nádda',
  'náddi',
  'náddu',
  'náist',
  'nálar',
  'nálga',
  'nálgi',
  'nálgs',
  'nálin',
  'nálir',
  'nálum',
  'náman',
  'námar',
  'námað',
  'námir',
  'námið',
  'námum',
  'námur',
  'nánda',
  'nápar',
  'nápað',
  'nápin',
  'nápið',
  'nápum',
  'nápur',
  'nátan',
  'nátar',
  'nátin',
  'nátta',
  'nátti',
  'nátum',
  'nátur',
  'náðar',
  'náðað',
  'náðig',
  'náðin',
  'náðir',
  'náðið',
  'náðug',
  'náðum',
  'nældi',
  'nældu',
  'nælir',
  'nælið',
  'næman',
  'næmar',
  'næmir',
  'næmis',
  'næmið',
  'næmra',
  'næmur',
  'nærka',
  'nærki',
  'nærri',
  'nærum',
  'næsta',
  'næsti',
  'næsts',
  'næstu',
  'nætur',
  'nævur',
  'níddi',
  'níddu',
  'nígið',
  'nígur',
  'nípan',
  'nípir',
  'nípið',
  'nípti',
  'níptu',
  'nípum',
  'nípur',
  'nísan',
  'nísta',
  'nísti',
  'nísts',
  'nístu',
  'nísum',
  'nísur',
  'nítið',
  'nítur',
  'nívda',
  'nívdi',
  'nívds',
  'nívdu',
  'nívir',
  'nívið',
  'nívst',
  'níðir',
  'níðið',
  'níðsk',
  'nógva',
  'nógvi',
  'nógvu',
  'nónan',
  'nónin',
  'nónið',
  'nópar',
  'nópin',
  'nópum',
  'nópur',
  'nóran',
  'nórar',
  'nórin',
  'nórum',
  'nórur',
  'nósan',
  'nósar',
  'nósin',
  'nósum',
  'nótan',
  'nótar',
  'nótin',
  'nótir',
  'nótum',
  'nóðra',
  'nóðru',
  'nøgda',
  'nøgdi',
  'nøgds',
  'nøgdu',
  'nøgga',
  'nøggi',
  'nøgla',
  'nøglu',
  'nøgst',
  'nøgta',
  'nøgti',
  'nøkta',
  'nøkti',
  'nøkur',
  'nølar',
  'nølað',
  'nølið',
  'nørda',
  'nørdi',
  'nørds',
  'nørdu',
  'nørir',
  'nørið',
  'nørst',
  'nørta',
  'nørti',
  'nørts',
  'nøsin',
  'nøsku',
  'nøsum',
  'nøtan',
  'nøtar',
  'nøtin',
  'nøtir',
  'nøtra',
  'nøtri',
  'nøtum',
  'nøtur',
  'nøvan',
  'nøvin',
  'nøvum',
  'nøvur',
  'núgva',
  'núgvu',
  'núlig',
  'núpar',
  'núpin',
  'núpum',
  'núpur',
  'nútíð',
  'núvan',
  'núvum',
  'núvur',
  'nýara',
  'nýari',
  'nýaru',
  'nýast',
  'nýggi',
  'nýggj',
  'nýmet',
  'nýrað',
  'nýrna',
  'nýrum',
  'nýrur',
  'nýsur',
  'nýtan',
  'nýtar',
  'nýtir',
  'nýtið',
  'nýtra',
  'nýtst',
  'nýtta',
  'nýtti',
  'nýtts',
  'nýttu',
  'nýtum',
  'nýtur',
  'nýtíð',
  'nýval',
  'nývil',
  'nývir',
  'nývis',
  'nývið',
  'nývla',
  'nývli',
  'nývum',
  'nýára',
  'nýári',
  'nýárs',
  'nýøld',
  'oasan',
  'oasum',
  'oasur',
  'oddan',
  'oddar',
  'oddað',
  'oddin',
  'oddið',
  'oddum',
  'oddur',
  'offur',
  'ofrar',
  'ofrað',
  'ofrið',
  'ofrum',
  'ofsin',
  'ofsið',
  'ofsna',
  'ofsni',
  'ofsnu',
  'oftum',
  'ognan',
  'ognar',
  'ognað',
  'ognin',
  'ognir',
  'ognið',
  'ognum',
  'ohmið',
  'ohmum',
  'okans',
  'okara',
  'okari',
  'okaða',
  'okaði',
  'okaðs',
  'okaðu',
  'okini',
  'okkum',
  'okkur',
  'oknar',
  'oknin',
  'oknir',
  'oknum',
  'okrar',
  'okrað',
  'okrið',
  'oksan',
  'oksar',
  'oksað',
  'oksin',
  'oksið',
  'oksum',
  'oktan',
  'okurs',
  'oljan',
  'oljar',
  'oljað',
  'oljið',
  'oljum',
  'oljur',
  'oljut',
  'omaná',
  'omaní',
  'omega',
  'omegu',
  'omman',
  'ommba',
  'ommut',
  'omnia',
  'omnii',
  'ompil',
  'ompla',
  'ompli',
  'ondin',
  'ondum',
  'ongan',
  'ongar',
  'ongin',
  'ongir',
  'ongla',
  'ongli',
  'ongul',
  'ongum',
  'onkar',
  'onkað',
  'onkis',
  'onkið',
  'onkla',
  'onkli',
  'onkra',
  'onkul',
  'onkum',
  'onkun',
  'onkur',
  'ontin',
  'ontum',
  'opala',
  'opali',
  'opals',
  'opast',
  'opaða',
  'opaði',
  'opaðs',
  'opaðu',
  'opera',
  'operu',
  'opini',
  'opins',
  'opist',
  'opium',
  'opnan',
  'opnar',
  'opnað',
  'opnir',
  'opnið',
  'opnum',
  'opnur',
  'oprar',
  'oprað',
  'oprið',
  'opsin',
  'opsið',
  'opsna',
  'opsni',
  'opsnu',
  'opuna',
  'opuni',
  'orala',
  'orali',
  'orals',
  'oralt',
  'oralu',
  'ordan',
  'ordra',
  'ordri',
  'organ',
  'orkan',
  'orkar',
  'orkað',
  'orkið',
  'orlov',
  'ormin',
  'ormum',
  'ormur',
  'ornar',
  'ornað',
  'ornið',
  'orran',
  'orrar',
  'orrað',
  'orrin',
  'orrið',
  'orrum',
  'orrur',
  'orsak',
  'ortan',
  'ortar',
  'ortir',
  'ortra',
  'ortum',
  'ortur',
  'orvið',
  'orvum',
  'orðar',
  'orðað',
  'orðfá',
  'orðið',
  'orðna',
  'orðni',
  'orðum',
  'osans',
  'osara',
  'osaði',
  'osaðu',
  'osoni',
  'osons',
  'ostar',
  'ostin',
  'ostra',
  'ostru',
  'ostum',
  'ostur',
  'otana',
  'otast',
  'otaða',
  'otaði',
  'otaðs',
  'otaðu',
  'otist',
  'otrar',
  'otrað',
  'otrið',
  'otuna',
  'otuni',
  'ovala',
  'ovali',
  'ovals',
  'ovalt',
  'ovalu',
  'ovara',
  'ovari',
  'ovaru',
  'ovast',
  'ovbit',
  'oveta',
  'oveti',
  'ovfar',
  'ovfer',
  'ovfór',
  'ovlýs',
  'ovmet',
  'ovmøð',
  'ovnar',
  'ovnað',
  'ovnin',
  'ovnið',
  'ovnum',
  'ovnur',
  'ovróð',
  'ovrør',
  'ovsig',
  'ovsov',
  'ovsúp',
  'ovtak',
  'ovtók',
  'ovvit',
  'ováti',
  'ováts',
  'ovótu',
  'oydda',
  'oyddi',
  'oyddu',
  'oydna',
  'oydni',
  'oydnu',
  'oygda',
  'oygdi',
  'oygds',
  'oygdu',
  'oyggj',
  'oygla',
  'oygli',
  'oynna',
  'oynni',
  'oyran',
  'oyrar',
  'oyrað',
  'oyrin',
  'oyrna',
  'oyrum',
  'oyrur',
  'oysan',
  'oysir',
  'oysið',
  'oysta',
  'oysti',
  'oysts',
  'oystu',
  'oysum',
  'oysur',
  'oyðan',
  'oyðar',
  'oyðet',
  'oyðin',
  'oyðir',
  'oyðis',
  'oyðið',
  'oyðsl',
  'oyðst',
  'oyðum',
  'oyður',
  'oyðát',
  'ozoni',
  'ozons',
  'pabba',
  'padda',
  'paddu',
  'pakka',
  'pakki',
  'pakta',
  'palla',
  'palli',
  'panda',
  'pandu',
  'panna',
  'pannu',
  'panta',
  'panti',
  'pants',
  'papan',
  'papar',
  'papin',
  'pappa',
  'pappi',
  'papum',
  'parar',
  'parað',
  'paria',
  'pariu',
  'parið',
  'parka',
  'parki',
  'parta',
  'parti',
  'parts',
  'partí',
  'passa',
  'passi',
  'pasta',
  'pastu',
  'pauka',
  'pauku',
  'pausa',
  'pausu',
  'pavna',
  'pavni',
  'pavns',
  'pavst',
  'paðar',
  'paðað',
  'paðið',
  'paðum',
  'pedal',
  'pegil',
  'pegla',
  'pegli',
  'peiar',
  'peiað',
  'peiga',
  'peigi',
  'peiið',
  'peika',
  'peiki',
  'peila',
  'peili',
  'peisa',
  'pekan',
  'pekar',
  'pekin',
  'pekum',
  'pekur',
  'pelan',
  'pelar',
  'pelin',
  'pella',
  'pelli',
  'pelsa',
  'pelsi',
  'pelum',
  'pelur',
  'pempa',
  'pempi',
  'penan',
  'penar',
  'penga',
  'pengi',
  'penir',
  'penna',
  'penni',
  'penta',
  'penti',
  'pentu',
  'penum',
  'penur',
  'peran',
  'perik',
  'perla',
  'perli',
  'perls',
  'perlu',
  'perma',
  'permu',
  'persa',
  'persi',
  'persu',
  'perur',
  'pesin',
  'pesja',
  'pesju',
  'pesta',
  'pesti',
  'pests',
  'petta',
  'petti',
  'peyra',
  'peyri',
  'peðið',
  'peðum',
  'piano',
  'piara',
  'piari',
  'pifta',
  'pifti',
  'pikka',
  'pikki',
  'pikku',
  'piksa',
  'piksi',
  'pikta',
  'pikti',
  'pilið',
  'pilka',
  'pilki',
  'pilks',
  'pilla',
  'pilli',
  'pilot',
  'pilsa',
  'pilsi',
  'pilta',
  'pilti',
  'pilts',
  'pilum',
  'pimpa',
  'pimpi',
  'pinja',
  'pinju',
  'pinka',
  'pinki',
  'pinks',
  'pinku',
  'pinna',
  'pinni',
  'pinta',
  'pinti',
  'pints',
  'pipar',
  'pippa',
  'pippi',
  'pippu',
  'pipra',
  'pipri',
  'pirar',
  'pirin',
  'pirka',
  'pirki',
  'pirks',
  'pirkt',
  'pirku',
  'pirra',
  'pirri',
  'pirru',
  'pirtl',
  'pirum',
  'pirur',
  'pisan',
  'pisið',
  'piska',
  'pisku',
  'pissa',
  'pissi',
  'pisum',
  'pisur',
  'pisut',
  'pitil',
  'pitla',
  'pitli',
  'pitlu',
  'pitsa',
  'pitsu',
  'pitta',
  'pitti',
  'piðar',
  'piðað',
  'piðið',
  'pjaga',
  'pjagi',
  'pjaka',
  'pjaki',
  'pjaks',
  'pjank',
  'pjapp',
  'pjaps',
  'pjask',
  'pjonk',
  'pjága',
  'pjági',
  'pjáka',
  'pjáki',
  'pjáks',
  'pjána',
  'pjáni',
  'pjáta',
  'pjáti',
  'pjáts',
  'pjøga',
  'pjøgi',
  'pjøgs',
  'pjøka',
  'pjøki',
  'pjøks',
  'pjøpp',
  'pjøps',
  'pjøss',
  'plaga',
  'plagg',
  'plagi',
  'plags',
  'plagt',
  'plana',
  'plani',
  'plans',
  'plast',
  'plats',
  'platt',
  'pleir',
  'plena',
  'plenu',
  'plets',
  'plett',
  'pleyr',
  'pliki',
  'pliks',
  'plikt',
  'plink',
  'plint',
  'pluss',
  'plága',
  'plági',
  'plágu',
  'plána',
  'pláni',
  'pláns',
  'pláss',
  'pláta',
  'plátu',
  'plógs',
  'plógv',
  'pløga',
  'pløgd',
  'pløgg',
  'pløgi',
  'pløgt',
  'plúss',
  'podia',
  'podii',
  'poeng',
  'poesi',
  'pokan',
  'pokar',
  'pokin',
  'pokna',
  'poknu',
  'poksi',
  'pokum',
  'pokur',
  'pokut',
  'polio',
  'polka',
  'polla',
  'polli',
  'popla',
  'popli',
  'poppi',
  'porra',
  'porru',
  'posan',
  'posar',
  'posin',
  'posta',
  'posti',
  'posts',
  'posum',
  'posut',
  'potar',
  'potað',
  'potið',
  'potta',
  'potti',
  'potum',
  'poyar',
  'poyað',
  'poyið',
  'poðar',
  'poðað',
  'poðið',
  'poðum',
  'poðut',
  'prega',
  'pregi',
  'pregs',
  'preia',
  'preii',
  'preis',
  'prena',
  'preni',
  'prens',
  'prent',
  'prepi',
  'preps',
  'presi',
  'press',
  'prest',
  'preta',
  'preti',
  'prets',
  'previ',
  'prevs',
  'prika',
  'priki',
  'prikk',
  'priks',
  'primo',
  'prins',
  'pripp',
  'prips',
  'priða',
  'priði',
  'propp',
  'props',
  'prosa',
  'prosu',
  'proys',
  'prump',
  'prunk',
  'prusa',
  'prusi',
  'pruta',
  'pruti',
  'prutl',
  'prutu',
  'prála',
  'práli',
  'práls',
  'práma',
  'prámi',
  'práms',
  'prása',
  'prási',
  'práta',
  'práti',
  'práts',
  'príla',
  'príli',
  'príls',
  'prísa',
  'prísi',
  'prógv',
  'próna',
  'próni',
  'próns',
  'próst',
  'próvs',
  'prøva',
  'prøvi',
  'prúdd',
  'prútt',
  'prúða',
  'prúði',
  'prúðs',
  'prúðu',
  'prýdd',
  'prýds',
  'prýtt',
  'prýða',
  'prýði',
  'psyka',
  'psyku',
  'puaði',
  'puaðu',
  'puffa',
  'puffi',
  'pukka',
  'pukki',
  'pulja',
  'pulju',
  'pulka',
  'pulki',
  'pulla',
  'pulli',
  'pulsi',
  'pulta',
  'pulti',
  'pults',
  'puman',
  'pumma',
  'pummi',
  'pumpa',
  'pumpi',
  'pumpu',
  'pumsa',
  'pumsi',
  'pumum',
  'pumur',
  'punda',
  'pundi',
  'punds',
  'punga',
  'pungi',
  'pungs',
  'punkt',
  'punsa',
  'punsi',
  'punsj',
  'punss',
  'punta',
  'punti',
  'punts',
  'purka',
  'purku',
  'purla',
  'purli',
  'purlu',
  'purra',
  'purri',
  'purru',
  'pusar',
  'pusað',
  'pusið',
  'pussa',
  'pussi',
  'putla',
  'putli',
  'putls',
  'putlu',
  'putra',
  'putri',
  'putta',
  'putti',
  'putur',
  'puuna',
  'puuni',
  'puuta',
  'puuti',
  'puuts',
  'puutu',
  'pygme',
  'pyksa',
  'pyksi',
  'pylsa',
  'pylsu',
  'pynta',
  'pynti',
  'pynts',
  'pábót',
  'pálmi',
  'pálur',
  'pápan',
  'pápar',
  'pápin',
  'pápum',
  'páska',
  'pátra',
  'pátri',
  'pávan',
  'pávar',
  'pávin',
  'pávum',
  'píkan',
  'píkar',
  'píkað',
  'píkin',
  'píkið',
  'píkum',
  'píkur',
  'pílan',
  'pílar',
  'pílað',
  'pílik',
  'pílin',
  'pílir',
  'pílið',
  'pílla',
  'pílli',
  'pílum',
  'pílur',
  'pínan',
  'pínar',
  'pínað',
  'pínda',
  'píndi',
  'pínds',
  'píndu',
  'pínir',
  'pínið',
  'pínsl',
  'pínst',
  'pínum',
  'pínur',
  'pípan',
  'pípar',
  'pípað',
  'pípil',
  'pípið',
  'pípla',
  'pípli',
  'pípum',
  'pípur',
  'píran',
  'pírdi',
  'pírdu',
  'pírin',
  'pírir',
  'pírið',
  'pírna',
  'pírni',
  'pírnu',
  'pírum',
  'pírur',
  'pírut',
  'píska',
  'píski',
  'písks',
  'pískt',
  'písku',
  'pístr',
  'pólsk',
  'pólís',
  'pørum',
  'pøsar',
  'pøsin',
  'pøsir',
  'pøsið',
  'pøsta',
  'pøsti',
  'pøsts',
  'pøstu',
  'pøsum',
  'pøðan',
  'pøðum',
  'pøður',
  'pøðut',
  'púkan',
  'púkar',
  'púkin',
  'púkum',
  'púlar',
  'púlað',
  'púlið',
  'púran',
  'púrar',
  'púrga',
  'púrgi',
  'púrir',
  'púrum',
  'púrur',
  'púsin',
  'púsið',
  'púsna',
  'púsni',
  'púsnu',
  'pústi',
  'pústr',
  'pústs',
  'pútan',
  'pútum',
  'pútur',
  'pýggi',
  'pýggj',
  'radda',
  'radio',
  'rafta',
  'ragga',
  'raggi',
  'ragla',
  'ragli',
  'ragna',
  'ragni',
  'rakan',
  'rakar',
  'rakað',
  'rakið',
  'rakka',
  'rakki',
  'rakna',
  'rakni',
  'rakst',
  'rakta',
  'rakti',
  'rakts',
  'raktu',
  'rakum',
  'rakár',
  'ralar',
  'ralað',
  'ralið',
  'ralla',
  'ralli',
  'raman',
  'ramar',
  'ramin',
  'ramir',
  'ramma',
  'rammi',
  'rammu',
  'ramra',
  'ramsa',
  'ramsi',
  'ramsu',
  'ramur',
  'ranan',
  'ranar',
  'randa',
  'randi',
  'ranfa',
  'ranfu',
  'ranga',
  'rangi',
  'rangs',
  'rangt',
  'rangu',
  'ranin',
  'ranka',
  'ranki',
  'ranks',
  'rankt',
  'ranna',
  'ranni',
  'ranst',
  'ranum',
  'rapar',
  'rapað',
  'rapið',
  'rapla',
  'rapli',
  'rapls',
  'rappa',
  'rappi',
  'rapul',
  'rasan',
  'rasar',
  'rasað',
  'rasið',
  'raska',
  'raski',
  'rasks',
  'raskt',
  'raspa',
  'raspi',
  'rasps',
  'rassa',
  'rassi',
  'rasum',
  'rasur',
  'ratta',
  'ratti',
  'ravan',
  'ravar',
  'ravað',
  'ravin',
  'ravið',
  'ravna',
  'ravni',
  'ravns',
  'ravum',
  'ravur',
  'raðan',
  'raðar',
  'raðað',
  'raðir',
  'raðið',
  'raðsá',
  'raðum',
  'reala',
  'reali',
  'reals',
  'realt',
  'realu',
  'redar',
  'redda',
  'reddi',
  'redik',
  'redin',
  'redir',
  'redum',
  'reger',
  'regla',
  'regli',
  'reglu',
  'regna',
  'regni',
  'regns',
  'regul',
  'reidd',
  'reids',
  'reigs',
  'reika',
  'reiki',
  'reiks',
  'reima',
  'reina',
  'reini',
  'reins',
  'reint',
  'reinu',
  'reion',
  'reipa',
  'reipi',
  'reips',
  'reisa',
  'reisi',
  'reist',
  'reisu',
  'reita',
  'reiti',
  'reits',
  'reitt',
  'reiva',
  'reivi',
  'reivs',
  'reiða',
  'reiði',
  'reiðs',
  'reiðu',
  'rekan',
  'rekar',
  'rekil',
  'rekin',
  'rekir',
  'rekið',
  'rekja',
  'rekka',
  'rekki',
  'rekla',
  'rekli',
  'reksa',
  'reksi',
  'rekst',
  'reksu',
  'rekta',
  'rekti',
  'rekts',
  'rektu',
  'rekum',
  'rekur',
  'remba',
  'rembi',
  'rembt',
  'remma',
  'remmu',
  'remsa',
  'remsi',
  'remsu',
  'renda',
  'rendi',
  'rends',
  'rendu',
  'renir',
  'renið',
  'renla',
  'renli',
  'renna',
  'renni',
  'rennu',
  'rensl',
  'renst',
  'renta',
  'renti',
  'rentu',
  'repar',
  'repað',
  'repil',
  'repið',
  'repla',
  'repli',
  'reppa',
  'reppi',
  'repum',
  'resta',
  'resti',
  'revar',
  'revil',
  'revin',
  'revla',
  'revli',
  'revsa',
  'revsi',
  'revum',
  'revur',
  'reyan',
  'reyka',
  'reyki',
  'reyks',
  'reyla',
  'reyli',
  'reyna',
  'reyni',
  'reyns',
  'reypa',
  'reypi',
  'reyps',
  'reyst',
  'reytt',
  'reyum',
  'reyur',
  'reyva',
  'reyða',
  'reyði',
  'reyðs',
  'reyðu',
  'reðka',
  'reðku',
  'reðra',
  'reðri',
  'reður',
  'ribsa',
  'ribsi',
  'ridla',
  'ridli',
  'ridls',
  'rifla',
  'riflu',
  'rifta',
  'rifti',
  'rifts',
  'rigga',
  'riggi',
  'rigna',
  'rigni',
  'rignt',
  'rikin',
  'rikið',
  'rikna',
  'rikni',
  'riknu',
  'rilka',
  'rilki',
  'rilpa',
  'rilpi',
  'rilta',
  'rilti',
  'rimar',
  'rimað',
  'rimil',
  'rimin',
  'rimið',
  'rimla',
  'rimli',
  'rimpa',
  'rimpi',
  'rimum',
  'rinar',
  'rinað',
  'ringa',
  'ringd',
  'ringi',
  'rings',
  'ringt',
  'ringu',
  'rinið',
  'rinka',
  'rinki',
  'rinum',
  'ripar',
  'ripað',
  'ripið',
  'rippa',
  'rippi',
  'rippu',
  'ripsa',
  'ripsi',
  'ripst',
  'ripta',
  'ripti',
  'ripts',
  'riptu',
  'ripum',
  'risan',
  'risar',
  'risin',
  'risið',
  'riska',
  'riski',
  'risks',
  'risla',
  'risli',
  'risna',
  'risni',
  'risnu',
  'rispa',
  'rispi',
  'rista',
  'risti',
  'rists',
  'ristu',
  'risum',
  'ritan',
  'ritar',
  'ritað',
  'ritil',
  'ritið',
  'ritla',
  'ritli',
  'ritna',
  'ritni',
  'ritnu',
  'ritum',
  'ritur',
  'ritut',
  'rival',
  'rivan',
  'rivar',
  'rivað',
  'rivin',
  'rivið',
  'rivja',
  'rivji',
  'rivju',
  'rivna',
  'rivni',
  'rivnu',
  'rivum',
  'rivur',
  'rivut',
  'riðan',
  'riðar',
  'riðað',
  'riðil',
  'riðin',
  'riðið',
  'riðla',
  'riðli',
  'riðna',
  'riðni',
  'riðnu',
  'riðul',
  'riðum',
  'rjóma',
  'rjómi',
  'rjóta',
  'rjóti',
  'rjóða',
  'rjóði',
  'rodda',
  'roddi',
  'rodna',
  'rodni',
  'roffa',
  'roffi',
  'rogga',
  'roggi',
  'rogna',
  'rogni',
  'rogns',
  'rokan',
  'rokar',
  'rokað',
  'rokin',
  'rokið',
  'rokka',
  'rokki',
  'rokna',
  'rokni',
  'roknu',
  'roksa',
  'roksi',
  'roksl',
  'rokum',
  'rokur',
  'rokut',
  'rokár',
  'rolla',
  'rolli',
  'rollu',
  'roman',
  'romar',
  'romba',
  'rombu',
  'romin',
  'rommi',
  'romum',
  'rongu',
  'ronku',
  'ronta',
  'ronti',
  'ronts',
  'ropar',
  'ropað',
  'ropið',
  'roppa',
  'roppi',
  'roppu',
  'ropum',
  'rossa',
  'rossi',
  'rotan',
  'rotar',
  'rotað',
  'rotin',
  'rotið',
  'rotna',
  'rotni',
  'rotnu',
  'rotor',
  'rotta',
  'rotti',
  'rottu',
  'rotum',
  'rotur',
  'rovan',
  'rovar',
  'rovað',
  'rovið',
  'rovum',
  'rovur',
  'royal',
  'royki',
  'royks',
  'roykt',
  'royna',
  'roynd',
  'royni',
  'roynt',
  'royra',
  'royrd',
  'royri',
  'royrt',
  'royta',
  'royti',
  'royts',
  'roytt',
  'royva',
  'royvi',
  'royvt',
  'royða',
  'royðu',
  'roðan',
  'roðar',
  'roðað',
  'roðin',
  'roðið',
  'roðum',
  'roðál',
  'rubba',
  'rubbi',
  'rubil',
  'rubin',
  'rubla',
  'rubli',
  'rudda',
  'ruddi',
  'ruddu',
  'ruffa',
  'ruffi',
  'rufla',
  'rufli',
  'rufsa',
  'rufsi',
  'rugga',
  'ruggi',
  'rugin',
  'rugur',
  'rukka',
  'rukki',
  'rukku',
  'rulka',
  'rulki',
  'rulks',
  'rulku',
  'rulla',
  'rulli',
  'rullu',
  'rumba',
  'rumdi',
  'rumdu',
  'rumla',
  'rumli',
  'rumma',
  'rummi',
  'rumpa',
  'rumpu',
  'rumsa',
  'rumsi',
  'runan',
  'runar',
  'runað',
  'runda',
  'rundi',
  'runds',
  'rundu',
  'runga',
  'rungi',
  'rungs',
  'rungu',
  'runin',
  'runið',
  'runka',
  'runki',
  'runks',
  'runna',
  'runni',
  'runnu',
  'runsa',
  'runsi',
  'runum',
  'runut',
  'rupan',
  'rupla',
  'rupli',
  'rupls',
  'ruplu',
  'rupul',
  'rupum',
  'rupur',
  'rural',
  'ruran',
  'rurar',
  'rurað',
  'rurið',
  'rusar',
  'rusað',
  'rusið',
  'ruska',
  'ruski',
  'rusks',
  'rusla',
  'rusli',
  'rusls',
  'ruspa',
  'ruspi',
  'rusps',
  'russa',
  'russi',
  'rusta',
  'rusti',
  'rusts',
  'rusum',
  'rusut',
  'rutan',
  'rutað',
  'rutið',
  'rutla',
  'rutli',
  'rutum',
  'rutur',
  'ruvið',
  'ruvum',
  'ruðan',
  'ruðri',
  'ruðum',
  'ruður',
  'rygda',
  'rygdi',
  'rygds',
  'rygdu',
  'ryggi',
  'rygna',
  'rygnd',
  'rygni',
  'rygnt',
  'rykka',
  'rykki',
  'rykst',
  'rykta',
  'rykti',
  'rykts',
  'ryktu',
  'rylki',
  'rylkt',
  'rymið',
  'rymja',
  'rymji',
  'rymur',
  'ryski',
  'rysks',
  'ryssa',
  'ryssu',
  'rytan',
  'rytma',
  'rytmu',
  'rytta',
  'ryttu',
  'rytum',
  'rytur',
  'ryvja',
  'ryvju',
  'ryðið',
  'ryðja',
  'ryður',
  'ráans',
  'ráara',
  'ráari',
  'ráaru',
  'ráast',
  'rábít',
  'rádda',
  'ráddi',
  'ráddu',
  'rádna',
  'rádni',
  'rádnu',
  'rádýr',
  'ráfræ',
  'ráina',
  'ráini',
  'rákan',
  'rákar',
  'rákin',
  'rákið',
  'rákum',
  'rákís',
  'rálig',
  'ráman',
  'rámar',
  'rámað',
  'rámin',
  'rámir',
  'rámið',
  'rámum',
  'rámur',
  'ránað',
  'ránir',
  'ránið',
  'ránna',
  'ránni',
  'ránsk',
  'ránti',
  'rántu',
  'ránum',
  'ráran',
  'rárar',
  'rárig',
  'rárir',
  'rárum',
  'rárur',
  'rásan',
  'rásar',
  'rásað',
  'rásin',
  'rásir',
  'rásið',
  'rásum',
  'rátýð',
  'rávan',
  'rávið',
  'rávum',
  'rávur',
  'ráðin',
  'ráðir',
  'ráðis',
  'ráðið',
  'ráðst',
  'ráðum',
  'ræast',
  'rædda',
  'ræddi',
  'ræddu',
  'rædna',
  'rædni',
  'rædnu',
  'rædýr',
  'ræini',
  'ræist',
  'rækja',
  'rækju',
  'rælar',
  'rælin',
  'rælum',
  'rælur',
  'ræmda',
  'ræmdi',
  'ræmds',
  'ræmdu',
  'ræmir',
  'ræmið',
  'rænda',
  'rændi',
  'rænds',
  'rændu',
  'rænir',
  'rænið',
  'rænst',
  'rænum',
  'ræsir',
  'ræsis',
  'ræsið',
  'ræsna',
  'ræsni',
  'ræsta',
  'ræsti',
  'ræsts',
  'ræstu',
  'ræsum',
  'ræsur',
  'rætla',
  'rætli',
  'rætna',
  'rætni',
  'rætst',
  'rætta',
  'rætti',
  'rættu',
  'rævri',
  'rævur',
  'ræðan',
  'ræðil',
  'ræðin',
  'ræðir',
  'ræðis',
  'ræðið',
  'ræðla',
  'ræðli',
  'ræðst',
  'ræðum',
  'ræður',
  'ríggi',
  'rígna',
  'rígni',
  'rígnu',
  'ríkan',
  'ríkar',
  'ríkað',
  'ríkir',
  'ríkis',
  'ríkið',
  'ríkja',
  'ríkra',
  'ríkti',
  'ríktu',
  'ríkum',
  'ríkur',
  'rílig',
  'ríman',
  'rímar',
  'rímað',
  'rímið',
  'rímum',
  'rímur',
  'rínið',
  'rínsk',
  'rínur',
  'rípan',
  'rípar',
  'rípað',
  'rípið',
  'rípum',
  'rípur',
  'ríput',
  'rísin',
  'rísið',
  'rísla',
  'rísli',
  'rísna',
  'rísni',
  'rísnu',
  'rísum',
  'rísur',
  'rísut',
  'rívan',
  'rívin',
  'rívið',
  'rívna',
  'rívni',
  'rívnu',
  'rívst',
  'rívum',
  'rívur',
  'ríðar',
  'ríðin',
  'ríðir',
  'ríðið',
  'ríðst',
  'ríðum',
  'ríður',
  'róaru',
  'róast',
  'róaða',
  'róaði',
  'róaðs',
  'róaðu',
  'rógva',
  'rógvi',
  'rógvu',
  'rókar',
  'rókað',
  'rókin',
  'rókið',
  'rókum',
  'rókur',
  'rókut',
  'rólag',
  'rólan',
  'rólar',
  'rólað',
  'rólig',
  'rólið',
  'róløg',
  'róman',
  'rómar',
  'rómað',
  'rómin',
  'rómið',
  'rómur',
  'rónan',
  'rónar',
  'rónir',
  'rónna',
  'rónni',
  'rónum',
  'rópan',
  'rópið',
  'rópta',
  'rópti',
  'rópts',
  'róptu',
  'rópum',
  'rósan',
  'rósar',
  'rósað',
  'rósin',
  'rósir',
  'rósið',
  'rósum',
  'rósur',
  'rósut',
  'rótan',
  'rótar',
  'rótað',
  'rótin',
  'rótið',
  'rótum',
  'róvan',
  'róvum',
  'róvur',
  'róðra',
  'róðri',
  'rødda',
  'røddi',
  'røddu',
  'røkan',
  'røkil',
  'røkin',
  'røkir',
  'røkið',
  'røkja',
  'røkju',
  'røkka',
  'røkki',
  'røkla',
  'røkli',
  'røkna',
  'røkni',
  'røknu',
  'røkst',
  'røkta',
  'røkti',
  'røkts',
  'røktu',
  'røkum',
  'røkur',
  'rølik',
  'rønta',
  'rønti',
  'rørda',
  'rørdi',
  'rørds',
  'rørdu',
  'rørir',
  'rørið',
  'rørst',
  'rørum',
  'røsku',
  'røsta',
  'røstu',
  'røttu',
  'røtur',
  'røvar',
  'røvað',
  'røvil',
  'røvið',
  'røvla',
  'røvli',
  'røðan',
  'røðil',
  'røðin',
  'røðir',
  'røðið',
  'røðla',
  'røðli',
  'røðum',
  'røður',
  'røðut',
  'rúgva',
  'rúgvi',
  'rúgvu',
  'rúkið',
  'rúman',
  'rúmar',
  'rúmda',
  'rúmdi',
  'rúmds',
  'rúmdu',
  'rúmin',
  'rúmir',
  'rúmið',
  'rúmka',
  'rúmki',
  'rúmum',
  'rúmur',
  'rúmár',
  'rúnar',
  'rúnað',
  'rúnin',
  'rúnir',
  'rúnið',
  'rúnum',
  'rúsan',
  'rúsar',
  'rúsað',
  'rúsin',
  'rúsir',
  'rúsið',
  'rúsum',
  'rúsur',
  'rúsut',
  'rútar',
  'rútin',
  'rútir',
  'rútum',
  'rútur',
  'rútut',
  'rúðri',
  'rúður',
  'rýdda',
  'rýddi',
  'rýddu',
  'rýkur',
  'rýmda',
  'rýmdi',
  'rýmds',
  'rýmdu',
  'rýmir',
  'rýmið',
  'rýmst',
  'rýpan',
  'rýpum',
  'rýpur',
  'rýtir',
  'rýtið',
  'rýtma',
  'rýtmu',
  'rýtti',
  'rýttu',
  'rýtur',
  'rýðir',
  'rýðið',
  'rýðst',
  'safir',
  'safta',
  'sagan',
  'sagar',
  'sagað',
  'sagda',
  'sagdi',
  'sagds',
  'sagdu',
  'sagga',
  'saggi',
  'sagin',
  'sagir',
  'sagið',
  'sagna',
  'sagst',
  'sagum',
  'sakan',
  'sakar',
  'sakin',
  'sakir',
  'sakna',
  'sakni',
  'sakns',
  'saksa',
  'saksi',
  'sakst',
  'saksu',
  'sakta',
  'sakti',
  'sakum',
  'salat',
  'salgi',
  'salgs',
  'salin',
  'salir',
  'salið',
  'salla',
  'salli',
  'salsa',
  'salta',
  'salti',
  'salts',
  'salum',
  'salur',
  'salva',
  'salvi',
  'salvu',
  'samal',
  'saman',
  'samar',
  'samba',
  'samda',
  'samdi',
  'samds',
  'samdu',
  'samir',
  'samis',
  'samið',
  'samla',
  'samli',
  'samra',
  'samst',
  'samur',
  'sanda',
  'sandi',
  'sands',
  'sanga',
  'sangi',
  'sangs',
  'sanka',
  'sanki',
  'sanks',
  'sanna',
  'sanni',
  'sanra',
  'sansa',
  'sansi',
  'sarpa',
  'sarpi',
  'sarps',
  'sarpu',
  'satin',
  'satsa',
  'satsi',
  'satst',
  'sauna',
  'saunu',
  'saval',
  'savna',
  'savni',
  'savns',
  'saðil',
  'saðla',
  'saðli',
  'sebra',
  'sebru',
  'seggi',
  'segla',
  'segli',
  'segls',
  'segði',
  'seigs',
  'seila',
  'seili',
  'seina',
  'seini',
  'seins',
  'seint',
  'seinu',
  'seiða',
  'seiði',
  'seiðs',
  'sekan',
  'sekar',
  'sekað',
  'sekir',
  'sekki',
  'sekra',
  'seksa',
  'seksu',
  'sekta',
  'sekti',
  'sekum',
  'sekur',
  'selan',
  'selar',
  'selda',
  'seldi',
  'selds',
  'seldu',
  'selin',
  'selir',
  'selja',
  'selji',
  'sella',
  'selli',
  'sellu',
  'selst',
  'selum',
  'selur',
  'semda',
  'semil',
  'semis',
  'semið',
  'semja',
  'semji',
  'semju',
  'semla',
  'semli',
  'semst',
  'semur',
  'senat',
  'senda',
  'sendi',
  'sends',
  'sendu',
  'senta',
  'senti',
  'sents',
  'seran',
  'serar',
  'serba',
  'serbi',
  'seria',
  'serir',
  'seriu',
  'serki',
  'serum',
  'serur',
  'serva',
  'servi',
  'servu',
  'seráf',
  'sesam',
  'sessa',
  'sessi',
  'setan',
  'setar',
  'setin',
  'setir',
  'setis',
  'setið',
  'setja',
  'setji',
  'setra',
  'setri',
  'setst',
  'setta',
  'setti',
  'settu',
  'setur',
  'sevil',
  'sevið',
  'sevja',
  'sevju',
  'sevla',
  'sevli',
  'sevum',
  'sexið',
  'sexut',
  'seyma',
  'seymi',
  'seyms',
  'seyra',
  'seyri',
  'seysa',
  'seyða',
  'seyði',
  'seðil',
  'seðla',
  'seðli',
  'shaha',
  'shahi',
  'shahs',
  'sibba',
  'sibbi',
  'sigar',
  'sigda',
  'sigga',
  'siggi',
  'siggu',
  'sigin',
  'sigið',
  'sigla',
  'sigld',
  'sigli',
  'siglt',
  'signa',
  'signi',
  'signu',
  'sigra',
  'sigri',
  'sigst',
  'sigul',
  'sigum',
  'sigur',
  'sikha',
  'sikhi',
  'sikhs',
  'sikta',
  'sikti',
  'silar',
  'silað',
  'silda',
  'silið',
  'silja',
  'silji',
  'silju',
  'silki',
  'silla',
  'silli',
  'sillu',
  'silpa',
  'silpu',
  'silum',
  'simma',
  'simmi',
  'simra',
  'simri',
  'sinan',
  'sinar',
  'sinin',
  'sinka',
  'sinki',
  'sinks',
  'sinna',
  'sinni',
  'sinop',
  'sinst',
  'sinta',
  'sinti',
  'sints',
  'sintu',
  'sinum',
  'sinur',
  'sipan',
  'sipar',
  'sipað',
  'sipið',
  'sipum',
  'sipur',
  'sirja',
  'sirju',
  'sirka',
  'sirma',
  'sirmi',
  'sirms',
  'sirmu',
  'sirop',
  'sirra',
  'sirri',
  'sirru',
  'sirsi',
  'sirum',
  'sissa',
  'sissi',
  'sitar',
  'sitat',
  'sitin',
  'sitið',
  'sitja',
  'sitji',
  'sitna',
  'sitni',
  'sitnu',
  'sitst',
  'situr',
  'sivil',
  'sivji',
  'siðan',
  'siðar',
  'siðað',
  'siðin',
  'siðir',
  'siðið',
  'siðum',
  'siður',
  'sjabb',
  'sjabs',
  'sjaga',
  'sjagg',
  'sjagi',
  'sjags',
  'sjakk',
  'sjaks',
  'sjali',
  'sjals',
  'sjang',
  'sjarr',
  'sjars',
  'sjask',
  'sjava',
  'sjavi',
  'sjavs',
  'sjefa',
  'sjefi',
  'sjefs',
  'sjeik',
  'sjela',
  'sjeya',
  'sjeyu',
  'sjokk',
  'sjoks',
  'sjong',
  'sjunt',
  'sjuss',
  'sjála',
  'sjáli',
  'sjáls',
  'sjálv',
  'sjáva',
  'sjávi',
  'sjógv',
  'sjóna',
  'sjónd',
  'sjóða',
  'sjóði',
  'sjóðs',
  'sjøta',
  'sjøti',
  'sjøts',
  'sjúar',
  'sjúað',
  'sjúið',
  'sjúka',
  'sjúki',
  'sjúks',
  'sjúkt',
  'sjúku',
  'sjúti',
  'skaff',
  'skafs',
  'skaft',
  'skaka',
  'skaki',
  'skakk',
  'skaks',
  'skakt',
  'skala',
  'skald',
  'skali',
  'skals',
  'skalt',
  'skalv',
  'skamm',
  'skams',
  'skamt',
  'skank',
  'skapa',
  'skapi',
  'skaps',
  'skapt',
  'skara',
  'skari',
  'skarn',
  'skarp',
  'skars',
  'skart',
  'skarv',
  'skarð',
  'skata',
  'skati',
  'skats',
  'skatt',
  'skatu',
  'skava',
  'skavi',
  'skavs',
  'skaða',
  'skaði',
  'skedd',
  'skeft',
  'skega',
  'skegg',
  'skegi',
  'skegs',
  'skegu',
  'skein',
  'skeit',
  'skeiv',
  'skeið',
  'skeka',
  'skeki',
  'skeks',
  'skeku',
  'skeld',
  'skelk',
  'skell',
  'skelm',
  'skels',
  'skelt',
  'skelv',
  'skema',
  'skemd',
  'skemm',
  'skemt',
  'skemu',
  'skera',
  'skerd',
  'skeri',
  'skerj',
  'skerm',
  'skerp',
  'skers',
  'skert',
  'skerv',
  'skett',
  'skeyt',
  'skift',
  'skikk',
  'skiks',
  'skila',
  'skild',
  'skili',
  'skilp',
  'skils',
  'skilt',
  'skima',
  'skimi',
  'skiml',
  'skina',
  'skini',
  'skinn',
  'skins',
  'skinu',
  'skipa',
  'skipi',
  'skips',
  'skipu',
  'skira',
  'skiri',
  'skirs',
  'skirt',
  'skiru',
  'skitl',
  'skits',
  'skitt',
  'skitu',
  'skiva',
  'skivi',
  'skivu',
  'skjal',
  'skjar',
  'skjað',
  'skját',
  'skjól',
  'skjót',
  'skjøl',
  'skjør',
  'skjúl',
  'skola',
  'skoli',
  'skols',
  'skolu',
  'skomm',
  'skona',
  'skonk',
  'skons',
  'skopa',
  'skopi',
  'skopu',
  'skora',
  'skori',
  'skort',
  'skoru',
  'skota',
  'skoti',
  'skots',
  'skott',
  'skoyn',
  'skoyt',
  'skoða',
  'skoði',
  'skrev',
  'skriv',
  'skrið',
  'skruv',
  'skryð',
  'skráa',
  'skrái',
  'skrál',
  'skrán',
  'skráp',
  'skrás',
  'skráu',
  'skráv',
  'skræm',
  'skræð',
  'skrím',
  'skrín',
  'skríð',
  'skról',
  'skróv',
  'skrúv',
  'skrúð',
  'skrýv',
  'skrýð',
  'skula',
  'skuld',
  'skuli',
  'skulu',
  'skump',
  'skund',
  'skura',
  'skuri',
  'skurr',
  'skurs',
  'skurv',
  'skurð',
  'skuta',
  'skuti',
  'skutu',
  'skver',
  'skygd',
  'skygg',
  'skygt',
  'skyld',
  'skylt',
  'skyni',
  'skynn',
  'skyns',
  'skynt',
  'skypa',
  'skypi',
  'skyri',
  'skyrs',
  'skáan',
  'skáar',
  'skáin',
  'skáir',
  'skáið',
  'skáka',
  'skáki',
  'skáks',
  'skála',
  'skáld',
  'skáli',
  'skálk',
  'skálm',
  'skápa',
  'skápi',
  'skáps',
  'skára',
  'skári',
  'skátt',
  'skáum',
  'skáur',
  'skæra',
  'skæri',
  'skærs',
  'skært',
  'skæru',
  'skína',
  'skíni',
  'skíra',
  'skírd',
  'skíri',
  'skírn',
  'skírs',
  'skírt',
  'skíru',
  'skíta',
  'skíti',
  'skíts',
  'skíða',
  'skíði',
  'skóga',
  'skógi',
  'skógv',
  'skóka',
  'skóki',
  'skóku',
  'skólp',
  'skóna',
  'skóni',
  'skóru',
  'skósa',
  'skósi',
  'skóta',
  'skóti',
  'skóva',
  'skóvu',
  'skødd',
  'skøds',
  'skøft',
  'skøkk',
  'skøla',
  'skøld',
  'skøli',
  'skøll',
  'skølm',
  'skølp',
  'skøls',
  'skølt',
  'skønn',
  'skøns',
  'skønt',
  'skøpa',
  'skøpt',
  'skøpu',
  'skøra',
  'skørd',
  'skøri',
  'skørp',
  'skørr',
  'skørt',
  'skøru',
  'skørð',
  'skøta',
  'skøtt',
  'skøtu',
  'skøva',
  'skøvu',
  'skøða',
  'skøði',
  'skúgv',
  'skúla',
  'skúli',
  'skúlv',
  'skúma',
  'skúmi',
  'skúms',
  'skúra',
  'skúri',
  'skúrs',
  'skúta',
  'skúti',
  'skútu',
  'skúva',
  'skúvi',
  'skúvs',
  'skýið',
  'skýla',
  'skýld',
  'skýli',
  'skýlt',
  'skýlu',
  'skýma',
  'skýmd',
  'skými',
  'skýms',
  'skýmt',
  'skýmu',
  'skýra',
  'skýrd',
  'skýri',
  'skýrt',
  'skýum',
  'slabb',
  'slabs',
  'slafs',
  'slaga',
  'slagi',
  'slags',
  'slaka',
  'slaki',
  'slakk',
  'slaks',
  'slakt',
  'slang',
  'slank',
  'slant',
  'slapp',
  'slaps',
  'slava',
  'slavi',
  'slavs',
  'slavt',
  'sleim',
  'sleip',
  'sleit',
  'sleiv',
  'slekt',
  'slena',
  'sleni',
  'slenu',
  'slepp',
  'slept',
  'sleri',
  'sleru',
  'sleta',
  'sleti',
  'slets',
  'slett',
  'sletu',
  'sleva',
  'slevi',
  'slevj',
  'slevs',
  'slevu',
  'sleyg',
  'sleða',
  'sleði',
  'sleðu',
  'slipa',
  'slipi',
  'slips',
  'slipu',
  'slisk',
  'sliti',
  'slits',
  'slitu',
  'sloka',
  'slokk',
  'sloks',
  'sloku',
  'slota',
  'sloti',
  'slots',
  'slott',
  'slufs',
  'slupp',
  'slupr',
  'slups',
  'slura',
  'sluri',
  'slurk',
  'slurs',
  'sluts',
  'slutt',
  'slysa',
  'slysi',
  'slysn',
  'slyðr',
  'sláar',
  'sláin',
  'sláir',
  'sláið',
  'slána',
  'sláni',
  'sláns',
  'slást',
  'slátt',
  'sláum',
  'sláva',
  'slávi',
  'slært',
  'slæst',
  'slæts',
  'slætt',
  'slíka',
  'slíki',
  'slíks',
  'slíkt',
  'slíku',
  'slíma',
  'slími',
  'slíms',
  'slípa',
  'slípi',
  'slíta',
  'slíti',
  'slóar',
  'slóað',
  'slógs',
  'slógu',
  'slógv',
  'slóin',
  'slóir',
  'slóið',
  'slóma',
  'slómi',
  'slóms',
  'slómu',
  'slóst',
  'slótt',
  'slóum',
  'slóða',
  'slóði',
  'slødd',
  'sløds',
  'sløga',
  'sløgd',
  'sløgi',
  'sløgt',
  'sløkk',
  'sløkt',
  'sløku',
  'sløra',
  'sløri',
  'slørs',
  'sløsa',
  'sløsi',
  'sløtt',
  'sløða',
  'sløði',
  'sløðr',
  'sløðs',
  'slúka',
  'slúki',
  'slúks',
  'slúra',
  'slúri',
  'slúrs',
  'slúsa',
  'slúsu',
  'slúta',
  'slúti',
  'slúts',
  'slútu',
  'smaka',
  'smaki',
  'smakk',
  'smaks',
  'smala',
  'smali',
  'smals',
  'smalt',
  'smalu',
  'smart',
  'smask',
  'smatt',
  'smegl',
  'smeit',
  'smeki',
  'smeks',
  'smell',
  'smels',
  'smelt',
  'smeri',
  'smers',
  'smett',
  'smeyg',
  'smiða',
  'smiði',
  'smiðs',
  'smoga',
  'smogi',
  'smogs',
  'smogu',
  'smolk',
  'smolt',
  'smoyk',
  'smsið',
  'smsum',
  'smuga',
  'smugu',
  'smulk',
  'smurd',
  'smurt',
  'smusk',
  'smyrt',
  'smáan',
  'smáar',
  'smáað',
  'smáir',
  'smáið',
  'smálæ',
  'smátt',
  'smáum',
  'smáur',
  'smædd',
  'smæra',
  'smæru',
  'smæst',
  'smætt',
  'smæða',
  'smæði',
  'smíla',
  'smíli',
  'smíls',
  'smílt',
  'smíri',
  'smírs',
  'smíða',
  'smíði',
  'smíðs',
  'smøks',
  'smølu',
  'smøri',
  'smørs',
  'smørt',
  'smúgv',
  'snakk',
  'snaks',
  'snaps',
  'snara',
  'snari',
  'snars',
  'snaru',
  'snasa',
  'snata',
  'snati',
  'sneis',
  'sneið',
  'snell',
  'snels',
  'snerk',
  'snerp',
  'snert',
  'sneyt',
  'snild',
  'snilk',
  'snill',
  'snils',
  'snilt',
  'snimm',
  'snims',
  'snimt',
  'snipp',
  'snips',
  'snirr',
  'snirs',
  'snisa',
  'snisi',
  'snits',
  'snitt',
  'sniða',
  'sniði',
  'sniðs',
  'snjós',
  'snobb',
  'snobs',
  'snodd',
  'snods',
  'snopp',
  'snops',
  'snora',
  'snori',
  'snork',
  'snors',
  'snota',
  'snoti',
  'snoyp',
  'snudd',
  'snuds',
  'snups',
  'snurr',
  'snurs',
  'snurt',
  'snyka',
  'snyki',
  'snyks',
  'snáka',
  'snáki',
  'snáks',
  'snáku',
  'snáva',
  'snávi',
  'snávs',
  'snávu',
  'snáða',
  'sníka',
  'sníki',
  'sníks',
  'sníkt',
  'snípa',
  'snípi',
  'snípu',
  'snóra',
  'snóri',
  'snórs',
  'snósa',
  'snóta',
  'snóti',
  'snóts',
  'snótu',
  'snøgg',
  'snøgs',
  'snøgt',
  'snøll',
  'snøls',
  'snøra',
  'snørd',
  'snøri',
  'snørp',
  'snørt',
  'snúað',
  'snúgv',
  'snúin',
  'snúið',
  'snúna',
  'snúni',
  'snúnu',
  'snúsa',
  'snúsi',
  'snúst',
  'snúta',
  'snúti',
  'snúði',
  'snúðu',
  'snýrt',
  'snýsa',
  'snýsi',
  'snýst',
  'snýta',
  'snýti',
  'snýts',
  'snýtt',
  'snýða',
  'snýði',
  'sodan',
  'sodað',
  'sodna',
  'sodni',
  'sodnu',
  'sofan',
  'sofia',
  'sofum',
  'sofur',
  'sogan',
  'sogin',
  'sogið',
  'sogna',
  'sogni',
  'sognu',
  'sogum',
  'sogur',
  'sokka',
  'sokki',
  'sokla',
  'sokli',
  'sokna',
  'sokni',
  'soknu',
  'solka',
  'solki',
  'solla',
  'solli',
  'somlu',
  'somul',
  'somum',
  'sonar',
  'songa',
  'songi',
  'songs',
  'sonin',
  'sonum',
  'sonur',
  'sopan',
  'sopar',
  'sopin',
  'sopið',
  'sopna',
  'sopni',
  'sopnu',
  'soppa',
  'soppi',
  'soppu',
  'sopum',
  'soran',
  'sorar',
  'sorað',
  'sorga',
  'sorgi',
  'sorin',
  'sorið',
  'sorla',
  'sorli',
  'sorls',
  'sorna',
  'sorni',
  'sorns',
  'sorta',
  'sorti',
  'sortu',
  'sorut',
  'sovin',
  'sovið',
  'sovna',
  'sovni',
  'sovnu',
  'soyan',
  'soyað',
  'soyla',
  'soylu',
  'soyma',
  'soymd',
  'soymi',
  'soyms',
  'soymt',
  'soyra',
  'soyri',
  'soyrs',
  'soyrt',
  'soyru',
  'soyða',
  'soyði',
  'soðan',
  'soðin',
  'soðið',
  'spaka',
  'spaki',
  'spaks',
  'spakt',
  'spann',
  'spara',
  'spard',
  'spari',
  'spark',
  'sparl',
  'spars',
  'spart',
  'spaða',
  'spaði',
  'spegl',
  'speia',
  'speii',
  'speis',
  'speki',
  'spekt',
  'spela',
  'speli',
  'spell',
  'spels',
  'spenn',
  'spens',
  'spent',
  'sperd',
  'sperm',
  'spert',
  'spika',
  'spiki',
  'spiks',
  'spill',
  'spilt',
  'spina',
  'spini',
  'spinn',
  'spins',
  'spinu',
  'spita',
  'spiti',
  'spión',
  'spjað',
  'spjót',
  'spjøð',
  'split',
  'spola',
  'spoli',
  'spong',
  'sponn',
  'spora',
  'spori',
  'sporl',
  'spors',
  'sport',
  'spots',
  'spott',
  'sprek',
  'sprit',
  'spryt',
  'sprák',
  'spræn',
  'sprík',
  'spula',
  'spuli',
  'spuna',
  'spuni',
  'spuns',
  'spurd',
  'spurt',
  'spurv',
  'sputs',
  'sputt',
  'spyrn',
  'spyrt',
  'spáar',
  'spáað',
  'spádd',
  'spáið',
  'spáka',
  'spáki',
  'spáks',
  'spála',
  'spáli',
  'spást',
  'spátt',
  'spæið',
  'spæka',
  'spæki',
  'spæks',
  'spæla',
  'spæld',
  'spæli',
  'spæls',
  'spælt',
  'spæta',
  'spætu',
  'spíla',
  'spíld',
  'spíli',
  'spíls',
  'spíra',
  'spíri',
  'spírs',
  'spíru',
  'spísk',
  'spíss',
  'spóan',
  'spóar',
  'spóin',
  'spóki',
  'spóks',
  'spóna',
  'spóni',
  'spóum',
  'spøki',
  'spøkt',
  'spøku',
  'spøla',
  'spøli',
  'spøls',
  'spøna',
  'spøni',
  'spøra',
  'spøri',
  'spørk',
  'spørl',
  'spýrt',
  'spýta',
  'spýti',
  'spýts',
  'spýtt',
  'spýði',
  'spýðu',
  'stadd',
  'stads',
  'staka',
  'staki',
  'stakk',
  'staks',
  'stakt',
  'stall',
  'stals',
  'stama',
  'stami',
  'stamp',
  'stand',
  'stapa',
  'stapi',
  'stara',
  'stard',
  'stari',
  'stars',
  'start',
  'starv',
  'stata',
  'stati',
  'stats',
  'statt',
  'stava',
  'stavi',
  'stavn',
  'stavs',
  'staða',
  'staði',
  'staðs',
  'steig',
  'steik',
  'stein',
  'stelk',
  'stell',
  'stels',
  'stelt',
  'stemm',
  'stemt',
  'stepa',
  'stepi',
  'stepp',
  'steps',
  'sterk',
  'stert',
  'stetl',
  'steva',
  'stevi',
  'stevn',
  'stevs',
  'steyp',
  'steyr',
  'steðg',
  'stift',
  'stiga',
  'stigi',
  'stigs',
  'stigu',
  'stika',
  'stiki',
  'stikk',
  'stikl',
  'stiks',
  'stiku',
  'stild',
  'still',
  'stils',
  'stilt',
  'stima',
  'stimi',
  'stina',
  'sting',
  'stink',
  'stinn',
  'stins',
  'stint',
  'stinu',
  'stird',
  'stirt',
  'stiði',
  'stjal',
  'stjól',
  'stjøl',
  'stoff',
  'stofs',
  'stokk',
  'stoks',
  'stokt',
  'stola',
  'stolt',
  'stolu',
  'stong',
  'stopp',
  'stops',
  'stork',
  'storm',
  'stova',
  'stovn',
  'stovu',
  'stoyp',
  'stoyt',
  'stoða',
  'stoði',
  'strev',
  'strik',
  'strok',
  'stroy',
  'stráa',
  'strái',
  'strás',
  'strát',
  'strís',
  'stríð',
  'strúk',
  'strút',
  'strýs',
  'stumm',
  'stump',
  'stums',
  'stumt',
  'stuna',
  'stund',
  'stuni',
  'stuns',
  'stunt',
  'stuss',
  'stuts',
  'stutt',
  'stuða',
  'stuði',
  'stuðl',
  'stygd',
  'stygg',
  'stygs',
  'stygt',
  'stynj',
  'styrk',
  'styts',
  'stytt',
  'stáka',
  'stáki',
  'stáks',
  'stála',
  'stáli',
  'stáls',
  'stása',
  'stási',
  'státa',
  'státi',
  'státs',
  'státu',
  'stæla',
  'stæld',
  'stæli',
  'stælt',
  'stætt',
  'stíga',
  'stígi',
  'stígs',
  'stíla',
  'stíli',
  'stíls',
  'stíva',
  'stívi',
  'stívs',
  'stívt',
  'stívu',
  'stóla',
  'stóli',
  'stóls',
  'stópa',
  'stópi',
  'stóps',
  'stóra',
  'stóri',
  'stórs',
  'stórt',
  'stóru',
  'stórá',
  'stóta',
  'stóti',
  'stóts',
  'stóða',
  'stóði',
  'stóðs',
  'stóðu',
  'stødd',
  'støka',
  'støkk',
  'støks',
  'støkt',
  'støku',
  'støra',
  'støri',
  'størs',
  'størv',
  'støva',
  'støvi',
  'støvs',
  'støða',
  'støðg',
  'støði',
  'støðs',
  'støðu',
  'stúgv',
  'stúka',
  'stúku',
  'stúpa',
  'stúpi',
  'stúra',
  'stúri',
  'stúrs',
  'stúrt',
  'stúta',
  'stúti',
  'stúts',
  'stútt',
  'stútu',
  'stúva',
  'stúvi',
  'stúvs',
  'stúvu',
  'stýra',
  'stýrd',
  'stýri',
  'stýrt',
  'stýva',
  'stývd',
  'stývi',
  'stývt',
  'stývu',
  'subba',
  'subbi',
  'suffa',
  'suffi',
  'sugga',
  'suggu',
  'sukat',
  'sukka',
  'sukki',
  'sukku',
  'sukra',
  'sukri',
  'sukse',
  'sukur',
  'sulka',
  'sulki',
  'sulks',
  'sulla',
  'sulli',
  'summa',
  'summi',
  'sumra',
  'sumri',
  'sunda',
  'sundi',
  'sunds',
  'sungu',
  'sunna',
  'sunni',
  'sunnu',
  'sunra',
  'super',
  'suppa',
  'suppu',
  'surka',
  'surki',
  'surks',
  'surku',
  'surla',
  'surli',
  'surls',
  'surpa',
  'surpi',
  'surps',
  'surpu',
  'surra',
  'surri',
  'surru',
  'sussa',
  'sussi',
  'sussu',
  'sutla',
  'sutli',
  'sutls',
  'sutra',
  'sutri',
  'sutru',
  'sutta',
  'sutti',
  'suttu',
  'sutur',
  'suðan',
  'suðar',
  'suðað',
  'suðið',
  'suðri',
  'suðum',
  'suður',
  'svaga',
  'svagg',
  'svagi',
  'svags',
  'svaka',
  'svaki',
  'svaks',
  'svakt',
  'svala',
  'svald',
  'svali',
  'svall',
  'svalt',
  'svalu',
  'svamp',
  'svana',
  'svani',
  'svank',
  'svann',
  'svans',
  'svara',
  'svari',
  'svarm',
  'svars',
  'svart',
  'svarv',
  'svass',
  'svavd',
  'svavt',
  'svaða',
  'svaði',
  'svaðs',
  'sveik',
  'sveim',
  'svein',
  'sveip',
  'sveiv',
  'sveið',
  'svera',
  'sveri',
  'sverm',
  'svers',
  'svert',
  'sveru',
  'svevj',
  'svian',
  'sviar',
  'sviin',
  'svika',
  'sviki',
  'sviks',
  'sviku',
  'sving',
  'svinn',
  'svins',
  'svint',
  'svirr',
  'svirs',
  'svita',
  'svitu',
  'svium',
  'sviva',
  'svivi',
  'svivs',
  'svivu',
  'sviða',
  'sviði',
  'sviðu',
  'svong',
  'svull',
  'svuls',
  'svult',
  'svumu',
  'svágd',
  'svágt',
  'sválg',
  'svára',
  'svári',
  'svárs',
  'svárt',
  'sváru',
  'svæva',
  'svævd',
  'svævi',
  'svævt',
  'svían',
  'svíar',
  'svíin',
  'svíka',
  'svíki',
  'svíks',
  'svíma',
  'svími',
  'svína',
  'svíni',
  'svíns',
  'svíra',
  'svíri',
  'svíum',
  'svíva',
  'svívi',
  'svíða',
  'svíði',
  'svórt',
  'svóru',
  'svóvu',
  'svøku',
  'svølg',
  'svøll',
  'svølt',
  'svøpp',
  'svøps',
  'svøra',
  'svøri',
  'svørj',
  'svørm',
  'svørs',
  'svørt',
  'svøru',
  'svørð',
  'svøvn',
  'syfta',
  'syfti',
  'syfts',
  'syftu',
  'sylla',
  'sylli',
  'syllu',
  'synda',
  'syndi',
  'synds',
  'syndu',
  'syngi',
  'synir',
  'synja',
  'synji',
  'synum',
  'syrgd',
  'syrgi',
  'syrgt',
  'syrpa',
  'syrpu',
  'syvja',
  'syvji',
  'syðra',
  'syðri',
  'syðru',
  'syðst',
  'sáast',
  'sáaða',
  'sáaði',
  'sáaðs',
  'sáaðu',
  'sádda',
  'sáddi',
  'sádds',
  'sáddu',
  'sádóm',
  'sáing',
  'sáist',
  'sálan',
  'sálar',
  'sálað',
  'sálda',
  'sáldi',
  'sálds',
  'sálig',
  'sálin',
  'sálir',
  'sálma',
  'sálmi',
  'sálms',
  'sálug',
  'sálum',
  'sálur',
  'sálva',
  'sálvi',
  'sálvu',
  'sáman',
  'sámar',
  'sámdi',
  'sámdu',
  'sámin',
  'sámir',
  'sámið',
  'sámum',
  'sápan',
  'sápar',
  'sápað',
  'sápið',
  'sápum',
  'sápur',
  'sárar',
  'sárað',
  'sárir',
  'sárið',
  'sárka',
  'sárki',
  'sárna',
  'sárni',
  'sárum',
  'sátan',
  'sátta',
  'sátti',
  'sáttu',
  'sátum',
  'sátur',
  'sáðan',
  'sáðar',
  'sáðin',
  'sáðir',
  'sáðið',
  'sáðum',
  'sáður',
  'sáðut',
  'sædda',
  'sæddi',
  'sæddu',
  'sækúm',
  'sækýr',
  'sælan',
  'sælar',
  'sælda',
  'sældi',
  'sælds',
  'sældu',
  'sælir',
  'sælla',
  'sælli',
  'sællu',
  'sælra',
  'sælum',
  'sælur',
  'særda',
  'særdi',
  'særds',
  'særdu',
  'særir',
  'særið',
  'særst',
  'sætir',
  'sætis',
  'sætið',
  'sætst',
  'sætta',
  'sætti',
  'sættu',
  'sætum',
  'sídda',
  'sígda',
  'sígdi',
  'sígds',
  'sígdu',
  'síggi',
  'síggj',
  'sígir',
  'sígið',
  'sígna',
  'sígni',
  'sígnu',
  'sígur',
  'sílan',
  'sílar',
  'sílað',
  'sílin',
  'sílir',
  'sílið',
  'sílum',
  'sílur',
  'sínar',
  'sínir',
  'sínum',
  'sípot',
  'sítræ',
  'sítrø',
  'síðan',
  'síðar',
  'síðir',
  'síðis',
  'síðka',
  'síðki',
  'síðla',
  'síðst',
  'síðum',
  'síður',
  'sógva',
  'sógvi',
  'sógvu',
  'sókna',
  'sókni',
  'sólan',
  'sólar',
  'sólað',
  'sólia',
  'sólin',
  'sólir',
  'sóliu',
  'sólið',
  'sólja',
  'sólju',
  'sólum',
  'sólur',
  'sólár',
  'sóman',
  'sómin',
  'sópar',
  'sópað',
  'sópin',
  'sópið',
  'sópum',
  'sópur',
  'sósar',
  'sósin',
  'sósir',
  'sósum',
  'sótar',
  'sótað',
  'sótið',
  'sótta',
  'sótut',
  'sóust',
  'søddu',
  'søgan',
  'søgdu',
  'søgum',
  'søgur',
  'søgut',
  'søkan',
  'søkil',
  'søkin',
  'søkið',
  'søkka',
  'søkki',
  'søkla',
  'søkli',
  'søkna',
  'søkni',
  'søknu',
  'søkst',
  'søkta',
  'søkti',
  'søkts',
  'søktu',
  'søkum',
  'søkur',
  'sølan',
  'sølar',
  'sølað',
  'sølin',
  'sølið',
  'sølna',
  'sølni',
  'sølnu',
  'søltu',
  'sølum',
  'sølur',
  'sømda',
  'sømdi',
  'sømdu',
  'sømir',
  'sømið',
  'søpil',
  'søpla',
  'søpli',
  'søpul',
  'søran',
  'sørar',
  'sørað',
  'sørga',
  'sørgi',
  'sørir',
  'sørið',
  'sørpa',
  'sørpu',
  'sørum',
  'sørur',
  'søtan',
  'søtar',
  'søtað',
  'søtin',
  'søtir',
  'søtið',
  'søtna',
  'søtni',
  'søtra',
  'søtum',
  'søtur',
  'søvda',
  'søvdi',
  'søvds',
  'søvdu',
  'søvir',
  'søvið',
  'súgar',
  'súgað',
  'súgin',
  'súgið',
  'súgst',
  'súgur',
  'súgva',
  'súgvi',
  'súgál',
  'súlan',
  'súlta',
  'súlti',
  'súltu',
  'súlum',
  'súlur',
  'súlut',
  'súnna',
  'súnni',
  'súnum',
  'súpan',
  'súpið',
  'súpst',
  'súran',
  'súrar',
  'súrga',
  'súrgi',
  'súrgu',
  'súrir',
  'súrna',
  'súrni',
  'súrum',
  'súrur',
  'súsar',
  'súsað',
  'súsið',
  'sútar',
  'sútin',
  'sútir',
  'sútum',
  'súðan',
  'súðar',
  'súðin',
  'súðir',
  'súðum',
  'súður',
  'sýgst',
  'sýgur',
  'sýlar',
  'sýlda',
  'sýldi',
  'sýlds',
  'sýldu',
  'sýlin',
  'sýlir',
  'sýlið',
  'sýlum',
  'sýlur',
  'sýnan',
  'sýnar',
  'sýnað',
  'sýnda',
  'sýndi',
  'sýnds',
  'sýndu',
  'sýnin',
  'sýnir',
  'sýnis',
  'sýnið',
  'sýnst',
  'sýnta',
  'sýnti',
  'sýnts',
  'sýntu',
  'sýnum',
  'sýnur',
  'sýpst',
  'sýpur',
  'sýran',
  'sýrar',
  'sýrað',
  'sýrin',
  'sýrið',
  'sýrum',
  'sýrur',
  'sýsan',
  'sýsar',
  'sýsað',
  'sýsið',
  'sýsla',
  'sýslu',
  'sýsum',
  'sýsur',
  'sýsut',
  'sýtin',
  'sýtir',
  'sýtið',
  'sýtna',
  'sýtni',
  'sýtnu',
  'sýtst',
  'sýtta',
  'sýtti',
  'sýtts',
  'sýttu',
  'sýðst',
  'sýður',
  'tadda',
  'taddi',
  'tadna',
  'tadni',
  'tagað',
  'tagda',
  'tagdi',
  'tagds',
  'tagdu',
  'tagga',
  'taggi',
  'taggu',
  'tagla',
  'tagli',
  'tagls',
  'tagna',
  'tagni',
  'tagst',
  'takið',
  'takka',
  'takki',
  'takst',
  'takta',
  'takti',
  'takts',
  'taktu',
  'talan',
  'talar',
  'talað',
  'talda',
  'taldi',
  'talds',
  'taldu',
  'talið',
  'talja',
  'talji',
  'talju',
  'talst',
  'talum',
  'talur',
  'talva',
  'talvi',
  'talvs',
  'talvu',
  'taman',
  'tamar',
  'tamba',
  'tambi',
  'tambs',
  'tamda',
  'tamdi',
  'tamds',
  'tamdu',
  'tamin',
  'tamir',
  'tamið',
  'tamna',
  'tamni',
  'tamnu',
  'tampa',
  'tampi',
  'tamps',
  'tamra',
  'tamst',
  'tamur',
  'tanda',
  'tandi',
  'tands',
  'tandu',
  'tanga',
  'tangi',
  'tangs',
  'tanka',
  'tanki',
  'tanks',
  'tanla',
  'tanli',
  'tanls',
  'tanna',
  'tanst',
  'tapet',
  'tapir',
  'tapið',
  'tappa',
  'tappi',
  'taptó',
  'tapum',
  'taran',
  'tarar',
  'tarin',
  'tarma',
  'tarmi',
  'tarms',
  'tarna',
  'tarni',
  'tarns',
  'tartl',
  'tarum',
  'tarva',
  'tarvi',
  'tarvs',
  'tarvt',
  'taska',
  'tasku',
  'tatar',
  'tavar',
  'tavað',
  'tavin',
  'tavið',
  'tavna',
  'tavni',
  'tavnu',
  'tavum',
  'taðan',
  'taðar',
  'taðað',
  'taðið',
  'tegir',
  'tegið',
  'tegna',
  'tegni',
  'tegns',
  'teiga',
  'teigi',
  'teigs',
  'teina',
  'teini',
  'teins',
  'teipa',
  'teipi',
  'teist',
  'teita',
  'teiti',
  'teits',
  'teitt',
  'teitu',
  'tekan',
  'tekin',
  'tekir',
  'tekið',
  'tekja',
  'tekju',
  'tekka',
  'tekki',
  'tekku',
  'tekna',
  'tekni',
  'tekns',
  'tekst',
  'tekta',
  'tekti',
  'tekts',
  'tektu',
  'tekum',
  'tekur',
  'telda',
  'teldi',
  'teldu',
  'telgd',
  'telgi',
  'telgt',
  'telið',
  'telja',
  'telji',
  'telpa',
  'telpu',
  'telst',
  'telta',
  'telti',
  'telts',
  'telur',
  'telva',
  'telvd',
  'telvi',
  'telvt',
  'temai',
  'temas',
  'temað',
  'temba',
  'tembd',
  'tembi',
  'tembt',
  'temin',
  'temið',
  'temja',
  'temji',
  'temna',
  'temni',
  'temnu',
  'temsa',
  'temsi',
  'temst',
  'temum',
  'temur',
  'tenja',
  'tenji',
  'tenna',
  'tenni',
  'tenor',
  'tenst',
  'tenta',
  'tenti',
  'tents',
  'tentu',
  'tenum',
  'tenur',
  'tenøs',
  'teori',
  'teppa',
  'teppi',
  'tepra',
  'tepri',
  'tepru',
  'tepst',
  'tepta',
  'tepti',
  'tepts',
  'teptu',
  'tepur',
  'terga',
  'tergi',
  'terna',
  'terni',
  'ternu',
  'terpa',
  'terpi',
  'terra',
  'terri',
  'tersi',
  'terta',
  'terti',
  'tertl',
  'terts',
  'tertu',
  'terva',
  'tervi',
  'teska',
  'teski',
  'tesks',
  'tessa',
  'tessi',
  'testa',
  'testi',
  'tetst',
  'tetta',
  'tetti',
  'tettu',
  'tevan',
  'tevin',
  'tevið',
  'tevja',
  'tevji',
  'tevsa',
  'tevsi',
  'tevur',
  'teyma',
  'teymi',
  'teyms',
  'teysa',
  'tiara',
  'tiari',
  'tiggi',
  'tigið',
  'tigla',
  'tigli',
  'tiglu',
  'tigna',
  'tigni',
  'tigst',
  'tigul',
  'tigur',
  'tikin',
  'tikið',
  'tikna',
  'tikni',
  'tiknu',
  'tilið',
  'tilja',
  'tilji',
  'tilju',
  'timað',
  'tinar',
  'tinað',
  'tinda',
  'tindi',
  'tinds',
  'tinga',
  'tingi',
  'tings',
  'tinið',
  'tinna',
  'tinnu',
  'tinta',
  'tippa',
  'tippi',
  'tippu',
  'tipst',
  'tipta',
  'tipti',
  'tipts',
  'tiptu',
  'tirla',
  'tirli',
  'tirlu',
  'tirra',
  'tirri',
  'tirru',
  'titan',
  'titar',
  'titað',
  'titil',
  'titið',
  'titla',
  'titli',
  'titra',
  'titri',
  'titul',
  'tivan',
  'tivar',
  'tivað',
  'tivið',
  'tiðna',
  'tiðni',
  'tjald',
  'tjukk',
  'tjuks',
  'tjukt',
  'tjykd',
  'tjógv',
  'tjóra',
  'tjóri',
  'tjórs',
  'tjóva',
  'tjóvi',
  'tjóvs',
  'tjóða',
  'tjøld',
  'tjøra',
  'tjørg',
  'tjøri',
  'tjørn',
  'tjøru',
  'tjúga',
  'tjúgu',
  'tjúkd',
  'tjúkk',
  'tjúkn',
  'tjúks',
  'tjúkt',
  'tjúna',
  'tjúni',
  'todda',
  'toddi',
  'tofta',
  'tofti',
  'toftu',
  'togan',
  'togar',
  'togað',
  'togin',
  'togið',
  'togna',
  'togni',
  'togum',
  'tokan',
  'tokar',
  'tokað',
  'tokið',
  'tokka',
  'tokki',
  'tokna',
  'tokni',
  'toknu',
  'tokum',
  'tokut',
  'tolað',
  'tolda',
  'toldi',
  'tolds',
  'toldu',
  'tolig',
  'tolin',
  'tolir',
  'tolið',
  'tolka',
  'tolki',
  'tolks',
  'tolla',
  'tolli',
  'tolna',
  'tolni',
  'tolnu',
  'tolst',
  'tolug',
  'tomat',
  'tomba',
  'tombu',
  'tomma',
  'tommi',
  'tomum',
  'tonal',
  'tonsa',
  'tonsi',
  'tonut',
  'topas',
  'toppa',
  'toppi',
  'toppu',
  'toran',
  'torað',
  'tordi',
  'tordu',
  'torga',
  'torgi',
  'torgs',
  'torir',
  'torið',
  'torna',
  'torni',
  'torns',
  'torpa',
  'torpi',
  'torps',
  'torra',
  'torri',
  'torsk',
  'torst',
  'torta',
  'torti',
  'torts',
  'torva',
  'torvi',
  'torvs',
  'torvu',
  'tosan',
  'tosar',
  'tosað',
  'tosið',
  'toska',
  'toski',
  'tosks',
  'tosta',
  'tosti',
  'tosut',
  'total',
  'totar',
  'totað',
  'totið',
  'totut',
  'toyar',
  'toyað',
  'toyga',
  'toygd',
  'toygg',
  'toygi',
  'toygs',
  'toygt',
  'toygu',
  'toyin',
  'toyið',
  'toyma',
  'toymi',
  'toyur',
  'traff',
  'trakt',
  'trall',
  'trals',
  'trama',
  'trami',
  'tramp',
  'trana',
  'trani',
  'trant',
  'trask',
  'trast',
  'trava',
  'traða',
  'traðk',
  'treff',
  'trega',
  'tregi',
  'trein',
  'treiv',
  'treka',
  'treki',
  'trekk',
  'treks',
  'trekt',
  'treku',
  'trena',
  'treni',
  'trepa',
  'trepi',
  'tresk',
  'treyt',
  'treyð',
  'trini',
  'trinn',
  'trins',
  'trint',
  'trist',
  'tritl',
  'triva',
  'trivi',
  'trivs',
  'trivu',
  'triði',
  'troga',
  'trogi',
  'trogs',
  'troka',
  'troki',
  'troks',
  'troku',
  'trola',
  'troli',
  'trols',
  'troma',
  'tromi',
  'trong',
  'tropa',
  'trota',
  'troti',
  'trots',
  'troys',
  'troyt',
  'troða',
  'troði',
  'troðs',
  'trukk',
  'truks',
  'trumf',
  'trumm',
  'trums',
  'trunk',
  'trygd',
  'trygg',
  'trygs',
  'trygt',
  'trykk',
  'tryks',
  'trykt',
  'tryll',
  'trylt',
  'tráan',
  'tráar',
  'tráað',
  'tráin',
  'tráir',
  'tráið',
  'trána',
  'tráni',
  'trátt',
  'tráum',
  'tráur',
  'tráða',
  'tráði',
  'tráðu',
  'træið',
  'træla',
  'træli',
  'træll',
  'træls',
  'træna',
  'træni',
  'trænu',
  'træta',
  'trætt',
  'trætu',
  'træum',
  'træða',
  'træði',
  'trína',
  'tríni',
  'tríum',
  'tríur',
  'tríva',
  'trívi',
  'tróna',
  'tróni',
  'tróns',
  'trónu',
  'trósk',
  'tróta',
  'tróti',
  'tróts',
  'trótu',
  'trødd',
  'trøds',
  'trøll',
  'trøls',
  'trøst',
  'trøtt',
  'trøum',
  'trøða',
  'trøði',
  'trúan',
  'trúar',
  'trúga',
  'trúgi',
  'trúgv',
  'trúin',
  'trúir',
  'trúna',
  'trúni',
  'trúnu',
  'trúti',
  'trúts',
  'trútt',
  'trúum',
  'trúur',
  'trúði',
  'trúðu',
  'trýna',
  'trýni',
  'trýns',
  'trýrt',
  'trýss',
  'trýst',
  'trýum',
  'trýur',
  'tuban',
  'tubba',
  'tubum',
  'tubur',
  'tuffi',
  'tufla',
  'tufli',
  'tuflu',
  'tugda',
  'tugdi',
  'tugds',
  'tugdu',
  'tugga',
  'tuggu',
  'tugla',
  'tugli',
  'tugls',
  'tugst',
  'tukan',
  'tukar',
  'tukað',
  'tukið',
  'tukta',
  'tukti',
  'tulka',
  'tulki',
  'tulks',
  'tulpa',
  'tulpu',
  'tumla',
  'tumli',
  'tumma',
  'tummi',
  'tunar',
  'tunað',
  'tunga',
  'tungi',
  'tungl',
  'tungs',
  'tungt',
  'tungu',
  'tunið',
  'tunla',
  'tunli',
  'tunna',
  'tunni',
  'tunnu',
  'tunra',
  'tupan',
  'tupla',
  'tuplu',
  'tupum',
  'tupur',
  'turar',
  'turað',
  'turið',
  'turka',
  'turki',
  'turks',
  'turna',
  'turni',
  'turns',
  'turra',
  'turri',
  'turru',
  'tuska',
  'tuski',
  'tusks',
  'tussa',
  'tussi',
  'tussj',
  'tusta',
  'tusti',
  'tusts',
  'tustu',
  'tutan',
  'tutla',
  'tutli',
  'tutls',
  'tutra',
  'tutri',
  'tutta',
  'tutti',
  'tutum',
  'tutur',
  'tvaga',
  'tvagi',
  'tvags',
  'tvara',
  'tvari',
  'tvarr',
  'tvars',
  'tvask',
  'tvass',
  'tvaða',
  'tvaði',
  'tvaðs',
  'tveim',
  'tvein',
  'tveir',
  'tveit',
  'tvekk',
  'tvekt',
  'tveya',
  'tveyu',
  'tvinn',
  'tvins',
  'tvint',
  'tvist',
  'tvong',
  'tvátt',
  'tvætl',
  'tvæts',
  'tvætt',
  'tvíar',
  'tvíað',
  'tvíið',
  'tvíta',
  'tvíti',
  'tvítt',
  'tvíár',
  'tvøga',
  'tvøgu',
  'tvøra',
  'tvøri',
  'tvørs',
  'tvørt',
  'tvøru',
  'tvørá',
  'tvøst',
  'twist',
  'tyggi',
  'tygil',
  'tygla',
  'tygli',
  'tygst',
  'tygum',
  'tygur',
  'tykir',
  'tykið',
  'tykja',
  'tykki',
  'tykna',
  'tykni',
  'tyknu',
  'tykra',
  'tykst',
  'tykta',
  'tykti',
  'tykts',
  'tyktu',
  'tykum',
  'tykur',
  'tylvt',
  'tyngd',
  'tyngi',
  'tyngt',
  'tynka',
  'tynki',
  'tynna',
  'tynni',
  'tynra',
  'tynri',
  'tynru',
  'tynst',
  'tynta',
  'tynti',
  'tynts',
  'tyntu',
  'typan',
  'typpa',
  'typpi',
  'typum',
  'typur',
  'tyril',
  'tyrla',
  'tyrli',
  'tyrlu',
  'tyrpa',
  'tyrpi',
  'tyrpt',
  'tyrst',
  'tyrva',
  'tyrvd',
  'tyrvi',
  'tyrvt',
  'tysið',
  'tysja',
  'tysji',
  'tyssa',
  'tyssi',
  'tysta',
  'tysti',
  'tysts',
  'tystu',
  'tysur',
  'tytta',
  'tyttu',
  'táara',
  'táari',
  'táaru',
  'táast',
  'táaði',
  'táaðu',
  'tágan',
  'tágar',
  'tágin',
  'tágut',
  'tájól',
  'tákna',
  'táknu',
  'tálga',
  'tálgi',
  'tálki',
  'tálks',
  'tálma',
  'tálmi',
  'táman',
  'támar',
  'támir',
  'támið',
  'támum',
  'támur',
  'támut',
  'tánar',
  'tánað',
  'tánið',
  'tánna',
  'tánni',
  'tápan',
  'tápum',
  'tápur',
  'tárar',
  'tárað',
  'tárið',
  'tárum',
  'tátan',
  'tátar',
  'tátað',
  'tátið',
  'tátta',
  'tátti',
  'táttu',
  'tátum',
  'tátur',
  'tátíð',
  'tægan',
  'tægar',
  'tægað',
  'tægið',
  'tægra',
  'tægru',
  'tægum',
  'tægur',
  'tærda',
  'tærdi',
  'tærds',
  'tærdu',
  'tærir',
  'tæris',
  'tærið',
  'tærst',
  'tærum',
  'tætna',
  'tætni',
  'tætst',
  'tætta',
  'tætti',
  'tættu',
  'tídda',
  'tíggi',
  'tígna',
  'tígni',
  'tíkar',
  'tíkin',
  'tíkum',
  'tílík',
  'tíman',
  'tímar',
  'tímað',
  'tímdi',
  'tímdu',
  'tímin',
  'tímir',
  'tímið',
  'tímum',
  'tínar',
  'tínda',
  'tíndi',
  'tínds',
  'tíndu',
  'tínir',
  'tínis',
  'tínið',
  'tínst',
  'tínum',
  'títta',
  'títti',
  'títtu',
  'tívan',
  'tívar',
  'tívin',
  'tívum',
  'tíðan',
  'tíðar',
  'tíðað',
  'tíðin',
  'tíðir',
  'tíðið',
  'tíðla',
  'tíðli',
  'tíðum',
  'tíður',
  'tóast',
  'tódna',
  'tódni',
  'tógva',
  'tógvi',
  'tókst',
  'tókta',
  'tókti',
  'tókts',
  'tóktu',
  'tólið',
  'tólum',
  'tólva',
  'tólvi',
  'tólvs',
  'tólvu',
  'tóman',
  'tómar',
  'tómin',
  'tómir',
  'tómlæ',
  'tómum',
  'tómur',
  'tónan',
  'tónar',
  'tónað',
  'tónin',
  'tónir',
  'tónið',
  'tónna',
  'tónni',
  'tónum',
  'tónur',
  'tórar',
  'tórað',
  'tórið',
  'tóvar',
  'tóvað',
  'tóvin',
  'tóvið',
  'tóvna',
  'tóvni',
  'tóvnu',
  'tóvum',
  'tóvut',
  'tøbba',
  'tøbbi',
  'tøgdu',
  'tøggi',
  'tøgin',
  'tøgið',
  'tøgna',
  'tøgni',
  'tøgnu',
  'tøkan',
  'tøkar',
  'tøkin',
  'tøkir',
  'tøkis',
  'tøkið',
  'tøkja',
  'tøkna',
  'tøkni',
  'tøknu',
  'tøkra',
  'tøkum',
  'tøkur',
  'tølda',
  'tøldi',
  'tølds',
  'tøldu',
  'tølir',
  'tølis',
  'tølið',
  'tølpa',
  'tølpi',
  'tølps',
  'tølsk',
  'tølst',
  'tølum',
  'tømda',
  'tømdi',
  'tømds',
  'tømdu',
  'tømir',
  'tømið',
  'tømst',
  'tøpir',
  'tøpis',
  'tøpið',
  'tøppa',
  'tøppi',
  'tøpum',
  'tørna',
  'tørni',
  'tørns',
  'tørva',
  'tørvi',
  'tørvs',
  'tøsan',
  'tøsar',
  'tøsað',
  'tøsið',
  'tøssa',
  'tøssi',
  'tøtla',
  'tøtli',
  'tøtls',
  'tøttu',
  'tøvan',
  'tøvda',
  'tøvdi',
  'tøvds',
  'tøvdu',
  'tøvir',
  'tøvið',
  'tøvst',
  'tøvum',
  'tøvur',
  'tøðan',
  'tøðar',
  'tøðað',
  'tøðið',
  'tøðum',
  'tøður',
  'túast',
  'túaða',
  'túaði',
  'túaðs',
  'túaðu',
  'túgla',
  'túgli',
  'túgls',
  'túgva',
  'túgvu',
  'túist',
  'túlli',
  'túnið',
  'túnum',
  'túrar',
  'túrað',
  'túrin',
  'túrir',
  'túrið',
  'túrum',
  'túrur',
  'túsna',
  'túsni',
  'tústa',
  'tústi',
  'tústs',
  'tústu',
  'tútan',
  'tútar',
  'tútað',
  'tútin',
  'tútið',
  'tútum',
  'tútur',
  'túvan',
  'túvum',
  'túvur',
  'túvut',
  'týdda',
  'týddi',
  'týddu',
  'týggi',
  'týnda',
  'týndi',
  'týnds',
  'týndu',
  'týnir',
  'týnið',
  'týnst',
  'týpan',
  'týpum',
  'týpur',
  'týska',
  'týski',
  'týsks',
  'týskt',
  'týsku',
  'týsna',
  'týsni',
  'týðan',
  'týðar',
  'týðað',
  'týðir',
  'týðið',
  'týðst',
  'týðum',
  'týður',
  'uggan',
  'uggar',
  'uggað',
  'uggin',
  'uggið',
  'uglan',
  'uglar',
  'uglin',
  'uglum',
  'uglur',
  'uksar',
  'uksin',
  'uksir',
  'uksum',
  'ulkan',
  'ulkum',
  'ulkur',
  'ullar',
  'ullað',
  'ullin',
  'ullir',
  'ullum',
  'ulpan',
  'ulpum',
  'ulpur',
  'umbar',
  'umbað',
  'umber',
  'umbið',
  'umboð',
  'umbót',
  'umbøn',
  'umfar',
  'umfør',
  'umkom',
  'umlan',
  'umlar',
  'umlað',
  'umlið',
  'ummar',
  'ummað',
  'ummið',
  'ummál',
  'umráð',
  'umrøð',
  'umsat',
  'umset',
  'umsit',
  'umtak',
  'umtal',
  'umtøk',
  'umval',
  'umvav',
  'umveg',
  'umvæl',
  'umætt',
  'undan',
  'undir',
  'undra',
  'undri',
  'undur',
  'ungan',
  'ungar',
  'ungað',
  'ungin',
  'ungir',
  'ungið',
  'ungra',
  'ungum',
  'ungur',
  'uppal',
  'uppat',
  'uppav',
  'uppiá',
  'uppií',
  'uppum',
  'uppás',
  'uppól',
  'uppúr',
  'upsan',
  'upsar',
  'upsin',
  'upsir',
  'upsum',
  'upsur',
  'urani',
  'urans',
  'urgan',
  'urgum',
  'urgur',
  'urini',
  'urnan',
  'urnar',
  'urnað',
  'urnin',
  'urnið',
  'urnum',
  'urpta',
  'ursan',
  'ursar',
  'ursað',
  'ursin',
  'ursið',
  'ursum',
  'ursur',
  'urtar',
  'urtin',
  'urtir',
  'urtum',
  'urðar',
  'urðin',
  'urðum',
  'uttan',
  'vafla',
  'vaflu',
  'vagga',
  'vaggi',
  'vagla',
  'vagli',
  'vagls',
  'vagni',
  'vagns',
  'vakin',
  'vakið',
  'vakka',
  'vakki',
  'vakna',
  'vakni',
  'vaknu',
  'vakra',
  'vakri',
  'vaksa',
  'vaksi',
  'vakta',
  'vakti',
  'vakts',
  'vaktu',
  'vakur',
  'valan',
  'valda',
  'valdi',
  'valds',
  'valdu',
  'valgi',
  'valgs',
  'valin',
  'valir',
  'valið',
  'valla',
  'valli',
  'valna',
  'valni',
  'valnu',
  'valsa',
  'valsi',
  'valst',
  'valum',
  'valur',
  'vamba',
  'vamla',
  'vamli',
  'vamls',
  'vampa',
  'vampi',
  'vanan',
  'vanar',
  'vanda',
  'vandi',
  'vands',
  'vandu',
  'vanga',
  'vangi',
  'vanin',
  'vanir',
  'vanka',
  'vanki',
  'vanks',
  'vanra',
  'vansa',
  'vansi',
  'vanst',
  'vanta',
  'vanti',
  'vants',
  'vanum',
  'vanur',
  'vanær',
  'vappa',
  'vappi',
  'varan',
  'varar',
  'varað',
  'varda',
  'vardi',
  'vards',
  'vardu',
  'varga',
  'vargi',
  'vargs',
  'varig',
  'varin',
  'varir',
  'varið',
  'varma',
  'varmi',
  'varms',
  'varmt',
  'varna',
  'varni',
  'varnu',
  'varpa',
  'varpi',
  'varps',
  'varra',
  'varri',
  'varst',
  'varta',
  'varti',
  'varug',
  'varum',
  'varur',
  'varða',
  'varði',
  'vasan',
  'vasar',
  'vasað',
  'vasin',
  'vasið',
  'vaska',
  'vaski',
  'vasks',
  'vaskt',
  'vassa',
  'vassi',
  'vasum',
  'vasut',
  'vatna',
  'vatni',
  'vatns',
  'vatta',
  'vatti',
  'vavda',
  'vavdi',
  'vavds',
  'vavdu',
  'vavið',
  'vavla',
  'vavli',
  'vavst',
  'vavva',
  'vavvi',
  'vaðil',
  'vaðið',
  'vaðla',
  'vaðli',
  'vaðsa',
  'vaðsi',
  'vaðum',
  'vedda',
  'veddi',
  'vefta',
  'vefti',
  'vefts',
  'vegar',
  'vegað',
  'veggi',
  'vegin',
  'vegir',
  'vegið',
  'vegna',
  'vegum',
  'vegur',
  'veidd',
  'veids',
  'veigs',
  'veiið',
  'veika',
  'veiki',
  'veiks',
  'veikt',
  'veiku',
  'veila',
  'veili',
  'veils',
  'veilt',
  'veilu',
  'veipa',
  'veipi',
  'veips',
  'veira',
  'veiri',
  'veirs',
  'veita',
  'veiti',
  'veits',
  'veitt',
  'veitu',
  'veium',
  'veiða',
  'veiði',
  'veiðu',
  'vekra',
  'vekri',
  'veksa',
  'veksi',
  'vekst',
  'vekta',
  'vekur',
  'velan',
  'velar',
  'velda',
  'veldi',
  'veldu',
  'velik',
  'velin',
  'velið',
  'velja',
  'velji',
  'velki',
  'velkt',
  'vella',
  'velli',
  'velst',
  'velta',
  'velti',
  'velts',
  'veltu',
  'velum',
  'velur',
  'venan',
  'venar',
  'venað',
  'venda',
  'vendi',
  'vends',
  'vendu',
  'venið',
  'venja',
  'venji',
  'venju',
  'venst',
  'venur',
  'veran',
  'verba',
  'verbi',
  'verbs',
  'verda',
  'verdi',
  'verds',
  'verdu',
  'verdí',
  'verin',
  'verið',
  'verja',
  'verji',
  'verju',
  'verka',
  'verki',
  'verks',
  'verkt',
  'verma',
  'vermd',
  'vermi',
  'vermt',
  'vernd',
  'verpa',
  'verpi',
  'verpu',
  'verra',
  'verri',
  'verru',
  'versa',
  'versi',
  'verst',
  'verta',
  'verti',
  'verts',
  'verum',
  'verur',
  'verða',
  'verði',
  'verðs',
  'vesan',
  'vesar',
  'vesað',
  'vesin',
  'vesir',
  'vesis',
  'vesið',
  'veska',
  'vesku',
  'vespa',
  'vespu',
  'vessa',
  'vessi',
  'vesta',
  'vesti',
  'vests',
  'vesum',
  'vetar',
  'vetað',
  'vetið',
  'vetna',
  'vetni',
  'vetra',
  'vetri',
  'vetur',
  'vevin',
  'vevir',
  'vevið',
  'vevja',
  'vevji',
  'vevla',
  'vevli',
  'vevna',
  'vevni',
  'vevst',
  'vevum',
  'vevur',
  'veðin',
  'veðir',
  'veðið',
  'veðra',
  'veðri',
  'veðum',
  'veður',
  'video',
  'vifta',
  'viftu',
  'vigan',
  'vigar',
  'vigað',
  'vigið',
  'vigla',
  'vigli',
  'vikan',
  'vikar',
  'vikað',
  'vikin',
  'vikið',
  'vikna',
  'vikni',
  'viknu',
  'vikum',
  'vikur',
  'vilar',
  'vilað',
  'vildi',
  'vildu',
  'vilig',
  'vilið',
  'vilja',
  'vilji',
  'villa',
  'villi',
  'villu',
  'vilra',
  'vilst',
  'vilta',
  'vilti',
  'vilts',
  'viltu',
  'vilum',
  'vilva',
  'vilvi',
  'vimpa',
  'vimpi',
  'vimsa',
  'vimsi',
  'vinan',
  'vinar',
  'vinda',
  'vindi',
  'vinds',
  'vindu',
  'vingl',
  'vinin',
  'vinir',
  'vinka',
  'vinki',
  'vinks',
  'vinna',
  'vinni',
  'vinnu',
  'vinst',
  'vinum',
  'vinur',
  'vinýl',
  'viola',
  'violu',
  'vippa',
  'vippi',
  'vippu',
  'viral',
  'virda',
  'virdi',
  'virds',
  'virdu',
  'virka',
  'virki',
  'virkt',
  'virus',
  'virða',
  'virði',
  'visin',
  'visið',
  'viska',
  'viski',
  'visks',
  'visna',
  'visni',
  'visnu',
  'visra',
  'vissa',
  'vissi',
  'vissu',
  'vista',
  'visti',
  'vistu',
  'visum',
  'vital',
  'vitan',
  'vitar',
  'vitað',
  'vitig',
  'vitin',
  'vitið',
  'vitja',
  'vitji',
  'vitna',
  'vitni',
  'vitnu',
  'vitra',
  'vitri',
  'vitru',
  'vitug',
  'vitum',
  'vitur',
  'viðar',
  'viðað',
  'viðin',
  'viðið',
  'viðja',
  'viðju',
  'viðra',
  'viðri',
  'viður',
  'vióla',
  'vodka',
  'voffa',
  'voffi',
  'vogna',
  'vogni',
  'vogns',
  'vokal',
  'voksi',
  'volar',
  'volað',
  'volda',
  'voldi',
  'volds',
  'voldu',
  'volið',
  'volla',
  'volli',
  'volta',
  'volti',
  'volts',
  'volum',
  'vondu',
  'vongi',
  'vongs',
  'vonum',
  'vorið',
  'vorum',
  'vovin',
  'vovið',
  'vovna',
  'vovni',
  'vovnu',
  'vovva',
  'vovvi',
  'vraka',
  'vraki',
  'vraks',
  'vreið',
  'vrevl',
  'vriða',
  'vriði',
  'vráar',
  'vráin',
  'vráir',
  'vráum',
  'vrøvl',
  'vuksu',
  'vundu',
  'vunna',
  'vunni',
  'vunnu',
  'vurpu',
  'vurða',
  'vurði',
  'vágan',
  'vágin',
  'vágið',
  'vágna',
  'vágni',
  'vágnu',
  'vágur',
  'vákna',
  'vákni',
  'vákns',
  'válan',
  'válar',
  'válað',
  'válga',
  'válgi',
  'válgs',
  'válgt',
  'válgu',
  'válin',
  'válið',
  'válka',
  'válki',
  'válks',
  'válum',
  'válur',
  'vánda',
  'vándi',
  'vánds',
  'vándu',
  'vánir',
  'vánna',
  'vánni',
  'vánum',
  'vápna',
  'vápni',
  'vápns',
  'várar',
  'várað',
  'várir',
  'várið',
  'várum',
  'vásið',
  'vátan',
  'vátar',
  'vátir',
  'vátla',
  'vátli',
  'vátra',
  'vátta',
  'vátti',
  'vátum',
  'vátur',
  'váðan',
  'váðar',
  'váðin',
  'váðir',
  'váðum',
  'vælan',
  'vælar',
  'vældi',
  'vældu',
  'vælin',
  'vælir',
  'vælið',
  'vælst',
  'vælum',
  'vænar',
  'vænir',
  'vænra',
  'vænri',
  'vænru',
  'vænst',
  'vænta',
  'vænti',
  'væntu',
  'væris',
  'værið',
  'vætan',
  'vætin',
  'vætum',
  'vætur',
  'vídda',
  'vígda',
  'vígdi',
  'vígds',
  'vígdu',
  'víggi',
  'víggj',
  'vígir',
  'vígið',
  'vígst',
  'vígum',
  'víkar',
  'víkin',
  'víkir',
  'víkið',
  'víkja',
  'víkna',
  'víkni',
  'víknu',
  'víkst',
  'víkum',
  'víkur',
  'víkut',
  'vínið',
  'vípan',
  'vípum',
  'vípur',
  'vírik',
  'vísan',
  'vísar',
  'vísin',
  'vísir',
  'vísið',
  'vísra',
  'vísta',
  'vísti',
  'vísts',
  'vístu',
  'vísum',
  'vísur',
  'vívið',
  'vívum',
  'víðan',
  'víðar',
  'víðir',
  'víðka',
  'víðki',
  'víðum',
  'víður',
  'vógna',
  'vógni',
  'vónar',
  'vónað',
  'vónin',
  'vónir',
  'vónið',
  'vónum',
  'vórðu',
  'vødda',
  'vøddi',
  'vøgga',
  'vøggu',
  'vøkan',
  'vøkru',
  'vøkst',
  'vøktu',
  'vøkum',
  'vøkur',
  'vølan',
  'vølar',
  'vølað',
  'vølin',
  'vølir',
  'vølið',
  'vølli',
  'vølum',
  'vølur',
  'vølva',
  'vølvu',
  'vønum',
  'vøran',
  'vørin',
  'vørir',
  'vørla',
  'vørli',
  'vørmu',
  'vørpa',
  'vørpu',
  'vørra',
  'vørri',
  'vørta',
  'vørtu',
  'vørum',
  'vørur',
  'vørða',
  'vørði',
  'vørðu',
  'vøsan',
  'vøsar',
  'vøsað',
  'vøsið',
  'vøsku',
  'vøsum',
  'vøsut',
  'vøtti',
  'vøðum',
  'watta',
  'watti',
  'yddar',
  'yddað',
  'yddið',
  'ylast',
  'ylist',
  'yljið',
  'ylnar',
  'ylnað',
  'ylnið',
  'ymisk',
  'ymiss',
  'ymist',
  'ymjið',
  'ymsan',
  'ymsar',
  'ymsir',
  'ymsra',
  'ymsum',
  'yndar',
  'yndað',
  'yndig',
  'yndis',
  'yndið',
  'yndug',
  'yngda',
  'yngdi',
  'yngds',
  'yngdu',
  'yngir',
  'yngið',
  'yngja',
  'yngju',
  'yngla',
  'yngli',
  'yngra',
  'yngri',
  'yngru',
  'yngst',
  'yngul',
  'ynnar',
  'ynnað',
  'ynnir',
  'ynnið',
  'ynska',
  'ynski',
  'ynsks',
  'ynskt',
  'yntir',
  'yntið',
  'yogað',
  'yrkan',
  'yrkar',
  'yrkir',
  'yrkis',
  'yrkið',
  'yrkja',
  'yrkra',
  'yrkum',
  'yrkur',
  'ystan',
  'ystar',
  'ystir',
  'ystið',
  'ystra',
  'ystst',
  'ystum',
  'ystur',
  'ytsta',
  'ytsti',
  'ytsts',
  'ytstu',
  'yvara',
  'yvari',
  'yvaru',
  'yvast',
  'yviri',
  'yvrig',
  'yvris',
  'yvrið',
  'yðjan',
  'Ábala',
  'Ábali',
  'Ábals',
  'Ábram',
  'Ábria',
  'Ábriu',
  'Ádama',
  'Ádami',
  'Ádams',
  'Ákans',
  'Áland',
  'Ámund',
  'Ánias',
  'Ápram',
  'Árans',
  'Árant',
  'Árnan',
  'Árnin',
  'Árnur',
  'Árona',
  'Ároni',
  'Árons',
  'Ásans',
  'Ásara',
  'Ásari',
  'Ásars',
  'Ásdis',
  'Áskil',
  'Áslak',
  'Áslan',
  'Áslum',
  'Áslur',
  'Ásmóð',
  'Ástan',
  'Ástur',
  'Ásuna',
  'Ásuni',
  'Ásvar',
  'Ásvør',
  'Ávald',
  'Ímund',
  'Ísaka',
  'Ísaki',
  'Ísaks',
  'Íshav',
  'Ísmal',
  'Ívara',
  'Ívari',
  'Ívars',
  'Íðunn',
  'Óinar',
  'Óinin',
  'Óinum',
  'Ólans',
  'Ólava',
  'Ólavi',
  'Ólavs',
  'Óluva',
  'Óluvu',
  'Ómara',
  'Ómari',
  'Ómars',
  'Órans',
  'Óðina',
  'Óðini',
  'Óðins',
  'Økrum',
  'Øssur',
  'Úlvar',
  'Ýrina',
  'Ýrini',
  'áandi',
  'áanna',
  'ábata',
  'ábati',
  'ábekk',
  'ábeks',
  'ábera',
  'áberi',
  'ábita',
  'ábiti',
  'ábits',
  'ábrek',
  'áburð',
  'ábygd',
  'ábygt',
  'ábyrg',
  'ábæra',
  'ábæri',
  'ábærs',
  'ábært',
  'ábæru',
  'ábóta',
  'ádráp',
  'áfall',
  'áfals',
  'áfast',
  'áfløt',
  'áfoka',
  'áfoki',
  'áfoks',
  'áfram',
  'áføll',
  'áføst',
  'áfýsn',
  'ágang',
  'ágerð',
  'ágiti',
  'ágáva',
  'ágávu',
  'ágóða',
  'ágóði',
  'ágørn',
  'áhald',
  'áhuga',
  'áhugi',
  'ákall',
  'ákals',
  'ákast',
  'ákoma',
  'ákomu',
  'ákæra',
  'ákærd',
  'ákæri',
  'ákært',
  'ákæru',
  'ákøll',
  'ákøst',
  'álaga',
  'álagd',
  'álagi',
  'álags',
  'álagt',
  'álakk',
  'álaks',
  'álast',
  'álaða',
  'álaði',
  'álaðs',
  'álaðu',
  'álegg',
  'áleið',
  'álina',
  'áling',
  'álini',
  'álist',
  'álita',
  'áliti',
  'álits',
  'áljós',
  'álkan',
  'álkum',
  'álkur',
  'állan',
  'állar',
  'állin',
  'állum',
  'állur',
  'álman',
  'álmar',
  'álmin',
  'álmir',
  'álmum',
  'álmur',
  'álopa',
  'álopi',
  'álops',
  'áluta',
  'áluti',
  'áluts',
  'álutu',
  'álvan',
  'álvar',
  'álvin',
  'álvir',
  'álvið',
  'álvum',
  'álvur',
  'áláta',
  'áláti',
  'áláts',
  'álíka',
  'álíki',
  'álíks',
  'álíkt',
  'álíku',
  'áløga',
  'áløgd',
  'áløgu',
  'áminn',
  'ámint',
  'ámæli',
  'ámóta',
  'ámóti',
  'ámóts',
  'ánara',
  'ánari',
  'ánaða',
  'ánaði',
  'ánaðs',
  'ánaðu',
  'ánina',
  'áning',
  'ánini',
  'ánáma',
  'ánámi',
  'ánáms',
  'ánæmi',
  'áogna',
  'áraka',
  'árbók',
  'árend',
  'árina',
  'áring',
  'árini',
  'árins',
  'árita',
  'áriti',
  'árits',
  'árlað',
  'árlig',
  'árnar',
  'árnað',
  'árnið',
  'árnum',
  'árund',
  'árunt',
  'árása',
  'áræði',
  'áróna',
  'áróni',
  'árónu',
  'árødd',
  'árøds',
  'árøtt',
  'ásaka',
  'ásaki',
  'ásamt',
  'áseta',
  'áseti',
  'ásets',
  'ásett',
  'ásetu',
  'áseyð',
  'ásian',
  'ásina',
  'ásini',
  'ásins',
  'ásium',
  'ásiur',
  'ásjón',
  'áskot',
  'áslag',
  'ásløg',
  'ásnum',
  'ástar',
  'ástað',
  'ástig',
  'ástin',
  'ástir',
  'ástum',
  'ásýna',
  'ásýnd',
  'ásýni',
  'ásýns',
  'ásýnt',
  'ásýnu',
  'átaka',
  'átaki',
  'átaks',
  'átala',
  'átali',
  'átalu',
  'átara',
  'átari',
  'átbær',
  'átiga',
  'átigi',
  'átigs',
  'átigt',
  'átigu',
  'átjan',
  'átrúa',
  'áttan',
  'áttar',
  'áttir',
  'áttum',
  'áttur',
  'átuna',
  'átuni',
  'átuta',
  'átuti',
  'átuts',
  'átutu',
  'átóku',
  'átøka',
  'átøki',
  'átøkk',
  'átøks',
  'átøkt',
  'átøku',
  'áunum',
  'ávara',
  'ávari',
  'áverk',
  'ávika',
  'áviki',
  'áviks',
  'ávísa',
  'ávísi',
  'ávíst',
  'ávísu',
  'ávøga',
  'ávøgu',
  'ælaði',
  'ælaðu',
  'æling',
  'ælini',
  'ælnám',
  'ærast',
  'æraða',
  'æraði',
  'æraðs',
  'æraðu',
  'ærdan',
  'ærdar',
  'ærdir',
  'ærdum',
  'ærdur',
  'ærgir',
  'ærgis',
  'ærgið',
  'ærgja',
  'ærina',
  'ærini',
  'ærist',
  'ærlig',
  'ærnar',
  'ærnum',
  'ærull',
  'æruna',
  'æruni',
  'æruta',
  'æruti',
  'æruts',
  'ærutu',
  'æsina',
  'æsing',
  'æsini',
  'æsuna',
  'æsuni',
  'ætlan',
  'ætlar',
  'ætlað',
  'ætlið',
  'ætlum',
  'ættar',
  'ættað',
  'ættin',
  'ættir',
  'ættið',
  'ættum',
  'æviga',
  'ævigi',
  'ævigs',
  'ævigt',
  'ævigu',
  'ævina',
  'ævini',
  'ævuga',
  'ævugi',
  'ævugs',
  'ævugt',
  'ævugu',
  'æðrar',
  'æðrin',
  'æðrum',
  'æðuna',
  'æðuni',
  'æðuta',
  'æðuti',
  'æðuts',
  'æðutu',
  'íandi',
  'íbirt',
  'íbláa',
  'íblái',
  'íblás',
  'íbláu',
  'íbygd',
  'íbygt',
  'íbúða',
  'ídnan',
  'ídnar',
  'ídnað',
  'ídnir',
  'ídnis',
  'ídnið',
  'ídnum',
  'íelvi',
  'íferð',
  'ígakk',
  'ígang',
  'ígekk',
  'ígera',
  'ígeri',
  'ígert',
  'ígerð',
  'ígrøn',
  'ígula',
  'íguli',
  'íguls',
  'ígult',
  'ígulu',
  'ígðan',
  'ígðum',
  'ígður',
  'íhald',
  'íhava',
  'íhavi',
  'íhavs',
  'íhavt',
  'íhylk',
  'íkast',
  'íklæð',
  'íkoma',
  'íkomu',
  'ílaga',
  'ílagi',
  'ílags',
  'ílagt',
  'ílans',
  'ílata',
  'ílati',
  'ílats',
  'ílega',
  'ílegg',
  'ílegs',
  'ílegu',
  'íleik',
  'íleið',
  'ílend',
  'ílent',
  'ílopa',
  'ílopi',
  'ílops',
  'íláta',
  'íláti',
  'íláts',
  'ílæts',
  'ílætt',
  'ílíki',
  'íløga',
  'íløgd',
  'íløgu',
  'íløtt',
  'ímaða',
  'ímaði',
  'ímaðs',
  'ímaðu',
  'ímerk',
  'ímgrá',
  'ímint',
  'ímuta',
  'ímuti',
  'ímuts',
  'ímutu',
  'ímynd',
  'ímóti',
  'ípota',
  'ípoti',
  'ípots',
  'írans',
  'írast',
  'írevl',
  'íreyð',
  'írist',
  'íriva',
  'írivi',
  'írivs',
  'írska',
  'írski',
  'írsks',
  'írskt',
  'írsku',
  'ísara',
  'ísari',
  'ísast',
  'ísaða',
  'ísaði',
  'ísaðs',
  'ísaðu',
  'ísets',
  'ísett',
  'ísfon',
  'ísfrí',
  'íshús',
  'ísing',
  'ísins',
  'ísist',
  'íslit',
  'ísnar',
  'ísnað',
  'ísnið',
  'ísnám',
  'ísoga',
  'ísogu',
  'ísopp',
  'ísops',
  'ístig',
  'ístra',
  'ístri',
  'ístur',
  'ístíð',
  'ísáar',
  'ísáað',
  'ísádd',
  'ísáds',
  'ísáið',
  'ísára',
  'ísári',
  'ísárs',
  'ísátt',
  'ísáði',
  'ísáðs',
  'ísøld',
  'ítaka',
  'ítaki',
  'ítaks',
  'ítara',
  'ítari',
  'ítaru',
  'ítast',
  'ítriv',
  'ítøka',
  'ítøki',
  'ítøks',
  'ítøkt',
  'ítøku',
  'ívera',
  'íveru',
  'ívist',
  'íðins',
  'íðkan',
  'íðkar',
  'íðkað',
  'íðkið',
  'íðuna',
  'íðuni',
  'óbata',
  'óbati',
  'óbein',
  'óbend',
  'óbent',
  'óblíð',
  'óburð',
  'óbygd',
  'óbygt',
  'óbúna',
  'óbúni',
  'óbúnu',
  'óbýla',
  'óbýli',
  'óbýts',
  'óbýtt',
  'ódaga',
  'ódagi',
  'ódags',
  'ódegi',
  'ódjór',
  'ódlig',
  'ódnar',
  'ódnað',
  'ódnin',
  'ódnir',
  'ódnið',
  'ódnum',
  'ódnur',
  'óduld',
  'ódult',
  'ódygd',
  'ódygg',
  'ódygs',
  'ódygt',
  'ódámi',
  'ódáms',
  'ódáða',
  'ódæla',
  'ódæli',
  'ódæll',
  'ódæls',
  'ódælt',
  'ódælu',
  'ódøma',
  'ódømi',
  'ódýra',
  'ódýri',
  'ódýrs',
  'ódýrt',
  'ódýru',
  'óegnd',
  'óegnt',
  'óella',
  'óellu',
  'óerla',
  'óerlu',
  'óetin',
  'óetið',
  'óetna',
  'óetni',
  'óetnu',
  'ófant',
  'ófast',
  'ófeig',
  'óferi',
  'óferð',
  'ófest',
  'ófima',
  'ófimi',
  'ófims',
  'ófimt',
  'ófimu',
  'ófits',
  'ófitt',
  'ófrið',
  'ófría',
  'ófríi',
  'ófrís',
  'ófríu',
  'ófríð',
  'ófylt',
  'ófína',
  'ófíni',
  'ófíns',
  'ófínt',
  'ófínu',
  'ófødd',
  'óføds',
  'óføra',
  'óføri',
  'óførs',
  'óført',
  'óføru',
  'óføst',
  'óføtt',
  'ófúsa',
  'ófúsi',
  'ófúst',
  'ófúsu',
  'ófýsa',
  'ófýsi',
  'ógagn',
  'ógerð',
  'ógift',
  'ógild',
  'ógilt',
  'ógits',
  'ógitt',
  'óglað',
  'óglær',
  'ógvar',
  'ógvað',
  'ógvið',
  'ógvár',
  'ógáin',
  'ógáið',
  'ógána',
  'ógáni',
  'ógánu',
  'ógæva',
  'ógævu',
  'óhaga',
  'óhagi',
  'óhags',
  'óhagt',
  'óhagu',
  'óhapp',
  'óhaps',
  'óheft',
  'óheil',
  'óheld',
  'óhent',
  'óherd',
  'óhert',
  'óhuga',
  'óhugi',
  'óhugs',
  'óhærd',
  'óhært',
  'óhógv',
  'óhóvs',
  'óhøga',
  'óhøgi',
  'óhøgu',
  'óhøpp',
  'óivað',
  'ójøvn',
  'ókend',
  'ókent',
  'ókkan',
  'ókkum',
  'ókkur',
  'óklár',
  'óklók',
  'ókrút',
  'ókunn',
  'ókuns',
  'ókunt',
  'ókust',
  'ókyrr',
  'ókyrs',
  'ókyrt',
  'ókáta',
  'ókáti',
  'ókáts',
  'ókátt',
  'ókátu',
  'ókøna',
  'ókøni',
  'ókøns',
  'ókønt',
  'ókønu',
  'ólagi',
  'ólags',
  'ólits',
  'ólitt',
  'óljóð',
  'ólust',
  'ólærd',
  'ólært',
  'ólæst',
  'ólæta',
  'ólæti',
  'ólíka',
  'ólíki',
  'ólíks',
  'ólíkt',
  'ólíku',
  'ólóta',
  'ólødd',
  'óløds',
  'óløga',
  'óløgi',
  'óløgs',
  'ólønt',
  'óløst',
  'óløtt',
  'ólúna',
  'ólúni',
  'ólúnu',
  'ómaga',
  'ómagi',
  'ómaka',
  'ómaki',
  'ómaks',
  'ómegd',
  'ómegi',
  'ómegn',
  'ómild',
  'ómilt',
  'ómint',
  'ómála',
  'ómáli',
  'ómælt',
  'ómótt',
  'ómóða',
  'ómóði',
  'ómóðs',
  'ómóðu',
  'óndan',
  'óndar',
  'óndir',
  'óndra',
  'óndum',
  'óndur',
  'óneyv',
  'ónira',
  'óniri',
  'óniru',
  'ónáða',
  'ónáði',
  'ónæra',
  'ónæru',
  'ónøgd',
  'ónøgt',
  'ónýta',
  'ónýti',
  'ónýts',
  'ónýtt',
  'ónýtu',
  'óorða',
  'óorði',
  'óorðs',
  'órein',
  'órina',
  'órini',
  'órins',
  'órinu',
  'órudd',
  'óruds',
  'órund',
  'órunt',
  'órusl',
  'órádd',
  'óráds',
  'órátt',
  'óráða',
  'órædd',
  'óræds',
  'óræts',
  'órætt',
  'órína',
  'óríni',
  'óróar',
  'órógv',
  'óróin',
  'óróna',
  'óróni',
  'órónu',
  'órótt',
  'órødd',
  'órøki',
  'órøkt',
  'órørd',
  'órørt',
  'órøtt',
  'órúma',
  'órúmi',
  'órúms',
  'ósagt',
  'ósalt',
  'ósama',
  'ósamd',
  'ósami',
  'ósamt',
  'ósans',
  'ósatt',
  'óseka',
  'óseki',
  'óseks',
  'ósekt',
  'óseku',
  'óseld',
  'óselt',
  'ósemd',
  'ósemi',
  'ósiða',
  'ósiði',
  'ósjón',
  'óskil',
  'ósonn',
  'óstra',
  'óstri',
  'óstur',
  'óstøk',
  'ósunn',
  'ósuns',
  'ósunt',
  'ósádd',
  'ósáds',
  'ósáts',
  'ósátt',
  'ósædd',
  'ósæds',
  'ósærd',
  'ósært',
  'ósætt',
  'ósóma',
  'ósómi',
  'ósøgd',
  'ósøkt',
  'ósølt',
  'ósømd',
  'ósýnd',
  'ósýni',
  'ósýnt',
  'ótald',
  'ótali',
  'ótals',
  'ótalt',
  'ótamd',
  'ótamt',
  'ótent',
  'ótoli',
  'ótols',
  'ótrús',
  'óttan',
  'óttar',
  'óttað',
  'óttin',
  'óttið',
  'ótugd',
  'ótugt',
  'ótust',
  'ótynt',
  'ótyst',
  'ótæts',
  'ótætt',
  'ótódn',
  'ótøka',
  'ótøki',
  'ótøkk',
  'ótøks',
  'ótøkt',
  'ótøku',
  'ótørv',
  'ótøta',
  'ótøti',
  'ótøtt',
  'ótøvd',
  'ótøvt',
  'ótýtt',
  'ótýða',
  'ótýði',
  'ótýðs',
  'ótýðu',
  'óvana',
  'óvand',
  'óvani',
  'óvans',
  'óvant',
  'óvard',
  'óvart',
  'óvelt',
  'óvild',
  'óvina',
  'óvini',
  'óviss',
  'óvist',
  'óvita',
  'óviti',
  'óvits',
  'óvonu',
  'óvígd',
  'óvígt',
  'óvísa',
  'óvísi',
  'óvíst',
  'óvísu',
  'óárið',
  'óárum',
  'óátan',
  'óátið',
  'óæran',
  'óærut',
  'óætan',
  'óætis',
  'óætið',
  'óðali',
  'óðals',
  'óðara',
  'óðari',
  'óðaru',
  'óðast',
  'óðaða',
  'óðaði',
  'óðaðs',
  'óðaðu',
  'øddan',
  'øddar',
  'øddir',
  'øddum',
  'øddur',
  'ødlan',
  'ødlum',
  'ødlur',
  'øgast',
  'øgils',
  'øgist',
  'øglar',
  'øglum',
  'øgnin',
  'øgnum',
  'øgnut',
  'øguls',
  'økils',
  'øking',
  'økini',
  'økist',
  'økjum',
  'øklar',
  'øklum',
  'øknar',
  'øknin',
  'øknir',
  'øknum',
  'øksan',
  'øksar',
  'øksin',
  'øksir',
  'øksla',
  'øksli',
  'øksls',
  'øksul',
  'øksum',
  'øksur',
  'øktan',
  'øktar',
  'øktin',
  'øktir',
  'øktum',
  'øktur',
  'økuls',
  'økuna',
  'økuni',
  'ølaða',
  'ølaði',
  'ølaðs',
  'ølaðu',
  'ølbúk',
  'øldin',
  'øldir',
  'øldum',
  'øldós',
  'ølger',
  'ølina',
  'ølini',
  'ølkík',
  'øllum',
  'øltos',
  'ølvan',
  'ølvum',
  'ølvur',
  'ølvær',
  'ølótt',
  'ølóða',
  'ølóði',
  'ølóðs',
  'ølóðu',
  'ønara',
  'ønari',
  'ønina',
  'øning',
  'ønini',
  'ønnur',
  'øntir',
  'øntið',
  'ønuta',
  'ønuti',
  'ønuts',
  'ønutu',
  'ørara',
  'ørari',
  'øraru',
  'ørast',
  'øraði',
  'øraðu',
  'ørfín',
  'ørgan',
  'ørgum',
  'ørgur',
  'ørgut',
  'ørini',
  'ørins',
  'ørist',
  'ørkin',
  'ørkum',
  'ørlig',
  'ørmum',
  'ørnan',
  'ørnar',
  'ørnin',
  'ørnir',
  'ørnum',
  'ørsið',
  'ørska',
  'ørsku',
  'ørsmá',
  'ørsum',
  'ørval',
  'ørvar',
  'ørvin',
  'ørvum',
  'ørvur',
  'ørðug',
  'ørðut',
  'øsast',
  'øsaði',
  'øsaðu',
  'øsina',
  'øsing',
  'øsini',
  'øsist',
  'øskan',
  'øskra',
  'øskri',
  'øsnan',
  'øsnar',
  'øsnað',
  'øsnið',
  'øsnum',
  'øsnur',
  'øsnut',
  'øspin',
  'øspum',
  'østan',
  'østar',
  'østir',
  'østra',
  'østum',
  'østur',
  'øtana',
  'øtast',
  'øtini',
  'øtist',
  'øtlar',
  'øtlað',
  'øtlið',
  'øvaða',
  'øvaði',
  'øvaðs',
  'øvaðu',
  'øviga',
  'øvigi',
  'øvigs',
  'øvigt',
  'øvigu',
  'øving',
  'øvuga',
  'øvugi',
  'øvugs',
  'øvugt',
  'øvugu',
  'øvund',
  'øvuta',
  'øvuti',
  'øvuts',
  'øvutu',
  'øðast',
  'øðina',
  'øðini',
  'øðist',
  'øðrum',
  'øðuna',
  'øðuni',
  'úldan',
  'úldar',
  'úldað',
  'úldir',
  'úldið',
  'úldna',
  'úldni',
  'úldra',
  'úldum',
  'úldur',
  'úlmar',
  'úlmað',
  'úlmið',
  'úlpan',
  'úlpum',
  'úlpur',
  'úluna',
  'úluni',
  'úlvin',
  'úlvsa',
  'úlvsi',
  'úlvum',
  'úlvur',
  'úraði',
  'úraðu',
  'úrlop',
  'úrlík',
  'úrløð',
  'úrnýt',
  'úrráð',
  'úrsýn',
  'úrtak',
  'úrtíð',
  'úrtøk',
  'úrval',
  'útblá',
  'útboð',
  'útbúð',
  'útbýa',
  'útbýi',
  'útbýr',
  'útdyr',
  'úteld',
  'útelt',
  'útfit',
  'útfrá',
  'útgav',
  'útgev',
  'útham',
  'úthav',
  'úthug',
  'úthøv',
  'úthús',
  'útibú',
  'útinn',
  'útint',
  'útkom',
  'útlat',
  'útlim',
  'útlit',
  'útlið',
  'útlop',
  'útlán',
  'útlát',
  'útlæg',
  'útlæt',
  'útmat',
  'útmið',
  'útnes',
  'útoya',
  'útrak',
  'útras',
  'útriv',
  'útrun',
  'útrák',
  'útrøs',
  'útset',
  'útsig',
  'útsúg',
  'úttak',
  'úttrá',
  'úttøk',
  'úttýð',
  'útval',
  'útveg',
  'útvið',
  'útása',
  'útætt',
  'ýandi',
  'ýling',
  'ýlini',
  'ýsopi',
  'ýsops',
  'ýtini',
  'ýtuna',
  'ýtuni',
  'ývins',
  'ývnan',
  'ývnar',
  'ývnað',
  'ývnir',
  'ývnið',
  'ývnum',
];
